import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import axios from "axios";

import GameConnections from "../../io/GameConnections";
import {
  CALL_ACTION,
  CHECK_ACTION,
  CHECK_GAME_API,
  CHECK_GAME_API_READY_TO_REQUEST,
  CHECK_GAME_API_RESPONSE_SUCCESS,
  EXIT_TABLE_ACK_SUCCESS,
  GAME_JOIN_API_READY_TO_REQUEST,
  FOLD_ACTION,
  GAME_STAGE_FLOP,
  GAME_STAGE_PRE_FLOP,
  GAME_STAGE_RIVER,
  GAME_STAGE_TURN,
  MATCH_MAKING_API,
  MATCH_MAKING_API_READY_TO_REQUEST,
  MATCH_MAKING_API_REQUEST_REJECTED,
  RAISE_ACTION,
  GAME_JOIN_API_RESPONSE_FAILURE,
  SEATED_OUT,
  GAME_STAGE_SHOWDOWN,
  FOLD_SOUND,
  CHECK_SOUND,
  CALL_SOUND,
  RAISE_SOUND,
  TURN_SOUND,
  WINNER_SOUND,
  BUTTON_SOUND,
  VIBRATE_LIGHT,
  VIBRATE_HEAVY,
  ACTIVE,
  WAITING_FOR_BB,
  PLAYER_DEFAULT_TIMER,
  PLAYER_EXTRA_TIMER,
  IS_SOUND_ENABLED,
  IS_HAPTICS_EBABLED,
  REBUY_INSUFFICIENT_FUNDS,
  REBUY_OTHER,
  ALL_IN,
  GAME_CONNECTION_PROTOCOL_SUCCESS,
  MATCH_MAKING_API_RESPONSE_SUCCESS,
  CHECK_GAME_API_REQUEST_REJECTED,
  GAME_SOCKET_TIMEOUT,
  RESPONSE_KEY_NAME,
  REJECTED_KEY_NAME,
  RESPONSE_CODE_KEY_NAME,
  IN_ACTIVE,
  AUTO_CALL_ACTION,
  AUTO_CALL_ANY_ACTION,
  AUTO_CHECK_ACTION,
  AUTO_CHECK_OR_FOLD_ACTION,
  AUTO_FOLD_ACTION,
  INITIATE_LACK_GAME_CONNECTION,
  TOAST_WARNING,
  TOAST_SUCCESS,
  TOAST_ERROR,
  TOAST_INFO,
  TEXAS_COMMUNITY_CARDS_NUMBER,
  PORTRAIT,
  LANDSCAPE,
  DISCONNECTION,
  INITIATE_TOURNEY_GAME_CONNECTION,
  INITIATE_TOURNEY_GAME_RECONNECTION,
  TOURNEY_GAME_RECONNECTION_STATE,
  TOURNEY_GAME_CONNECTION_STATE,
  LEAVE_SEAT_ACK_PROCESSING,
  LEAVE_SEAT_ACK_SUCCESS,
  LEAVE_SEAT_ACK_REQUEST_ALREADY_SENT,
  OMAHA,
  OMAHA5,
  BUY_IN,
  MAX_CARD_WIDTH,
  INSUFFICIENT_BALANCE,
  TOURNEY_BANNER_BLINDS_UP,
  TOURNEY_BANNER_BREAK_TIME,
  TOURNEY_BANNER_BREAK_WAITING_FOR_OTHER_TABLES,
  GAME_LOOSER_MODAL,
  TOURNEY_GAME_WINNER_MODAL,
  DISCONNECTION_TIMER,
  PLAYER_STATS,
  LB_PLAY,
  INSUFFICIENT_FUN_CHIPS_BALANCE,
  TOURNEY_REBUYIN_WITH_DOUBLE_REBUY,
  TOURNEY_BANNER_WAITING_FOR_REBUYS,
  CARD_SIZE_MEDIUM,
  AUTO_CHECK,
  AUTO_FOLD,
  MATCH_MAKING_BET_DISABLED,
  TOURNEY_ADDON,
  LB_REAL,
  TOURNEY_BANNER_MERGED_WITH_ANOTHER_TABLE,
  TOURNEY_BANNER_NODE_SWITCH,
  TOURNEY_BANNER_IN_WINNING_POSITIONS,
  DELETED_PLAYER,
  TO_BE_DELETED_PLAYER,
  DELETED_PLAYER_LOGOUT,
  ACCOUNT_ISSUE_GAME_JOIN,
  WALLET_BALANCE_ISSUE_GAME_JOIN,
  DATA_LOST_ISSUE_GAME_JOIN,
  RESTRICTED_LOCATION_GAME_EXIT,
  TOURNEY_BANNER_MERGE_WAIT_MESSAGE,
  TOURNEY_TABLE_MERGE_BANNER_DELAY,
  TOURNEY_BANNER_ADDON_BREAK_WAITING_FOR_OTHER_TABLES,
  DEAL_SOUND,
  JOIN_FAILURE_ACCOUNT_DELETED,
  RELOGIN_FAILURE,
  RESTRICTED_LOCATION_HOURS,
  PRIVATE_TABLE,
  PRIVATE_TABLE_ADD_ANNOUNCEMENT,
  PRIVATE_TABLE_ANNOUNCEMENT_BROADCAST_CLOSE_DURATION,
  END_PRIVATE_TABLE,
  TERMINATE_PRIVATE_TABLE,
  TERMINATE_PRIVATE_TABLE_REQUEST_ALREADY_SENT,
  TERMINATE_PRIVATE_TABLE_REQUEST_PROCESSED,
  TOURNEY_BANNER_BLINDS_UP_FINAL_LEVEL,
  OMAHA6,
  PRIVATE_TABLE_HOST_NOT_ALLOWED,
  LOCKED_BET,
  TOURNEY_BANNER_ITM_AND_FINAL_BUBBLE,
  TOURNEY_BANNER_HAND_TO_HAND_FINAL_TABLE_BUBBLE,
  TOURNEY_BANNER_IN_THE_MONEY_BUBBLE,
  WAITLIST_ACCEPTED,
  WAITLIST_REJECTED,
  TIMER_REMOVED,
  TIME_RUNNING,
  EMOJI_SIZE,
  RUPEE_SYMBOL,
  DEAL_MAKING_DONE,
  DEAL_OPTED_IN,
  DEAL_OPTED_OUT,
  DEAL_PLAYER_NOT_SEATED,
  DEAL_INVALID_REQUEST_DATA,
  TOURNEY_IN_DEAL,
  DEAL_MAKING_TIMER_NOT_FOUND,
  DEAL_ALREADY_OPTED_IN,
  DEAL_ALREADY_OPTED_OUT,
  NOT_DEAL_PARTICIPANT,
  TOURNEY_DEAL_UNSUCCESSFUL,
} from "../../data/Constants";
import MessageToServer from "../services/MessageToServerCalls";
import {
  checkToDisplayValueInK,
  checkToDisplayValueInL,
  doesExist,
  getHandType,
  parseDecimalValuesOfNumber,
} from "../../../Common/utils/GameUtils";
import GameAudio from "../../audio/GameAudio";
import {
  getFromLocalStorage,
  setToLocalStorage,
} from "../../../Common/utils/StorageUtils";
import { getCardWidthAndHeight } from "../../../Common/utils/ResponsiveStyle";
import GameListenerN from "../../io/GameListenerN";
import GameConnectionsN from "../../io/GameConnectionsN";
import TableUtils from "../../utils/TableUtils";
import {
  getMLTLogFormat,
  sendCancelSitOutProtocol,
  sendNextGameProtocol,
  sendRefreshProtocol,
  sendShowCardsData,
  sendSitInProtocol,
  sendSitOutProtocol,
} from "../../utils/ProtocolUtils";
import { sendFaroLog } from "../../../Common/utils/FaroUtil";
import TimerObserver from "../../../Common/utils/TablesObserver";
import LobbyConnection from "../../io/LobbyConnection";
import {
  generateUniqueId,
  returnGameTypeText,
} from "../../../Common/utils/PokerUtils";

import { getTimerWorkerInstance } from "@/src/workers/timerWorkerInstance";

export const fetchMatchMakingDetails = createAsyncThunk(
  "/gameTableSlice/matchMakingDetails",
  async (requestDetails, { rejectWithValue }) => {
    console.log("In Fetch Making call");
    console.log("match making API URL: ", requestDetails.apiMatchMakingURL);
    console.log("Data object: ", requestDetails.dataObject);
    console.log(requestDetails);
    sendFaroLog({
      requestType: "MATCH_MAKING_INITIATE",
      requestPayload: requestDetails,
    });
    try {
      let response = await axios.post(
        requestDetails.apiMatchMakingURL,
        requestDetails.dataObject
      );
      response.tempTableId = requestDetails.tempTableId;
      return response;
    } catch (error) {
      return rejectWithValue(requestDetails.tempTableId, error);
    }
  }
);

export const fetchCheckGameDetails = createAsyncThunk(
  "/gameTableSlice/checkGameDetails",
  async (requestDetails, { rejectWithValue }) => {
    console.log("match making API URL: ", requestDetails.apiCheckGameURL);
    console.log("Data object: ", requestDetails.dataObject);
    sendFaroLog({
      requestType: "CHECK_GAME_INITIATE",
      requestPayload: requestDetails,
    });
    try {
      let response = await axios.post(
        requestDetails.apiCheckGameURL,
        requestDetails.dataObject
      );
      response.tempTableId = requestDetails.tempTableId;
      console.log("Response from check game server: ", response);
      return response;
    } catch (error) {
      return rejectWithValue(requestDetails.tempTableId, error);
    }
  }
);

function checkIfIsPlayerTurnOnAnyTable(state) {
  // Below is the code to flag if the user is active on ANY table. This flag can be used in lobby to know if he is active on ATLEAST 1 table.
  let tempTableIds = Object.keys(state.games);
  for (let i = 0; i < tempTableIds.length; i++) {
    let tempTableId = tempTableIds[i];
    if (
      state.games[tempTableId].playerTurn ===
      state.games[tempTableId].playerSeat
    ) {
      state.isPlayerTurnOnAnyTable = true;
      break;
    } else {
      state.isPlayerTurnOnAnyTable = false;
    }
  }
}

function processCreateTableData(state, action) {
  const {
    tempTableId,
    gameDefinition,
    lackGameId,
    lackTableId,
    awsalbcookie,
    gameEndpoint,
    isTourneyGame,
    isTourneyLackGame,
    watchPlayer,
    isPrivateTable,
    manualTableId,
    joinType,
    isTableListingEnabled,
  } = action.payload;
  console.log("Game Definition: ", gameDefinition);
  console.log("Type of max players: ", typeof gameDefinition.maxPlayers);

  let isGameAlreadyExistWithId = false;

  //temporary check
  Object.keys(state.games).forEach((eachTempTableId) => {
    if (!isGameAlreadyExistWithId) {
      let loopTableId = state.games[eachTempTableId].tableId;
      if (isTourneyGame) {
        isGameAlreadyExistWithId =
          state.games[eachTempTableId].gameDefinition.tourneyId ===
          gameDefinition.tourneyId && loopTableId === lackTableId;
      } else if (loopTableId && loopTableId === lackTableId) {
        console.log("TABLE ID MATCHED: ", loopTableId, lackTableId);
        isGameAlreadyExistWithId = true;
      }
    }
  });

  console.log(
    "isGameAlreadyExistWithId ",
    isGameAlreadyExistWithId,
    "temp table id: ",
    tempTableId
  );

  if (!isGameAlreadyExistWithId) {
    let newGameTable = {
      gameId: lackGameId,
      joinType: joinType,
      tableId: lackTableId ? lackTableId : manualTableId ? manualTableId : null,
      tempTableId: tempTableId,
      gameDefinition: gameDefinition,
      //below should be little fine tuned with respect to tourney @yashwanth
      gameAPIState: isTourneyGame
        ? TOURNEY_GAME_CONNECTION_STATE
        : lackGameId
          ? CHECK_GAME_API
          : MATCH_MAKING_API,
      gameConnectionStatus: isTourneyGame
        ? INITIATE_TOURNEY_GAME_CONNECTION
        : lackGameId
          ? INITIATE_LACK_GAME_CONNECTION
          : MATCH_MAKING_API_READY_TO_REQUEST,
      apiMatchMakingURL:
        joinType === "NA"
          ? import.meta.env.VITE_REACT_APP_MANUAL_MATCH_MAKING_API_URL
          : import.meta.env.VITE_REACT_APP_AUTO_MATCH_MAKING_API_URL,
      gameEnded: false,
      apiMatchMakingTimeLogsArray: [],
      apiCheckGameURL: import.meta.env.VITE_REACT_APP_CHECK_GAME_API_URL,
      apiCheckGameTimeLogsArray: [],
      gameEndpoint: gameEndpoint ? gameEndpoint : undefined,
      isConnectionAckReceivedOnce: false,
      isLackGame: isTourneyGame ? isTourneyLackGame : lackGameId ? true : false,
      awsalbcookie: lackTableId ? awsalbcookie : "",
      isDisconnected: false,
      isReconnected: false,
      totalPlayersConfig: isTourneyGame
        ? gameDefinition.playersPerTable
        : gameDefinition.maxPlayers,
      watchPlayer: watchPlayer,
      playerCards: [],
      gameStage: GAME_STAGE_PRE_FLOP,
      communityCards: [],
      RITCommunityCards: [],
      shownCards: [],
      isUserWinner: true,
      showAllCards: false,
      isRITEnabled: false,
      RITRequest: false,
      RITRequestDuration: 0,
      RITRequestEndTime: null,
      showCommunityCardsImmediately: false,
      multiPotAmounts: [],
      tableNumber: 0,
      playerData: [],
      playerMovedToCenter: false,
      setBuyInValueForPlayerPosition: undefined,
      playerSeat: undefined,
      playerStatus: undefined,
      playerTurn: undefined,
      autoAction: undefined,
      sitOutOption: false,
      playerSitOutTimer: false,
      openBuyInModal: false,
      openRebuyInModal: false,
      openInSufficientFundsModal: false,
      openTopupModal: false,
      buyInTimeInSeconds: 0,
      playerTimer: -1,
      gameTableDimensions: {},
      positionsArranged: false,
      playerPositions: [],
      totalPotAmt: undefined,
      close: false,
      toastMessages: [],
      showAutoActions: false,
      showDefaultActions: false,
      disableDefaultActions: false,
      disableAutoActions: false,
      minRaiseAmount: 0,
      maxRaiseAmount: 0,
      autoCall: false,
      autoCallAny: false,
      autoCheckOrFold: false,
      autoCheck: false,
      fold: false,
      communityCardPositon: [],
      restrictUserFromLeavingTable: false,
      restrictUserFromSitOut: false,
      clearCommunityCardsOnTable: false,
      isWaitingForBigBlind: false,
      joinFailureFlag: false,
      topUpPending: false,
      startWinnerPotAnimation: false,
      showReleaseToFoldAlert: false,
      processingDReserve: false,
      processingReserve: { status: false, position: undefined },
      tableStats: [],
      showRabbitHuntingCards: false,
      showStartGameTimer: false,
      doCommunityCardsExist: false,
      sitOutButtonDisabled: false,
      disableOrientationChange: false,
      revealCards: false,
      playerSeatBeforeLeaveSeat: undefined,
      isTableListingEnabled: isTableListingEnabled,

      gameModal: {
        type: null,
        config: null,
        visible: false,
      },
      isTourneyGame: isTourneyGame ? isTourneyGame : false,
      tourneyAutoPlay: false,
      isTourneyNodeSwitch: false,
      isFunGame: isTourneyGame
        ? false
        : gameDefinition?.flavourType?.toLowerCase() === LB_PLAY,
      tourneyBlindsUpDetails: null,
      tourneyGameBreakBroadcast: null,
      tourneyNextLevelUpDetails: null,
      activeTourneyBannerType: null,
      tourneyPrizeDetails: null,
      tourneyRebuyInDetails: null,
      isTourneyRebuyRequestLoading: false,
      tourneyAddOnDetails: null,
      isTourneyAddOnRequestInProgress: false,
      isTourneyRankingLeaderboardRequestInProgress: true,
      tourneyRankingLeaderboardDetails: null,
      tourneyPlayerRankDetails: null,
      tourneyGameCompleted: false,
      showHappyHoursToast: false,
      antiBanking: {
        antiBankAmount: 0,
        isAntiBank: false,
      },
      isComplainceBlocked: false,
      privateTable: {
        isPrivateTable: isPrivateTable,
        hideStartGameButton: gameDefinition?.autoStart,
        showAutoStartMessage: true,
        showMinPlayersJoinMessage: true,
        openHostControlSlider: true,
      },
      clickedFavToggle: false,
      watchTable: {
        timer: 0,
        status: null,
        hideTimer: false,
        closeSocket: false,
      },
      dealObject: {
        dealStarted: false,
        dealOpted: false,
        pendingAck: false,
        optedCount: 0,
        currentPlayerCount: 0,
        dealOptedPlayers: [],
      },
      dealICMObject: {
        dealICMData: {},
        dealICMRunTime: 0,
        pendingAck: false,
        winnersDetails: {},
      },
      showDealICMPayoutDistribution: false,
      showDealConclusionPopup: false,
      throwables: [
        // {
        //   uid: generateUniqueId(),
        //   throwableId: "queen10",
        //   sourceCoordinates: {
        //     x: 200,
        //     y: 700,
        //   },
        //   targetCoordinates: {
        //     x: 320,
        //     y: 180,
        //   },
        //   duration: 0.6,
        //   loop: false,
        // },
        // {
        //   uid: generateUniqueId(),
        //   throwableId: "queen1",
        //   sourceCoordinates: {
        //     x: 200,
        //     y: 700,
        //   },
        //   targetCoordinates: {
        //     x: 120,
        //     y: 180,
        //   },
        //   duration: 0.8,
        //   loop: false,
        // },
      ],
      // dummy values added by Yashwanth -- will be removed by Spruha
      // openTourneyWinnerModal: true,
      // tourneyPrizeDetails: {
      //   rank: 1,
      //   playerWinning: 20000,
      // }
    };
    sendFaroLog({
      type: "CREATING_A_NEW_GAME_TABLE",
      tempTableId: tempTableId,
      gameData: newGameTable,
      receivedPayloadToCreateGame: action.payload,
    });

    state.games[tempTableId] = newGameTable;
    state.activeGame = tempTableId;
    state.gamesAvailable = true;
    state.showGameTable = true;
    state.removePrivateTableGameDefId = null;
  } else if (isGameAlreadyExistWithId) {
    sendFaroLog({
      type: "FAILED_AT_CREATING_A_NEW_GAME_TABLE",
      tempTableId: tempTableId,
      receivedPayloadToCreateGame: action.payload,
      activeGameTempTableId: state.activeGame,
    });
  }
}

function processResetTableData(state, action) {
  const { tempTableId, isTourneyGame } = action.payload;
  let gameEndpoint = action.payload.gameEndpoint;
  let tableData = state.games[tempTableId];

  if (tableData) {
    if (isTourneyGame) {
      gameEndpoint = tableData.gameEndpoint;
    }
    tableData = {
      ...tableData,
      isReset: true,
      gameId: null,
      gameAPIState: isTourneyGame
        ? TOURNEY_GAME_CONNECTION_STATE
        : MATCH_MAKING_API,
      gameConnectionStatus: isTourneyGame
        ? INITIATE_TOURNEY_GAME_CONNECTION
        : MATCH_MAKING_API_READY_TO_REQUEST,
      gameEndpoint: gameEndpoint ? gameEndpoint : undefined,
      isConnectionAckReceivedOnce: false,
      isLackGame: false,
      awsalbcookie: "",
      isDisconnected: false,
      isReconnected: false,
      watchPlayer: true,
      gameModal: {
        type: null,
        config: null,
        visible: false,
      },
    };
  } else {
    showNoTableAvailableWarning(action);
  }
}

function showNoTableAvailableWarning(action) {
  //write a log to the lobby socket
  const logPayload = {
    type: "table not available",
    actionData: action,
  };

  let debugProtocol = `DB#${JSON.stringify(logPayload)}`;
  LobbyConnection.getInstance().writeMessage(debugProtocol);

  sendFaroLog(
    getMLTLogFormat({
      type: "table not available",
      stage: "showNoTableAvailableWarning",
      logLocation: "Game",
      tempTableId: action.payload.tempTableId,
      comments: action,
    })
  );
}

function processCloseGameWindow(state, action) {
  const { tempTableId, removeTable } = action.payload;
  let tableData = state.games[tempTableId];
  if (tableData) {
    if (removeTable) {
      delete state.games[tempTableId];
    }
  } else {
    showNoTableAvailableWarning(action);
  }
}

function processCleanTable(
  state,
  tempTableId,
  cleanGameId = true,
  tourneyGameAndCheckExitTable = false,
  doNotCleanShownCards = false
) {
  let tableData = state.games[tempTableId];
  if (tableData) {
    if (cleanGameId) {
      tableData.gameId = "";
    }
    tableData.playerCards = [];
    tableData.gameStage = "";
    tableData.communityCards = [];
    tableData.RITCommunityCards = [];
    if (!doNotCleanShownCards) {
      tableData.shownCards = [];
      tableData.showAllCards = false;
    }
    tableData.isUserWinner = false;
    tableData.isRITEnabled = false;
    tableData.showCommunityCardsImmediately = false;
    tableData.multiPotAmounts = [];
    tableData.gameEnded = false;
    tableData.totalPotAmt = undefined;
    tableData.isWinnerDeclared = false;
    tableData.winningPotDisplay = undefined;
    tableData.setBuyInValueForPlayerPosition = tableData.playerWaitingPosition
      ? tableData.setBuyInValueForPlayerPosition
      : undefined;
    tableData.showFold = false;
    tableData.showCall = false;
    tableData.showAllIn = false;
    tableData.showCheck = false;
    tableData.showRaise = false;
    tableData.autoCheckOrFold = false;
    tableData.autoCall = false;
    tableData.fold = false;
    tableData.autoCheck = false;
    tableData.isTableCleaned = true;
    tableData.playerTurn = undefined;
    tableData.autoAction = undefined;
    tableData.playerTimer = -1;
    tableData.showAutoActions = false;
    tableData.showStartGameTimer = false;
    tableData.doCommunityCardsExist = false;
    tableData.startGameTimerValue = 0;
    tableData.showDefaultActions = false;
    tableData.disableDefaultActions = false;
    tableData.disableAutoActions = false;
    tableData.autoCall = false;
    tableData.autoCallAny = false;
    tableData.autoCheckOrFold = false;
    tableData.autoCheck = false;
    tableData.fold = false;
    tableData.shouldPlayCardAnimation = false;
    tableData.isGameStarted = false;
    tableData.winningHand = [];
    tableData.rankDetails = undefined;
    tableData.potAmounts = [];
    tableData.handType = "";
    tableData.restrictUserFromLeavingTable = false;
    tableData.showReleaseToFoldAlert = false;
    if (!tableData.openInSufficientFundsModal) {
      //NOTE: If we have autoRebuyinf scenatio we will receive NGC , but we still need to open insufficient modal so for that we added this change
      tableData.openInSufficientFundsModal = false;
    }
    tableData.openTopupModal = false;
    // if the waitlist player is joining the table , then buy-in modal should not be closed
    // tableData.openBuyInModal = tableData.playerWaitingPosition ? true : false;
    tableData.openBuyInModal = tableData.openBuyInModal
      ? tableData.openBuyInModal
      : false;
    tableData.disableOrientationChange = false;
    tableData.revealCards = false;
    tableData.numberOfSidePots = 0;
    tableData.totalPotAmt = undefined;
    tableData.topUpPending = false;
    tableData.RITRequest = false;

    let updatedPlayer = tableData.playerData.map((player) => {
      player.winningHand = undefined;
      player.handType = undefined;
      // player.cards = undefined;
      player.allIn = false;
      player.RITRequestAccepted = false;
      player.winningPotAmount = undefined;
      player.revealCard = false;
      player.showingCards = false;
      player.showBlindIcon = true;
      player.handType = undefined;
      player.lastAction = undefined;
      player.winningAmount = undefined;
      player.winningPotAmount = [];
      player.muckCards = false;
      return player;
    });

    tableData.playerData = updatedPlayer;

    if (tourneyGameAndCheckExitTable) {
      tableData.restrictUserFromLeavingTable = tableData.watchPlayer
        ? false
        : true;
    }
  }
}

function processCreateTourneyBanner(state, payload) {
  const {
    tempTableId,
    type,
    tourneyBannerData,
    autoClose = true,
    autoCloseDuration = 3000,
  } = payload;

  let tableData = state.games[tempTableId];

  if (tableData) {
    if (!Array.isArray(tableData.tourneyBanners)) {
      tableData.tourneyBanners = [];
    }

    const isDuplicate = tableData.tourneyBanners.some(
      (banner) => banner.type === type
    );

    if (!isDuplicate) {
      tableData.tourneyBanners.push({
        id: Date.now(),
        type,
        tourneyBannerData,
        autoClose,
        autoCloseDuration,
      });
    }
  } else {
    showNoTableAvailableWarning({
      payload: {
        tempTableId: tempTableId,
      },
    });
  }
}

const gameTableSlice = createSlice({
  name: "gameTable",
  initialState: {
    playerAvatar: null,
    activeGame: null,
    applicationVisibility: true,
    showGameTable: false,
    tableBlur: false,
    canUserSwipe: true,
    swipeDirection: undefined,
    tableOrientation: "PORTRAIT",
    shouldTableSwitchAfterTurn: false,
    playerComponentSize: 55,
    isPlayerTurnOnAnyTable: false,
    tableSettings: {
      showHandStrength: true,
      autoTableSwitch: false,
      autoMuck: true,
      showEmojis: true,
      showThrowables: true,
      throwables: [],
      emojis: [],
      smartGestures: true,
      BBDisplay: false,
      smartGestureOptions: {
        smartFold: true,
        smartCheck: true,
      },
      autoRebuy: false,
      autoBuyIn: {
        enabled: false,
        percentage: 50,
      },
      autoTopupConfig: {
        enabled: false,
        fallsBelowAmount: 0,
        topUpAmount: 0,
        fallBelowMinAmount: 0,
        fallsBelowMaxAmount: 100,
        topUpMinAmount: 0,
        topUpMaxAmount: 100,
      },
      bettingOptions: {
        defaultPreflopPresetValue: 3,
        defaultPostflopPresetValue: 2,
        preflopPresetValues: {
          0: 2,
          1: 2.5,
          2: 3,
          3: 4,
        },
        postflopPresetValues: {
          0: 0.25,
          1: 0.5,
          2: 1,
          3: 2,
        },
      },
      sound:
        getFromLocalStorage(IS_SOUND_ENABLED) === null
          ? true
          : getFromLocalStorage(IS_SOUND_ENABLED),
      haptics:
        getFromLocalStorage(IS_HAPTICS_EBABLED) === null
          ? true
          : getFromLocalStorage(IS_HAPTICS_EBABLED),
    },
    themeData: {
      table: localStorage.getItem("tableTheme")
        ? localStorage.getItem("tableTheme")
        : "Table1",
      background: localStorage.getItem("tableBackground")
        ? localStorage.getItem("tableBackground")
        : "BG1",
      cardDeck: localStorage.getItem("cardDeck")
        ? localStorage.getItem("cardDeck")
        : "Default",
      cardBack: localStorage.getItem("cardBack")
        ? localStorage.getItem("cardBack")
        : "CB1",
      cardSize: localStorage.getItem("cardSize")
        ? localStorage.getItem("cardSize")
        : CARD_SIZE_MEDIUM,
    },
    lobbyMultiGameTableDrawer: false,
    gameTableData: {
      tables: [],
      activeTempTableId: "",
    },
    removePrivateTableGameDefId: null,
    gameJoinCheckObject: null,
    games: {},
    sequentialConnectionArray: [],
    userDetails: {
      userName: "",
      subscriptionType: "",
      state: "",
      level: "",
      isAllowLocation: "",
      avatar: "",
      IP: "",
      deviceId: "",
      latitude: "",
      longitude: "",
      userId: "",
      deepLink: {
        isAllowLocation: "true",
      },
    },
    handHistory: {
      activeHandIndex: undefined,
      details: {},
    },
    handHistoryLoading: true,
    displayNameMap: {},
    activeplayerCount: null,
    sitoutplayerCount: null,
    happyHoursInfoLoading: true,
    happyHoursInfoFailure: false,
    showHappyHoursButton: false,
    happyHourSavings: null,
    happyHoursInfo: {
      playerTotalSavings: null,
      playerTableSavings: null,
      totalTableSavings: null,
    },
    autoTableSwitchQueue: [],
    visibleGameTables: [],
    privateTable: {
      isPrivateTable: false,
      hideStartGameButton: false,
      showAutoStartMessage: false,
      showMinPlayersJoinMessage: false,
      openHostControlSlider: false,
    },
  },

  reducers: {
    requestReserveSeat: (state, action) => {
      const { tempTableId, position } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].processingReserve = {
          status: true,
          position: position,
        };
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleReserveSeatBroadcast: (state, action) => {
      const { playerName, position, tempTableId, displayName } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        let displayNameMap = tableData.displayNameMap || {};
        let reservePlayerData = {
          position: position,
          userName: playerName,
          avatar: "",
          userId: "",
          atTableAmount: 0,
          acelevel: "",
          isReservedSeat: true,
          isTakenSeat: false,
          isFolded: false,
          isActive: true,
          isWinner: false,
          allIn: false,
          displayName: displayName,
        };
        if (!displayNameMap[reservePlayerData.userName]) {
          displayNameMap[reservePlayerData.userName] =
            reservePlayerData.displayName;
        }
        state.games[tempTableId].displayNameMap = displayNameMap;
        state.games[tempTableId].playerData.push(reservePlayerData);
        state.games[tempTableId].processingReserve = {
          status: false,
          position: position,
        };
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleRSeatBroadcast: (state, action) => {
      const { playerList, tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        let reservePlayersData = [];
        playerList.forEach((player) => {
          let reservePlayerData = {
            position: player.position,
            userName: player.playerName,
            avatar: "",
            userId: "",
            atTableAmount: 0,
            acelevel: "",
            isReservedSeat: true,
            isTakenSeat: false,
            isFolded: false,
            isActive: true,
            isWinner: false,
            allIn: false,
          };
          reservePlayersData.push(reservePlayerData);
        });

        state.games[tempTableId].playerData = [
          ...state.games[tempTableId].playerData,
          ...reservePlayersData,
        ];
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleRemoveReserveSeatBroadcast: (state, action) => {
      const { position, tempTableId, playerName } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].playerData = state.games[
          tempTableId
        ].playerData.filter(
          (eachPlayer) =>
            eachPlayer.position !== position &&
            eachPlayer.userName !== playerName
        );
        if (state.games[tempTableId].processingReserve.position === position) {
          state.games[tempTableId].processingDReserve = false;
          state.games[tempTableId].processingReserve = {
            status: false,
            position: undefined,
          };
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    updateDisableGameActions: (state, action) => {
      const { tempTableId, disabled } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].showDefaultActions = false;
        state.games[tempTableId].disableAutoActions = disabled;
        state.games[tempTableId].disableDefaultActions = disabled;
        let playerData = state.games[tempTableId].playerData.find(
          (player) => player.position === state.games[tempTableId]?.playerSeat
        );
        if (playerData) {
          playerData.tableTimer = 0;
          playerData.startTableTimer = false;
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    requestRemoveReserveSeat: (state, action) => {
      let { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (state.games[tempTableId].openBuyInModal) {
          // We can use activeGame here since there is no chance of activeGame changes while buyinModal is open
          let position =
            state.games[tempTableId].setBuyInValueForPlayerPosition;
          state.games[tempTableId].processingDReserve = true;

          let gameConnections = GameConnections.getInstance();
          let activeGameConnection =
            gameConnections.getGameConnection(tempTableId);

          if (activeGameConnection && activeGameConnection.messageHandler) {
            let activeGameTable = state.games[tempTableId];
            if (activeGameTable) {
              activeGameConnection.gameClientListener.requestRemoveReserveSeat({
                playerName: state.userDetails.userName,
                position: `${position}`,
                tableId: state.games[tempTableId].tableId,
              });
            }
          }
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    setRemoveReserveSeatForPlayer: (state, action) => {
      const { tempTableId, position, playerName } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].openBuyInModal = false;
        state.games[tempTableId].setBuyInValueForPlayerPosition = null;
        state.games[tempTableId].playerData = state.games[
          tempTableId
        ].playerData.filter(
          (eachPlayer) =>
            eachPlayer.position !== position &&
            eachPlayer.userName !== playerName
        );
        state.games[tempTableId].processingDReserve = false;
        state.games[tempTableId].watchPlayer = true;
        state.games[tempTableId].processingReserve = {
          status: false,
          position: undefined,
        };
        state.games[tempTableId].antiBanking.antiBankAmount = 0;
        state.games[tempTableId].antiBanking.isAntiBank = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    setPreflopPresetValues: (state, action) => {
      state.tableSettings.bettingOptions.preflopPresetValues = action.payload;
    },

    setPostflopPresetValues: (state, action) => {
      state.tableSettings.bettingOptions.postflopPresetValues = action.payload;
    },

    setDefaultPreflopPresetValue: (state, action) => {
      state.tableSettings.bettingOptions.defaultPreflopPresetValue =
        action.payload;
    },

    setDefaultPostflopPresetValue: (state, action) => {
      state.tableSettings.bettingOptions.defaultPostflopPresetValue =
        action.payload;
    },

    processReserveFailure: (state, action) => {
      const { tempTableId, position } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].processingReserve = {
          status: false,
          position: position,
        };
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    // set the position of the player who clicked on sit here and buys in
    setBuyInValueForPlayerPosition: (state, action) => {
      const { tempTableId, endTime, position, playerName, joinType } =
        action.payload;
      let tableData = state.games[tempTableId];
      // need to handle based on server response - Naveen
      if (tableData) {
        let antiBankAmount = action?.payload?.antiBankAmount;
        let isAntiBank = action?.payload?.isAntiBank;
        let isAutoBuyIn = state.tableSettings.autoBuyIn.enabled;
        // If join type is automatic, we will not show the buy in popup.
        if (!isAutoBuyIn || isAntiBank) {
          state.games[tempTableId].setBuyInValueForPlayerPosition =
            joinType !== "NA" && !antiBankAmount && !isAntiBank
              ? null
              : position;
          state.games[tempTableId].openBuyInModal =
            joinType !== "NA" && !antiBankAmount && !isAntiBank ? false : true;
          state.games[tempTableId].openRebuyInModal = false;
          state.games[tempTableId].openTopupModal = false;
          state.games[tempTableId].buyInTimeInSeconds = endTime;
        }
        console.warn('Spruha >>> BUY IN POSITION >>> ', state.games[tempTableId].setBuyInValueForPlayerPosition);
        let reservePlayerData = {
          position: position,
          avatar: "",
          userId: "",
          atTableAmount: 0,
          acelevel: "",
          isReservedSeat: true,
          isTakenSeat: false,
          isFolded: false,
          isActive: true,
          isWinner: false,
          allIn: false,
        };
        state.games[tempTableId].antiBanking.antiBankAmount = antiBankAmount;
        state.games[tempTableId].antiBanking.isAntiBank = isAntiBank;
        state.games[tempTableId].processingDReserve = false;
        state.games[tempTableId].processingReserve = {
          status: true,
          position: position,
        };
        state.games[tempTableId].playerData.push(reservePlayerData);
        state.activeGame = tempTableId;
        console.log("buy in state after reserve ack ", state);
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleGameJoinRequest: (state, action) => {
      const { tempTableId, userDetails } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        const { userName, avatar, userId, level } = state.userDetails;
        let newPlayerData = {
          position: userDetails.position,
          userName: userName,
          avatar: avatar,
          userId: userId,
          atTableAmount: userDetails.atTableAmount,
          acelevel: level,
          isReservedSeat: false,
          isTakenSeat: true,
          isFolded: false,
          isActive: state.games[tempTableId].isGameStarted
            ? userDetails.isActivePlayer
            : true,
          isWinner: false,
          allIn: false,
          sitOutOption: false,
          // Since the join is successful, we will update reserved as false.
          isWaitingForBigBlind: userDetails.isWaitingForBigBlind,
        };
        state.games[tempTableId].openBuyInModal = false;
        let activePlayers = state.games[tempTableId].playerData.filter(
          (player) => player.position !== userDetails.position
        );
        activePlayers.push(newPlayerData);

        state.games[tempTableId].playerData = activePlayers;
        state.games[tempTableId].sitOutOption = false;
        state.games[tempTableId].playerSeat = userDetails?.position;
        state.games[tempTableId].playerSeatBeforeLeaveSeat =
          userDetails?.position;
        state.games[tempTableId].setBuyInValueForPlayerPosition = undefined;

        state.games[tempTableId].processingReserve = {
          status: false,
          position: userDetails.position,
        };

        state.games[tempTableId].playerWaitingPosition = undefined;
        state.games[tempTableId].totalWaitListPlayerCount = undefined;

        if (state.games[tempTableId].gameModal.type === BUY_IN) {
          state.games[tempTableId].gameModal.type = null;
          state.games[tempTableId].gameModal.visible = false;
        }
        state.games[tempTableId].antiBanking.antiBankAmount = 0;
        state.games[tempTableId].antiBanking.isAntiBank = false;

        if (state.tableSettings.haptics) {
          GameAudio.getInstance().playVibration(VIBRATE_LIGHT);
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handlePlayerJoinBroadcast: (state, action) => {
      const { tempTableId, userDetails } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        let displayNameMap = tableData.displayNameMap || {};
        const {
          position,
          playerName,
          atTableAmount,
          acelevel,
          profilePic,
          isActivePlayer,
          isWaitingForBigBlind,
          displayName,
        } = userDetails;

        let newPlayerData = {
          position: position,
          userName: playerName,
          displayName: displayName,
          atTableAmount: atTableAmount,
          acelevel: acelevel,
          avatar: profilePic,
          isReservedSeat: false,
          isTakenSeat: true,
          isFolded: false,
          isActive: state.games[tempTableId].isGameStarted
            ? isActivePlayer
            : true,
          isWinner: false,
          allIn: false,
          isWaitingForBigBlind: isWaitingForBigBlind,
          RITRequestAccepted: false,
        };
        if (newPlayerData.userName) {
          displayNameMap[newPlayerData.userName] = newPlayerData.displayName;
        }

        let currentPosition = state.games[tempTableId].playerData.find(
          (eachPlayer) => eachPlayer.position === position
        );
        if (currentPosition) {
          let updatedPlayerData = state.games[tempTableId].playerData.map(
            (eachPlayer) => {
              if (eachPlayer.position === position) {
                return newPlayerData;
              } else {
                return eachPlayer;
              }
            }
          );
          state.games[tempTableId].playerData = updatedPlayerData;
        } else {
          state.games[tempTableId].playerData.push(newPlayerData);
        }
        state.games[tempTableId].displayNameMap = displayNameMap;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handlePlayerAutoActions: (state, action) => {
      const { tempTableId, autoActions } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        const {
          callAny,
          call,
          callAmount,
          checkFold,
          check,
          fold,
          isCallAnySelected,
          isCallSelected,
          isCheckFoldSelected,
          isCheckSelected,
          isFoldSelected,
        } = autoActions;

        let autoAction = "";
        if (isCallAnySelected) {
          autoAction = AUTO_CALL_ANY_ACTION;
        } else if (isCallSelected) {
          autoAction = AUTO_CALL_ACTION;
        } else if (isCheckFoldSelected) {
          autoAction = AUTO_CHECK_OR_FOLD_ACTION;
        } else if (isCheckSelected) {
          autoAction = AUTO_CHECK_ACTION;
        } else if (isFoldSelected) {
          autoAction = AUTO_FOLD_ACTION;
        }
        state.games[tempTableId].autoAction = autoAction;
        state.games[tempTableId].showAutoActions = true;
        state.games[tempTableId].showDefaultActions = false;
        state.games[tempTableId].disableAutoActions = false;
        state.games[tempTableId].disableDefaultActions = false;
        state.games[tempTableId].autoCall = call;
        state.games[tempTableId].autoCallAny = callAny;
        state.games[tempTableId].callAmount = callAmount;
        state.games[tempTableId].autoCheckOrFold = checkFold;
        state.games[tempTableId].autoCheck = check;
        state.games[tempTableId].fold = fold;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    updateUserAutoActionPreference: (state, action) => {
      const { autoUserAction, tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].autoAction = autoUserAction;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    processPlayerConfigAck: (state, action) => {
      const { tempTableId, statusCode, message } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (statusCode === 400) {
          state.games[tempTableId].toastMessages.push({
            type: TOAST_ERROR,
            title: "Settings Error",
            message:
              message ||
              "Failed to update your table settings. Please try again.",
          });
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    clearToastMessages: (state, action) => {
      const { tempTableId } = action.payload;
      state.games[tempTableId].toastMessages = [];
    },

    updateAutoTableSwitchQueue: (state, action) => {
      const { tempTableId } = action.payload;
      let autoTableSwitchingQueue = state.autoTableSwitchQueue;
      // Removing the game user acted on from autoTableSwitchingQueue
      autoTableSwitchingQueue = autoTableSwitchingQueue.filter(
        (id) => id !== tempTableId
      );
      state.autoTableSwitchQueue = autoTableSwitchingQueue;
      // If the length of the queue is greater than 0, then move the user to the next table in queue immediately
      if (
        autoTableSwitchingQueue.length > 0 &&
        state.tableSettings.autoTableSwitch
      ) {
        if (autoTableSwitchingQueue[0] > state.activeGame) {
          state.swipeDirection = "left";
        } else {
          state.swipeDirection = "right";
        }
        if (state.games[state.autoTableSwitchQueue[0]]) {
          state.activeGame = state.autoTableSwitchQueue[0];
        } else {
          console.log(
            "Auto Table Switch Failure - Setting active game to >>> ",
            state.autoTableSwitchQueue[0]
          );
          sendFaroLog({
            type: "autoTableSwitchFailure",
            state,
          });
        }
      }
    },

    handleTurnChange: (state, action) => {
      const { tempTableId, turnDetails } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        const {
          position,
          fold,
          check,
          call,
          raise,
          allInForCall,
          callAmount,
          time,
          maxTime,
          totalTime,
          currentRaiseAmount,
          minimumRaiseAmount,
        } = turnDetails;

        let updatedPlayerDetails = state.games[tempTableId].playerData.map(
          (eachPlayer) => {
            if (eachPlayer.position === position) {
              eachPlayer.tableTimer = time;
              eachPlayer.totalTime = totalTime;
              eachPlayer.maxTurnTimer = maxTime;
              eachPlayer.startTurnTimer = true;
              eachPlayer.startTableTimer = true;
              eachPlayer.allInForCall = allInForCall;
              eachPlayer.currentRaiseAmount =
                parseDecimalValuesOfNumber(currentRaiseAmount);
              eachPlayer.activeTableTimerType = PLAYER_DEFAULT_TIMER;
              return eachPlayer;
            } else {
              eachPlayer.startTurnTimer = false;
              eachPlayer.startTableTimer = false;
              return eachPlayer;
            }
          }
        );

        const currentUserData = state.games[tempTableId].playerData.find(
          (player) => player.position === state.games[tempTableId]?.playerSeat
        );

        state.games[tempTableId].playerData = updatedPlayerDetails;
        state.games[tempTableId].showAutoActions = false;
        state.games[tempTableId].showDefaultActions = true;
        state.games[tempTableId].disableAutoActions = false;
        state.games[tempTableId].disableDefaultActions = false;
        state.games[tempTableId].showCall = call;
        state.games[tempTableId].showFold = fold;
        state.games[tempTableId].showCheck = check;
        state.games[tempTableId].showRaise = raise;
        state.games[tempTableId].showAllIn = allInForCall;
        state.games[tempTableId].callAmount = callAmount;
        state.games[tempTableId].playerTurn = position;
        state.games[tempTableId].autoAction = "";
        state.games[tempTableId].minRaiseAmount =
          parseDecimalValuesOfNumber(minimumRaiseAmount);

        if (
          state.games[tempTableId]?.gameDefinition?.gameType === OMAHA ||
          state.games[tempTableId]?.gameDefinition?.gameType === OMAHA5 ||
          state.games[tempTableId]?.gameDefinition?.gameType === OMAHA6
        ) {
          state.games[tempTableId].maxRaiseAmount =
            turnDetails.maximumRaiseAmount;
        } else {
          state.games[tempTableId].maxRaiseAmount = parseDecimalValuesOfNumber(
            currentUserData?.atTableAmount + currentUserData?.betAmount
          );
        }

        // Playing the sound iff user has to act in any way, not playing it for auto actions triggered by server
        if (call || fold || check || raise || allInForCall) {
          GameAudio.getInstance().stopSound();
          if (
            tempTableId === state?.activeGame &&
            state.applicationVisibility
          ) {
            if (state.tableSettings.haptics) {
              GameAudio.getInstance().playVibration(VIBRATE_LIGHT);
            }
            GameAudio.getInstance().playAudio(
              !state.tableSettings.sound,
              TURN_SOUND,
              true,
              false
            );
          }
        }

        // AUTO TABLE SWITCHING LOGIC
        // Appending the game to auto table switch queue if it requires user action
        let doesUserHaveToAct = call || fold || check || raise || allInForCall;
        let currentTableData = state.games[state.activeGame];
        let isPlayerTurnOnCurrentTable = currentTableData
          ? currentTableData.playerTurn === currentTableData.playerSeat
          : false;
        let autoTableSwitchingQueue = state.autoTableSwitchQueue;

        if (doesUserHaveToAct) {
          autoTableSwitchingQueue = autoTableSwitchingQueue.filter(
            (item) => item !== tempTableId
          );
          autoTableSwitchingQueue.push(tempTableId);
        }
        state.autoTableSwitchQueue = autoTableSwitchingQueue;

        // Switching will occur immediately here incase the player is on a table where it is not their turn.
        if (!isPlayerTurnOnCurrentTable) {
          if (
            autoTableSwitchingQueue.length > 0 &&
            state.tableSettings.autoTableSwitch
          ) {
            if (autoTableSwitchingQueue[0] > state.activeGame) {
              state.swipeDirection = "left";
            } else {
              state.swipeDirection = "right";
            }
            if (state.games[state.autoTableSwitchQueue[0]]) {
              state.activeGame = state.autoTableSwitchQueue[0];
            } else {
              sendFaroLog({
                type: "autoTableSwitchFailure",
                state,
              });
            }
          }
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleCallActionAck: (state, action) => {
      const {
        tempTableId,
        playerName,
        atTableAmount,
        betAmount,
        isAllIn,
        status,
      } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (status === "FAILED") {
          // Making sure that it is still the players turn to render buttons again.
          // If the turn has passed, do not show his actions even in case of failure.
          if (
            state.games[tempTableId].playerTurn ===
            state.games[tempTableId].playerSeat
          ) {
            state.games[tempTableId].disableAutoActions = false;
            state.games[tempTableId].disableDefaultActions = false;
            state.games[tempTableId].showDefaultActions = true;
            state.games[tempTableId].showAutoActions = false;
            state.games[tempTableId].toastMessages.push({
              type: TOAST_ERROR,
              title: "Game Action Failure",
              message: "Failed to call. Please try again.",
            });
          }
        } else if (status === "SUCCESS") {
          let updatedPlayerDetails = state.games[tempTableId].playerData.map(
            (eachPlayer) => {
              if (eachPlayer.userName === playerName) {
                eachPlayer.atTableAmount =
                  parseDecimalValuesOfNumber(atTableAmount);
                eachPlayer.betAmount = parseDecimalValuesOfNumber(betAmount);
                eachPlayer.lastAction = CALL_ACTION;
                eachPlayer.allIn = isAllIn;
                eachPlayer.startTableTimer = false;
                eachPlayer.tableTimer = 0;
                eachPlayer.activeTableTimerType = "";
                eachPlayer.remainingTime = false;
                eachPlayer.startPlayerChipAnimation = true;
                eachPlayer.startAllInAnimation = isAllIn;
                return eachPlayer;
              } else {
                return eachPlayer;
              }
            }
          );

          state.games[tempTableId].playerData = updatedPlayerDetails;
          state.games[tempTableId].showAutoActions = false;
          state.games[tempTableId].showDefaultActions = false;
          state.games[tempTableId].disableAutoActions = false;
          state.games[tempTableId].disableDefaultActions = false;
          state.games[tempTableId].playerTurn = false;
          state.games[tempTableId].autoAction = "";

          GameAudio.getInstance().stopSound();

          if (state.tableSettings.haptics) {
            GameAudio.getInstance().playVibration(VIBRATE_LIGHT);
          }

          if (
            tempTableId === state?.activeGame &&
            state.applicationVisibility
          ) {
            GameAudio.getInstance().playAudio(
              !state.tableSettings.sound,
              CALL_SOUND,
              true,
              false
            );
          }
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    updateAllInAnimationFlag: (state, action) => {
      const { tempTableId, position } = action.payload;

      let tableData = state.games[tempTableId];

      if (tableData) {
        let updatedPlayerDetails = state.games[tempTableId].playerData.map(
          (player) => {
            if (player.position === position) {
              player.startAllInAnimation = false;
            }
            return player;
          }
        );
        state.games[tempTableId].playerData = updatedPlayerDetails;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    setHappyHoursInfoLoading: (state, action) => {
      let { loading } = action.payload;
      state.happyHoursInfoLoading = loading;
    },

    updateGameDefinition: (state, action) => {
      const { gameDefinition } = action.payload;

      let tempTableIds = Object.keys(state.games);
      tempTableIds.map((tempTableId) => {
        let gameData = state.games[tempTableId];
        if (gameData.gameDefinition.gameDefId === gameDefinition.gameDefId) {
          gameData.gameDefinition = gameDefinition;
        }
      });
    },

    setPlayerAvatar: (state, action) => {
      state.playerAvatar = action.payload;
    },

    processHappyHoursInfo: (state, action) => {
      let { playerTotalSavings, totalTableSavings, playerTableSavings } =
        action.payload;
      state.happyHoursInfo = {
        playerTotalSavings: playerTotalSavings,
        totalTableSavings: totalTableSavings,
        playerTableSavings: playerTableSavings,
      };
      state.happyHoursInfoLoading = false;
      state.happyHoursInfoFailure = false;
    },

    processHappyHoursInfoFailure: (state, action) => {
      state.happyHoursInfoLoading = false;
      state.happyHoursInfoFailure = true;
    },

    handleCallActionBroadcast: (state, action) => {
      const { tempTableId, playerName, atTableAmount, betAmount, isAllIn } =
        action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        let updatedPlayerDetails = state.games[tempTableId].playerData.map(
          (eachPlayer) => {
            if (eachPlayer.userName === playerName) {
              eachPlayer.atTableAmount =
                parseDecimalValuesOfNumber(atTableAmount);
              eachPlayer.betAmount = parseDecimalValuesOfNumber(betAmount);
              eachPlayer.lastAction = CALL_ACTION;
              eachPlayer.allIn = isAllIn;
              eachPlayer.startTableTimer = false;
              eachPlayer.tableTimer = 0;
              eachPlayer.activeTableTimerType = "";
              eachPlayer.remainingTime = false;
              eachPlayer.startPlayerChipAnimation = true;
              eachPlayer.startAllInAnimation = isAllIn;
              return eachPlayer;
            } else {
              return eachPlayer;
            }
          }
        );
        state.games[tempTableId].playerData = updatedPlayerDetails;
        state.games[tempTableId].playerTurn = false;

        GameAudio.getInstance().stopSound();

        if (tempTableId === state?.activeGame && state.applicationVisibility) {
          GameAudio.getInstance().playAudio(
            !state.tableSettings.sound,
            CALL_SOUND,
            true,
            false
          );
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleCheckActionAck: (state, action) => {
      const { tempTableId, playerName, atTableAmount, status } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (status === "FAILED") {
          // Making sure that it is still the players turn to render buttons again.
          // If the turn has passed, do not show his actions even in case of failure.
          if (
            state.games[tempTableId].playerTurn ===
            state.games[tempTableId].playerSeat
          ) {
            state.games[tempTableId].disableAutoActions = false;
            state.games[tempTableId].disableDefaultActions = false;
            state.games[tempTableId].showDefaultActions = true;
            state.games[tempTableId].showAutoActions = false;
            state.games[tempTableId].toastMessages.push({
              type: TOAST_ERROR,
              title: "Game Action Failure",
              message: "Failed to check. Please try again.",
            });
          }
        } else if (status === "SUCCESS") {
          let updatedPlayerDetails = state.games[tempTableId].playerData.map(
            (eachPlayer) => {
              if (eachPlayer.userName === playerName) {
                eachPlayer.atTableAmount =
                  parseDecimalValuesOfNumber(atTableAmount);
                eachPlayer.lastAction = CHECK_ACTION;
                eachPlayer.startTableTimer = false;
                eachPlayer.tableTimer = 0;
                eachPlayer.activeTableTimerType = "";
                eachPlayer.remainingTime = false;
                eachPlayer.startPlayerChipAnimation = false;
                return eachPlayer;
              } else {
                return eachPlayer;
              }
            }
          );
          state.games[tempTableId].playerData = updatedPlayerDetails;
          state.games[tempTableId].autoAction = "";
          state.games[tempTableId].showAutoActions = false;
          state.games[tempTableId].showDefaultActions = false;
          state.games[tempTableId].disableAutoActions = false;
          state.games[tempTableId].disableDefaultActions = false;
          state.games[tempTableId].playerTurn = false;

          GameAudio.getInstance().stopSound();

          if (state.tableSettings.haptics) {
            GameAudio.getInstance().playVibration(VIBRATE_LIGHT);
          }
          if (
            tempTableId === state?.activeGame &&
            state.applicationVisibility
          ) {
            GameAudio.getInstance().playAudio(
              !state.tableSettings.sound,
              CHECK_SOUND,
              true,
              false
            );
          }
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleCheckActionBroadcast: (state, action) => {
      const { tempTableId, playerName, atTableAmount } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        let updatedPlayerDetails = state.games[tempTableId].playerData.map(
          (eachPlayer) => {
            if (eachPlayer.userName === playerName) {
              eachPlayer.atTableAmount =
                parseDecimalValuesOfNumber(atTableAmount);
              eachPlayer.lastAction = CHECK_ACTION;
              eachPlayer.startPlayerChipAnimation = false;
              eachPlayer.startTableTimer = false;
              eachPlayer.tableTimer = 0;
              eachPlayer.activeTableTimerType = "";
              eachPlayer.remainingTime = false;
              return eachPlayer;
            } else {
              return eachPlayer;
            }
          }
        );
        state.games[tempTableId].playerData = updatedPlayerDetails;
        state.games[tempTableId].playerTurn = false;

        GameAudio.getInstance().stopSound();

        if (tempTableId === state?.activeGame && state.applicationVisibility) {
          GameAudio.getInstance().playAudio(
            !state.tableSettings.sound,
            CHECK_SOUND,
            true,
            false
          );
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleFoldActionAck: (state, action) => {
      const { tempTableId, playerName, atTableAmount, status } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (status === "FAILED") {
          // Making sure that it is still the players turn to render buttons again.
          // If the turn has passed, do not show his actions even in case of failure.
          if (
            state.games[tempTableId].playerTurn ===
            state.games[tempTableId].playerSeat
          ) {
            state.games[tempTableId].disableAutoActions = false;
            state.games[tempTableId].disableDefaultActions = false;
            state.games[tempTableId].showDefaultActions = true;
            state.games[tempTableId].showAutoActions = false;
            state.games[tempTableId].toastMessages.push({
              type: TOAST_ERROR,
              title: "Game Action Failure",
              message: "Failed to fold. Please try again.",
            });
          }
        } else if (status === "SUCCESS") {
          let updatedPlayerDetails = state.games[tempTableId].playerData.map(
            (eachPlayer) => {
              if (eachPlayer.userName === playerName) {
                eachPlayer.isActive = true;
                eachPlayer.isFolded = true;
                eachPlayer.startTableTimer = false;
                eachPlayer.tableTimer = 0;
                eachPlayer.activeTableTimerType = "";
                eachPlayer.remainingTime = false;
                eachPlayer.lastAction = FOLD_ACTION;
                eachPlayer.activeTableTimerType = "";
                eachPlayer.remainingTime = false;
                return eachPlayer;
              } else {
                return eachPlayer;
              }
            }
          );

          state.games[tempTableId].playerData = updatedPlayerDetails;
          state.games[tempTableId].disableAutoActions = true;
          state.games[tempTableId].disableDefaultActions = true;
          state.games[tempTableId].showAutoActions = false;
          state.games[tempTableId].showDefaultActions = false;
          state.games[tempTableId].autoAction = "";
          state.games[tempTableId].playerTurn = false;
          state.games[tempTableId].startWinnerPotAnimation = false;

          GameAudio.getInstance().stopSound();

          if (
            tempTableId === state?.activeGame &&
            state.applicationVisibility
          ) {
            if (state.tableSettings.haptics) {
              GameAudio.getInstance().playVibration(VIBRATE_LIGHT);
            }
            GameAudio.getInstance().playAudio(
              !state.tableSettings.sound,
              FOLD_SOUND,
              true,
              false
            );
          }
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleFoldActionBroadcast: (state, action) => {
      const { tempTableId, playerName } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        let updatedPlayerDetails = state.games[tempTableId].playerData.map(
          (eachPlayer) => {
            if (eachPlayer.userName === playerName) {
              eachPlayer.isActive = true;
              eachPlayer.isFolded = true;
              eachPlayer.startTableTimer = false;
              eachPlayer.tableTimer = 0;
              eachPlayer.activeTableTimerType = "";
              eachPlayer.remainingTime = false;
              eachPlayer.lastAction = FOLD_ACTION;
              return eachPlayer;
            } else {
              return eachPlayer;
            }
          }
        );

        state.games[tempTableId].playerData = updatedPlayerDetails;
        state.games[tempTableId].showDefaultActions = false;
        state.games[tempTableId].showAutoActions = false;
        state.games[tempTableId].disableAutoActions = true;
        state.games[tempTableId].disableDefaultActions = true;
        state.games[tempTableId].playerTurn = false;

        GameAudio.getInstance().stopSound();

        if (tempTableId === state?.activeGame && state.applicationVisibility) {
          GameAudio.getInstance().playAudio(
            !state.tableSettings.sound,
            FOLD_SOUND,
            true,
            false
          );
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleRaiseActionAck: (state, action) => {
      const { tempTableId, status, allIn, position, betAmount, atTableAmount } =
        action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (status === "FAILED") {
          // Making sure that it is still the players turn to render buttons again.
          // If the turn has passed, do not show his actions even in case of failure.
          if (
            state.games[tempTableId].playerTurn ===
            state.games[tempTableId].playerSeat
          ) {
            state.games[tempTableId].disableAutoActions = false;
            state.games[tempTableId].disableDefaultActions = false;
            state.games[tempTableId].showDefaultActions = true;
            state.games[tempTableId].showAutoActions = false;
            state.games[tempTableId].toastMessages.push({
              type: TOAST_ERROR,
              title: "Game Action Failure",
              message: "Failed to Raise. Please try again.",
            });
          }
        } else if (status === "SUCCESS") {
          let updatedPlayerDetails = state.games[tempTableId].playerData.map(
            (eachPlayer) => {
              if (eachPlayer.position === position) {
                eachPlayer.atTableAmount =
                  parseDecimalValuesOfNumber(atTableAmount);
                eachPlayer.startTableTimer = false;
                eachPlayer.tableTimer = 0;
                eachPlayer.activeTableTimerType = "";
                eachPlayer.remainingTime = false;
                eachPlayer.allIn = allIn;
                eachPlayer.betAmount = parseDecimalValuesOfNumber(betAmount);
                eachPlayer.lastAction = RAISE_ACTION;
                eachPlayer.activeTableTimerType = "";
                eachPlayer.remainingTime = false;
                eachPlayer.startPlayerChipAnimation = true;
                eachPlayer.startAllInAnimation = allIn;
                return eachPlayer;
              } else {
                return eachPlayer;
              }
            }
          );

          state.games[tempTableId].disableAutoActions = false;
          state.games[tempTableId].disableDefaultActions = false;
          state.games[tempTableId].showAutoActions = false;
          state.games[tempTableId].showDefaultActions = false;
          state.games[tempTableId].playerData = updatedPlayerDetails;
          state.games[tempTableId].autoAction = "";
          state.games[tempTableId].playerTurn = false;

          GameAudio.getInstance().stopSound();

          if (tempTableId === state.activeGame && state.applicationVisibility) {
            if (state.tableSettings.haptics) {
              GameAudio.getInstance().playVibration(VIBRATE_LIGHT);
            }

            GameAudio.getInstance().playAudio(
              !state.tableSettings.sound,
              RAISE_SOUND,
              true,
              false
            );
          }
        } else {
          state.games[tempTableId].disableAutoActions = false;
          state.games[tempTableId].disableDefaultActions = false;
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleRaiseActionBroadcast: (state, action) => {
      const { tempTableId, playerName, allIn, betAmount, atTableAmount } =
        action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        let updatedPlayerDetails = state.games[tempTableId].playerData.map(
          (eachPlayer) => {
            if (eachPlayer.userName === playerName) {
              eachPlayer.atTableAmount =
                parseDecimalValuesOfNumber(atTableAmount);
              eachPlayer.startTableTimer = false;
              eachPlayer.tableTimer = 0;
              eachPlayer.activeTableTimerType = "";
              eachPlayer.remainingTime = false;
              eachPlayer.allIn = allIn;
              eachPlayer.betAmount = parseDecimalValuesOfNumber(betAmount);
              eachPlayer.lastAction = RAISE_ACTION;
              eachPlayer.startPlayerChipAnimation = true;
              eachPlayer.startAllInAnimation = allIn;
              return eachPlayer;
            } else {
              return eachPlayer;
            }
          }
        );

        state.games[tempTableId].playerData = updatedPlayerDetails;
        state.games[tempTableId].disableAutoActions = false;
        state.games[tempTableId].disableDefaultActions = false;
        state.games[tempTableId].playerTurn = false;

        GameAudio.getInstance().stopSound();

        if (tempTableId === state.activeGame && state.applicationVisibility) {
          GameAudio.getInstance().playAudio(
            !state.tableSettings.sound,
            RAISE_SOUND,
            true,
            false
          );
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleAutoCallActionAck: (state, action) => {
      const { tempTableId, autoActionEnable } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].autoAction = autoActionEnable
          ? AUTO_CALL_ACTION
          : "";
        state.games[tempTableId].disableAutoActions = false;
        state.games[tempTableId].disableDefaultActions = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleAutoCallAnyActionAck: (state, action) => {
      const { tempTableId, autoActionEnable } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].autoAction = autoActionEnable
          ? AUTO_CALL_ANY_ACTION
          : "";
        state.games[tempTableId].disableAutoActions = false;
        state.games[tempTableId].disableDefaultActions = false;

        GameAudio.getInstance().stopSound();

        if (tempTableId === state.activeGame && state.applicationVisibility) {
          GameAudio.getInstance().playAudio(
            !state.tableSettings.sound,
            BUTTON_SOUND,
            true,
            false
          );
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleAutoCheckActionAck: (state, action) => {
      const { tempTableId, autoActionEnable } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].autoAction = autoActionEnable
          ? AUTO_CHECK_ACTION
          : "";
        state.games[tempTableId].disableAutoActions = false;
        state.games[tempTableId].disableDefaultActions = false;

        GameAudio.getInstance().stopSound();

        if (tempTableId === state.activeGame && state.applicationVisibility) {
          GameAudio.getInstance().playAudio(
            !state.tableSettings.sound,
            BUTTON_SOUND,
            true,
            false
          );
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleAutoCheckFoldActionAck: (state, action) => {
      const { tempTableId, autoActionEnable } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].autoAction = autoActionEnable
          ? AUTO_CHECK_OR_FOLD_ACTION
          : "";
        state.games[tempTableId].disableAutoActions = false;
        state.games[tempTableId].disableDefaultActions = false;

        GameAudio.getInstance().stopSound();

        if (tempTableId === state.activeGame && state.applicationVisibility) {
          GameAudio.getInstance().playAudio(
            !state.tableSettings.sound,
            BUTTON_SOUND,
            true,
            false
          );
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleAutoFoldActionAck: (state, action) => {
      const { tempTableId, autoActionEnable } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].autoAction = autoActionEnable
          ? AUTO_FOLD_ACTION
          : "";
        state.games[tempTableId].disableAutoActions = false;
        state.games[tempTableId].disableDefaultActions = false;
        GameAudio.getInstance().stopSound();
        if (tempTableId === state.activeGame && state.applicationVisibility) {
          GameAudio.getInstance().playAudio(
            !state.tableSettings.sound,
            BUTTON_SOUND,
            true,
            false
          );
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handlePreSelectedAutoAction: (state, action) => {
      const { tempTableId, preSelectedAction } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].autoAction = preSelectedAction;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleRepaintPotAmounts: (state, action) => {
      const { potWinners, tempTableId } = action.payload;
      const { potWinnersList } = potWinners;
      state.games[tempTableId].multiPotAmounts = potWinnersList;
    },

    handlePotWinner: (state, action) => {
      const { tempTableId } = action.payload;
      state.games[tempTableId].playerData.map((player, index) => {
        player.isSmallBlind = false;
        player.isBigBlind = false;
        player.isForcedBlind = false;
        player.lastAction =
          player.lastAction === FOLD_ACTION ? player.lastAction : undefined;
      });
      state.games[tempTableId].showDefaultActions = false;
      state.games[tempTableId].showAutoActions = false;
      state.games[tempTableId].isWinnerDeclared = true;
      state.games[tempTableId].gameEnded = true;
    },

    updateWinningPotDisplay: (state, action) => {
      const { tempTableId, pot } = action.payload;
      //console.log('Spruha log >>> Debug Log 3 ')
      let potData = { ...pot };
      potData.playerCoordinates = {};
      state.games[tempTableId].playerData.map((player, index) => {
        //console.log('Spruha log >>> Debug Log 4 ')
        if (pot?.winnerNames.includes(player.userName)) {
          player.isWinner = true;
          if (!isNaN(player.winningAmount)) {
            player.atTableAmount = pot.winners[player.userName]?.atTableAmount;
            player.winningAmount = pot.netWinningPlayers[player.userName];
          } else {
            player.winningAmount = undefined;
          }
          // Updating winner positions here within winningPotDisplay
          let playerPosition = state.games[tempTableId]?.playerPositions.find(
            (data) => data.position === player.position
          );
          potData.playerCoordinates[player.userName] = current(playerPosition);
          potData.playAnimation = state.activeGame === tempTableId;
        } else {
          player.isWinner = false;
        }
      });
      //console.log('Spruha log >>> Debug Log 5 ')
      //console.log('Spruha log >>> Updating the Winning Pot Display >>> ', potData);
      state.games[tempTableId].winningPotDisplay = potData;
      if (tempTableId === state.activeGame && state.applicationVisibility) {
        GameAudio.getInstance().playAudio(
          !state.tableSettings.sound,
          WINNER_SOUND,
          true,
          false
        );
      }
    },

    // Flex My Hand Reveal
    handleShowOtherPlayerCards: (state, action) => {
      const { tempTableId, cards, playerName } = action.payload;
      let playersData = state.games[tempTableId].playerData;
      let player = playersData.find((item) => item.userName === playerName);
      if (player) {
        // Add cards to player.cards, avoiding duplicates
        const newCards = cards?.length > 0 ? cards : [];
        // For Omaha/Omaha5, always set to the latest array from server to avoid duplicates
        player.cards = newCards;
        player.revealCard = true;
        player.showingCards = true;
      }
    },

    handleRevealOtherPlayerCards: (state, action) => {
      const { tempTableId, resultDetails } = action.payload;
      const { resultBroadcasts } = resultDetails;

      let tableData = state.games[tempTableId];

      if (resultBroadcasts.length > 0) {
        tableData.playerData.map((player) => {
          player.RITRequestAccepted = false;
          resultBroadcasts.map((detail) => {
            if (
              detail.playerName === player.userName &&
              player.isActive &&
              detail?.userCards?.length > 0 &&
              detail?.rankDetails?.handType &&
              detail?.rankDetails?.winningHand
            ) {
              player.cards = detail.userCards;
              player.revealCard = true;
              player.handType = getHandType(detail.rankDetails.handType);
              player.winningHand = detail.rankDetails.winningHand.split(",");
            }
          });
        });
      }
    },

    handleResult: (state, action) => {
      const { tempTableId, resultDetails } = action.payload;
      const { resultBroadcasts, playersAutoMuckDtls } = resultDetails;
      let tableData = state.games[tempTableId];
      let highestHandRank = 0;

      if (tableData) {
        tableData.winningHand = [];
        tableData.gameEnded = true;

        if (resultBroadcasts.length > 0) {
          tableData.playerData.map((player) => {
            player.RITRequestAccepted = false;
            player.lastAction =
              player.allIn || player.lastAction === FOLD_ACTION
                ? player.lastAction
                : undefined;
            resultBroadcasts.map((detail) => {
              if (
                detail.playerName === player.userName &&
                player.isActive &&
                detail?.rankDetails
              ) {
                highestHandRank = Math.max(
                  highestHandRank,
                  detail?.rankDetails?.rank
                );
                player.rankDetails = detail?.rankDetails;
              }

              if (detail.playerName === state.userDetails.userName) {
                tableData.happyHoursSavingForGame = detail?.happyHourSavings;
                // This is to disable show my cards feature since the user is a winner, his cards will be shown anyway
                if (detail.userCards?.length > 0) {
                  tableData.isUserWinner = true;
                }
              }

              // Below code is to handle auto muck scenario
              if (
                detail.playerName === player.userName &&
                (!detail?.userCards || !detail?.rankDetails) &&
                detail?.autoMuck
              ) {
                player.muckCards = true;
              }
            });
          });
        }
        tableData.playerTurn = false;
        // Below is the code to flag if the user is active on ANY table. This flag can be used in lobby to know if he is active on ATLEAST 1 table.
        state = checkIfIsPlayerTurnOnAnyTable(state);
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    // initiateNextGameStartRequest: (state, action) => {
    //   const { tempTableId, loggedInPlayerObject } = action.payload;
    //   let tableData = state.games[tempTableId];
    //   console.log("Inside if check Yashwnath TN TN ");
    //   if (tableData) {
    //     console.log("STEP 1 Inside if check Yashwnath TN TN ");
    //     const loggedInPlayerOnTheTable = state.games[
    //       tempTableId
    //     ].playerData.find(
    //       (eachPlayer) => eachPlayer.userName === loggedInPlayerObject.userName
    //     );
    //     if (
    //       loggedInPlayerObject.playerStatus === DELETED_PLAYER ||
    //       loggedInPlayerObject.playerStatus === TO_BE_DELETED_PLAYER
    //     ) { //DELETED_PLAYER & TO_BE_DELETED_PLAYER check not required here as they are checked during start of this method
    //       state.games[tempTableId].gameModal.type = DELETED_PLAYER_LOGOUT;
    //       state.games[tempTableId].gameModal.visible = true;
    //     }
    //     console.log("loggedInPlayerObject.isAllowLocation: ", loggedInPlayerObject.isAllowLocation);
    //     if (
    //       !loggedInPlayerObject.isAllowLocation &&
    //       state.games[tempTableId].gameDefinition.flavourType === LB_REAL
    //     ) {
    //       console.log("STEP 2 Inside if check Yashwnath TN TN ");
    //       state.games[tempTableId].gameModal.type =
    //         RESTRICTED_LOCATION_GAME_EXIT;
    //       state.games[tempTableId].gameModal.visible = true;
    //       TableUtils.getInstance().removeTableObserver(tempTableId, false);
    //     }
    //     if (
    //       loggedInPlayerOnTheTable &&
    //       !state.games[tempTableId].playerSitOutTimer &&
    //       !state.games[tempTableId].sitOutOption &&
    //       loggedInPlayerObject.playerStatus !== DELETED_PLAYER &&
    //       loggedInPlayerObject.playerStatus !== TO_BE_DELETED_PLAYER //DELETED_PLAYER & TO_BE_DELETED_PLAYER check not required here as they are checked during start of this method
    //     ) {
    //       sendNextGameProtocol({
    //         tempTableId: tempTableId,
    //         playerName: loggedInPlayerObject.userName,
    //       });
    //     }
    //   } else {
    //     showNoTableAvailableWarning(action);
    //   }
    // },

    initiateNextGameStartRequest: (state, action) => {
      const {
        tempTableId,
        loggedInPlayerObject,
        showDeletedPlayerAlert,
        showLocationRestrictionAlert,
        lockedBet,
      } = action.payload;
      console.log("NEXT GAME START REQUEST PAYLOAD:", action.payload);

      console.log("loggedInPlayerObject:", loggedInPlayerObject);
      let tableData = state.games[tempTableId];
      console.log("Inside if check Yashwnath TN TN ");
      if (tableData) {
        console.log("STEP 1 Inside if check Yashwnath TN TN ");

        if (showDeletedPlayerAlert) {
          //DELETED_PLAYER & TO_BE_DELETED_PLAYER check not required here as they are checked during start of this method
          state.games[tempTableId].gameModal.type = DELETED_PLAYER_LOGOUT;
          state.games[tempTableId].gameModal.visible = true;
        } else if (showLocationRestrictionAlert) {
          console.log("STEP 2 Inside if check Yashwnath TN TN ");
          state.games[tempTableId].gameModal.type =
            RESTRICTED_LOCATION_GAME_EXIT;
          state.games[tempTableId].gameModal.visible = true;
        } else if (lockedBet) {
          state.games[tempTableId].gameModal.type = LOCKED_BET;
          state.games[tempTableId].gameModal.visible = true;
        } else {
          const loggedInPlayerOnTheTable = state.games[
            tempTableId
          ].playerData.find(
            (eachPlayer) =>
              eachPlayer.userName === loggedInPlayerObject.userName
          );

          if (
            loggedInPlayerOnTheTable &&
            !state.games[tempTableId].playerSitOutTimer &&
            !state.games[tempTableId].sitOutOption &&
            loggedInPlayerObject.playerStatus !== DELETED_PLAYER &&
            loggedInPlayerObject.playerStatus !== TO_BE_DELETED_PLAYER //DELETED_PLAYER & TO_BE_DELETED_PLAYER check not required here as they are checked during start of this method
          ) {
            //deleted player checks in this if condition can be removed as they are handled in the higher up checks
            sendNextGameProtocol({
              tempTableId: tempTableId,
              playerName: loggedInPlayerObject.userName,
            });
          }
        }
        if (!state.games[tempTableId].isUserWinner) {
          sendShowCardsData({
            tempTableId: tempTableId,
            playerName: loggedInPlayerObject.userName,
            shownCards: state.games[tempTableId].shownCards,
            tableId: state.games[tempTableId].tableId,
            gameId: state.games[tempTableId].gameId,
          });
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    closeRebuyIn: (state, action) => {
      const { tempTableId } = action.payload;
      state.games[tempTableId].openRebuyInModal = false;
    },

    handleMaintenancePopup: (state, action) => {
      let { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];
      if (tableData) {
        state = processCleanTable(state, tempTableId);
        state.games[tempTableId].showMaintenancePopup = true;
        state.games[tempTableId].gameConnectionStatus =
          MATCH_MAKING_BET_DISABLED;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleAutoRebuySuccess: (state, action) => {
      const { tempTableId, playerName, Amount } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        let isFunGame = state.games[tempTableId]?.isFunGame;

        let updatedPlayerDetails = state.games[tempTableId].playerData.map(
          (eachPlayer) => {
            if (eachPlayer.userName === playerName) {
              eachPlayer.atTableAmount = Amount;
              return eachPlayer;
            } else {
              return eachPlayer;
            }
          }
        );
        state.games[tempTableId].playerData = updatedPlayerDetails;
        state.games[tempTableId].toastMessages.push({
          type: TOAST_SUCCESS,
          title: "Re-Buy Successful",
          message: isFunGame
            ? `You are back in the game with ${Amount} chips.`
            : `You are back in the game with ₹${Amount}.`,
        });
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleAutoRebuyBroadcast: (state, action) => {
      const { tempTableId, playerName, Amount } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        let updatedPlayerDetails = state.games[tempTableId].playerData.map(
          (eachPlayer) => {
            if (eachPlayer.userName === playerName) {
              eachPlayer.atTableAmount = Amount;
              return eachPlayer;
            } else {
              return eachPlayer;
            }
          }
        );
        state.games[tempTableId].playerData = updatedPlayerDetails;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleRebuyIn: (state, action) => {
      const { tempTableId, endTime } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (
          state.games[tempTableId].playerSeat !== undefined &&
          state.games[tempTableId].playerSeat !== null
        ) {
          state.games[tempTableId].openRebuyInModal = true;
          state.games[tempTableId].antiBanking.antiBankAmount = 0;
          state.games[tempTableId].antiBanking.isAntiBank = false;
          state.games[tempTableId].buyInTimeInSeconds = endTime;
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleDRebuyIn: (state, action) => {
      const { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].openRebuyInModal = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleRebuyFailure: (state, action) => {
      const { tempTableId, statusCode } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (statusCode === REBUY_INSUFFICIENT_FUNDS) {
          state.games[tempTableId].openInSufficientFundsModal = true;
          state.games[tempTableId].showInsufficientBalance = true;
        } else {
          state.games[tempTableId].openRebuyInModal = false;
          state.games[tempTableId].toastMessages.push({
            type: TOAST_ERROR,
            title: "Re-Buyin Error",
            message: "Something wen't wrong. We're on it.",
          });
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleRebuySuccessAck: (state, action) => {
      const { tempTableId, Amount, playerName, statusCode } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        let isFunGame = state.games[tempTableId]?.isFunGame;

        let updatedPlayersData = state.games[tempTableId].playerData.map(
          (player) => {
            if (player.userName === playerName) {
              player.atTableAmount = Amount;
              return player;
            } else {
              return player;
            }
          }
        );
        state.games[tempTableId].playerData = [...updatedPlayersData];
        state.games[tempTableId].openRebuyInModal = false;
        if (statusCode === 403) {
          state.games[tempTableId].toastMessages.push({
            type: TOAST_INFO,
            title: "Re-Buyin Pending",
            message: `Rebuy-in will be processed after game start.`,
          });
        } else if (statusCode === 501) {
          state.games[tempTableId].toastMessages.push({
            type: TOAST_SUCCESS,
            title: "Re-Buyin Success",
            message: isFunGame
              ? `You are back in the game with ${Amount} chips.`
              : `You are back in the game with ₹${Amount}.`,
          });
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleRebuySuccessBroadcast: (state, action) => {
      const { tempTableId, Amount, playerName } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        let updatedPlayersData = state.games[tempTableId].playerData.map(
          (player) => {
            if (player.userName === playerName) {
              player.atTableAmount = Amount;
              return player;
            } else {
              return player;
            }
          }
        );
        state.games[tempTableId].playerData = [...updatedPlayersData];
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleAutoRebuyFailure: (state, action) => {
      const { tempTableId, statusCode } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (statusCode === REBUY_INSUFFICIENT_FUNDS) {
          state.games[tempTableId].openInSufficientFundsModal = true;
        } else if (statusCode === REBUY_OTHER) {
          state.games[tempTableId].toastMessages.push({
            type: TOAST_ERROR,
            title: "Auto Re-Buyin Error",
            message: "Something wen't wrong. We're on it.",
          });
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    updateTopupModalOpenStatus: (state, action) => {
      const { isOpen, tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].openTopupModal = isOpen;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    initiateTopupRequest: (state, action) => {
      const { tempTableId, topUpAmount } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        let requestPayload = {
          topUpAmount: topUpAmount,
        };
        let gameConnections = GameConnections.getInstance();
        let activeGameConnection =
          gameConnections.getGameConnection(tempTableId);
        if (activeGameConnection && activeGameConnection.messageHandler) {
          activeGameConnection.gameClientListener.requestTopup(requestPayload);
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTopupSuccessAck: (state, action) => {
      const {
        tempTableId,
        status,
        playerName,
        atTableAmount,
        amountToBeDebited,
      } = action.payload;

      let tableData = state.games[tempTableId];

      if (tableData) {
        let isFunGame = state.games[tempTableId]?.isFunGame;

        if (status === "SUCCESS") {
          let updatedPlayerData = state.games[tempTableId].playerData.map(
            (eachPlayer) => {
              if (eachPlayer.userName === playerName) {
                eachPlayer.atTableAmount = atTableAmount;
                if (amountToBeDebited) {
                  state.games[tempTableId].toastMessages.push({
                    type: TOAST_SUCCESS,
                    title: "Top Up Successful",
                    message: isFunGame
                      ? `You added ${amountToBeDebited} chips to your stack.`
                      : `You added ₹${amountToBeDebited} to your stack.`,
                  });
                } else {
                  state.games[tempTableId].toastMessages.push({
                    type: TOAST_SUCCESS,
                    title: "Top Up Successful",
                    message: isFunGame
                      ? `Your stack is now ${atTableAmount} chips.`
                      : `Your stack is now ₹${atTableAmount}.`,
                  });
                }
                return eachPlayer;
              } else {
                return eachPlayer;
              }
            }
          );
          state.games[tempTableId].playerData = [...updatedPlayerData];
          state.games[tempTableId].openTopupModal = false;
          state.games[tempTableId].topUpPending = false;
        } else if (status === "PENDING") {
          state.games[tempTableId].openTopupModal = false;
          state.games[tempTableId].toastMessages.push({
            type: TOAST_INFO,
            title: "Topup Pending",
            message: `Your top up will be processed soon.`,
          });
          state.games[tempTableId].topUpPending = true;
        } else if (status === "CANCELLED") {
          state.games[tempTableId].topUpPending = false;
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTopupBroadcast: (state, action) => {
      const { tempTableId, playerName, atTableAmount } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        let updatedPlayerData = state.games[tempTableId].playerData.map(
          (eachPlayer) => {
            if (eachPlayer.userName === playerName) {
              eachPlayer.atTableAmount = atTableAmount;
              return eachPlayer;
            } else {
              return eachPlayer;
            }
          }
        );
        state.games[tempTableId].playerData = [...updatedPlayerData];
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTopupFailure: (state, action) => {
      const { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].toastMessages.push({
          type: TOAST_ERROR,
          title: "Topup Failure",
          message: `Something wen't wrong, we're on it.`,
        });
        state.games[tempTableId].openTopupModal = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTopupCancel: (state, action) => {
      const { tempTableId } = action.payload;
      // Not showing the toast message in the case of *AUTO* top up cancellation. This is because it will show up every hand.
      // IM-2306
      if (action.payload?.isAutoTopUp) {
      }
      let tableData = state.games[tempTableId];
      if (tableData) {
        // state.games[tempTableId].toastMessages.push({
        //   type: TOAST_INFO,
        //   title: "Topup Inapplicable",
        //   message: `Your stack exceeds the max buy-in limit.`,
        // });
        state.games[tempTableId].openTopupModal = false;
        state.games[tempTableId].topUpPending = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleRevealCards: (state, action) => {
      const { tempTableId, revealCardsDetails } = action.payload;
      const { gameStage, revealCard } = revealCardsDetails;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].gameStage = gameStage;
        state.games[tempTableId].doCommunityCardsExist = true;
        if (gameStage !== GAME_STAGE_SHOWDOWN) {
          state.games[tempTableId].showCommunityCardsImmediately = false;
        } else {
          if (!state.showGameTable) {
            state.games[tempTableId].showCommunityCardsImmediately = true;
          }
        }

        if (gameStage === GAME_STAGE_FLOP) {
          state.games[tempTableId].communityCards = revealCard;
        } else if (gameStage === GAME_STAGE_TURN) {
          let prevcards = state.games[tempTableId].communityCards.filter(
            (eachCard) => eachCard !== "cardBack"
          );
          state.games[tempTableId].communityCards = [
            ...prevcards,
            ...revealCard,
          ];
        } else if (gameStage === GAME_STAGE_RIVER) {
          let prevcards = state.games[tempTableId].communityCards.filter(
            (eachCard) => eachCard !== "cardBack"
          );

          state.games[tempTableId].communityCards = [
            ...prevcards,
            ...revealCard,
          ];
        } else if (gameStage === GAME_STAGE_SHOWDOWN) {
          state.games[tempTableId].communityCards = [...revealCard];
        }

        let updatedPlayerDetails = state.games[tempTableId].playerData.map(
          (eachPlayer) => {
            // not resetting last action whenever a player folds, call/raise actions are being reset in  resetLastActionBeforeCardReveals
            eachPlayer.lastAction = eachPlayer.isFolded
              ? eachPlayer.lastAction
              : undefined;
            eachPlayer.betAmount =
              (eachPlayer.allIn && gameStage === GAME_STAGE_SHOWDOWN) ||
                gameStage === GAME_STAGE_SHOWDOWN
                ? eachPlayer.betAmount
                : 0;
            eachPlayer.startTableTimer = false;
            eachPlayer.tableTimer = 0;
            eachPlayer.activeTableTimerType = "";
            eachPlayer.remainingTime = false;
            eachPlayer.showBlindIcon = false;

            return eachPlayer;
          }
        );
        state.games[tempTableId].playerData = updatedPlayerDetails;
        state.games[tempTableId].autoAction = state.games[tempTableId]
          .playerWaitingPosition
          ? state.games[tempTableId].autoAction
          : "";
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleRITRequest: (state, action) => {
      const { tempTableId, duration, endTime } = action.payload;
      const tableData = state.games[tempTableId];
      tableData.RITRequestDuration = duration;
      tableData.RITRequestEndTime = endTime;
      tableData.RITRequest = true;
    },

    handleRITReject: (state, action) => {
      const { tempTableId, players } = action.payload;
      const tableData = state.games[tempTableId];
      tableData.RITRequest = false;
      if (
        players &&
        players?.length > 0 &&
        state.userDetails.userName !== players[0]
      ) {
        state.games[tempTableId].toastMessages.push({
          type: TOAST_INFO,
          title: "RIT Request Rejected",
          message: `${players} has declined the request.`,
        });
      }
    },

    handleRITAccept: (state, action) => {
      const { tempTableId, playerName } = action.payload;
      const tableData = state.games[tempTableId];
      const player = tableData.playerData.find(
        (player) => player.userName === playerName
      );
      if (player) {
        player.RITRequestAccepted = true;
        player.lastAction = null;
        player.allIn = null;
      }
    },

    setRITRequest: (state, action) => {
      const { tempTableId, value } = action.payload;
      const tableData = state.games[tempTableId];
      tableData.RITRequest = value;
    },

    handleRITRevealCards: (state, action) => {
      const { tempTableId, revealCardsDetails } = action.payload;
      const { gameStage, revealCard } = revealCardsDetails;
      let tableData = state.games[tempTableId];
      tableData.winningPotDisplay = undefined;
      if (tableData.RITRequest) {
        tableData.isWinnerDeclared = false;
      }

      if (tableData) {
        state.games[tempTableId].gameStage = gameStage;
        if (gameStage !== GAME_STAGE_SHOWDOWN) {
          state.games[tempTableId].showCommunityCardsImmediately = false;
        } else {
          if (!state.showGameTable) {
            state.games[tempTableId].showCommunityCardsImmediately = true;
          }
        }
        const existingCards = state.games[tempTableId].communityCards;

        // Create array of 5 'cardBack' items, then replace end elements with revealed cards
        const communityCards = Array(5).fill("cardBack");
        const filteredRevealCards = revealCard.map((card) =>
          existingCards.includes(card) ? "cardBack" : card
        );
        const startIndex = Math.max(0, 5 - filteredRevealCards.length);
        communityCards.splice(
          startIndex,
          filteredRevealCards.length,
          ...filteredRevealCards
        );
        state.games[tempTableId].RITCommunityCards = communityCards;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTableTimerChangeRequest: (state, action) => {
      const { tempTableId, position, time, maxTime } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        let playerSeat = state.games[tempTableId].playerSeat;
        let updatedPlayerDetails = state.games[tempTableId].playerData.map(
          (eachPlayer) => {
            if (eachPlayer.position === position) {
              if (playerSeat !== position) {
                eachPlayer.tableTimer = time;
                eachPlayer.totalTime = time;
                eachPlayer.maxTurnTimer = maxTime;
                eachPlayer.startTableTimer = true;
                eachPlayer.activeTableTimerType = PLAYER_DEFAULT_TIMER;
                eachPlayer.remainingTime = false;
              }
              return eachPlayer;
            } else {
              eachPlayer.startTableTimer = false;
              eachPlayer.tableTimer = 0;
              eachPlayer.activeTableTimerType = "";
              eachPlayer.remainingTime = false;
              return eachPlayer;
            }
          }
        );
        state.games[tempTableId].playerData = updatedPlayerDetails;
        state.games[tempTableId].playerTurn = position;
        // Below is the code to flag if the user is active on ANY table. This flag can be used in lobby to know if he is active on ATLEAST 1 table.
        state = checkIfIsPlayerTurnOnAnyTable(state);
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    processAutoTableSwitch: (state, action) => {
      let { tempTableId } = action.payload;
      // We do not need the autoTableSwitchSetting enabled to filter out the auto table switch array. Only when setting active tables, the function should be turned on.
      let autoTableSwitchingQueue = state.autoTableSwitchQueue;
      // Removing the game user acted on from autoTableSwitchingQueue
      autoTableSwitchingQueue = autoTableSwitchingQueue.filter(
        (id) => id !== tempTableId
      );
      state.autoTableSwitchQueue = autoTableSwitchingQueue;
      let isPlayerTurnOnCurrentTable = false;
      // If the length of the queue is greater than 0, then move the user to the next table in queue immediately
      if (
        autoTableSwitchingQueue.length > 0 &&
        state.tableSettings.autoTableSwitch &&
        !isPlayerTurnOnCurrentTable
      ) {
        if (autoTableSwitchingQueue[0] > state.activeGame) {
          state.swipeDirection = "left";
        } else {
          state.swipeDirection = "right";
        }
        if (state.games[state.autoTableSwitchQueue[0]]) {
          state.activeGame = state.autoTableSwitchQueue[0];
        } else {
          sendFaroLog({
            type: "autoTableSwitchFailure",
            state,
          });
        }
      }
    },

    handlePlayerExtraTime: (state, action) => {
      const { tempTableId, playerName, timeBank, position } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        let updatedPlayerDetails = state.games[tempTableId].playerData.map(
          (eachPlayer) => {
            if (
              eachPlayer.userName === playerName &&
              eachPlayer.position === position
            ) {
              eachPlayer.maxTurnTimer = timeBank;
              eachPlayer.startTableTimer = true;
              eachPlayer.tableTimer = timeBank;
              eachPlayer.totalTime = timeBank;
              eachPlayer.remainingTime = timeBank;
              eachPlayer.activeTableTimerType = PLAYER_EXTRA_TIMER;
              return eachPlayer;
            } else {
              eachPlayer.tableTimer = 0;
              eachPlayer.maxTurnTimer = 0;
              eachPlayer.startTableTimer = false;
              eachPlayer.remainingTime = 0;
              eachPlayer.activeTableTimerType = "";
              return eachPlayer;
            }
          }
        );
        state.games[tempTableId].playerData = updatedPlayerDetails;
        state.games[tempTableId].playerTurn = position;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handlePlayerExtraTimeLeft: (state, action) => {
      const { tempTableId, playerName, extraTimeLeft } = action.payload;
      let tableData = state.games[tempTableId];
      if (tableData) {
        let updatedPlayerDetails = state.games[tempTableId].playerData.map(
          (player) => {
            if (player.userName === playerName) {
              player.extraTimeLeft = extraTimeLeft;
            }
            return player;
          }
        );
        state.games[tempTableId].playerData = updatedPlayerDetails;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    removePlayerFromTable: (state, action) => {
      const { tempTableId, userName } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        let updatedPlayersData = state.games[tempTableId].playerData.filter(
          (eachPlayer) => eachPlayer.userName !== userName
        );
        state.games[tempTableId].playerData = updatedPlayersData;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    setPlayerRemainingTime: (state, action) => {
      const { tempTableId, remainingTime, playerPosition } = action.payload;

      let tableData = state.games[tempTableId];

      if (tableData) {
        let playersData = state.games[tempTableId]?.playerData;
        if (playersData && playersData.length > 0) {
          if (remainingTime <= 0) {
            GameAudio.getInstance().stopSound();
          }
          let modifiedPlayerData = playersData.find(
            (player) => player.position === playerPosition
          );
          if (modifiedPlayerData) {
            modifiedPlayerData.remainingTime = remainingTime;
          }
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    setTableTheme: (state, action) => {
      state.themeData.table = action.payload;
    },

    setTableBackground: (state, action) => {
      state.themeData.background = action.payload;
    },

    setCardDeck: (state, action) => {
      state.themeData.cardDeck = action.payload;
    },

    setCardBack: (state, action) => {
      state.themeData.cardBack = action.payload;
    },

    setCardSize: (state, action) => {
      state.themeData.cardSize = action.payload;
    },

    toggleHandStrength: (state) => {
      if (state.tableSettings.sound) {
        GameAudio.getInstance().stopSound();
        GameAudio.getInstance().playAudio(
          !state.tableSettings.sound,
          BUTTON_SOUND,
          true,
          false
        );
      }
      state.tableSettings.showHandStrength =
        !state.tableSettings.showHandStrength;
    },

    toggleAutoTableSwitch: (state) => {
      state.tableSettings.autoTableSwitch =
        !state.tableSettings.autoTableSwitch;
      if (!state.tableSettings.autoTableSwitch) {
        state.autoTableSwitchQueue = [];
      }
      if (state.tableSettings.sound) {
        GameAudio.getInstance().stopSound();
        GameAudio.getInstance().playAudio(
          !state.tableSettings.sound,
          BUTTON_SOUND,
          true,
          false
        );
      }
    },

    toggleDisplayInBB: (state, action) => {
      //state = cloneDeep(current(state));
      state.tableSettings.BBDisplay = !state.tableSettings.BBDisplay;
      if (state.tableSettings.sound) {
        GameAudio.getInstance().stopSound();
        GameAudio.getInstance().playAudio(
          !state.tableSettings.sound,
          BUTTON_SOUND,
          true,
          false
        );
      }
      if (
        state.tableSettings.BBDisplay &&
        action.payload &&
        action.payload?.playVibration
      ) {
        state.games[state.activeGame].toastMessages.push({
          type: TOAST_INFO,
          title: "BB Display - ON",
          message: "Your chips are now displayed in BB.",
        });
      } else if (
        !state.tableSettings.BBDisplay &&
        action.payload &&
        action.payload?.playVibration
      ) {
        state.games[state.activeGame].toastMessages.push({
          type: TOAST_INFO,
          title: "BB Display - OFF",
          message: "Your chips are no longer displayed in BB.",
        });
      }
      if (action.payload && action.payload?.playVibration) {
        GameAudio.getInstance().stopSound();
        GameAudio.getInstance().playVibration(VIBRATE_HEAVY);
      }
    },

    toggleSmartGestures: (state) => {
      state.tableSettings.smartGestures = !state.tableSettings.smartGestures;
      if (state.tableSettings.smartGestures) {
        state.tableSettings.smartGestureOptions.smartCheck = true;
        state.tableSettings.smartGestureOptions.smartFold = true;
      } else {
        state.tableSettings.smartGestureOptions.smartCheck = false;
        state.tableSettings.smartGestureOptions.smartFold = false;
      }
      if (state.tableSettings.sound) {
        GameAudio.getInstance().stopSound();
        GameAudio.getInstance().playAudio(
          !state.tableSettings.sound,
          BUTTON_SOUND,
          true,
          false
        );
      }
    },

    toggleSmartFold: (state) => {
      let smartGestureOptions = state.tableSettings.smartGestureOptions;
      smartGestureOptions.smartFold = !smartGestureOptions.smartFold;
      if (!smartGestureOptions.smartFold && !smartGestureOptions.smartCheck) {
        state.tableSettings.smartGestures = false;
      }
    },

    toggleSmartCheck: (state) => {
      let smartGestureOptions = state.tableSettings.smartGestureOptions;
      smartGestureOptions.smartCheck = !smartGestureOptions.smartCheck;
      if (!smartGestureOptions.smartFold && !smartGestureOptions.smartCheck) {
        state.tableSettings.smartGestures = false;
      }
    },

    toggleAutoMuck: (state) => {
      state.tableSettings.autoMuck = !state.tableSettings.autoMuck;

      GameAudio.getInstance().stopSound();
      GameAudio.getInstance().playAudio(
        !state.tableSettings.sound,
        BUTTON_SOUND,
        true,
        false
      );
    },

    toggleAutoRebuy: (state) => {
      state.tableSettings.autoRebuy = !state.tableSettings.autoRebuy;

      GameAudio.getInstance().stopSound();
      GameAudio.getInstance().playAudio(
        !state.tableSettings.sound,
        BUTTON_SOUND,
        true,
        false
      );
    },

    toggleAutoBuyIn: (state) => {
      state.tableSettings.autoBuyIn.enabled =
        !state.tableSettings.autoBuyIn.enabled;
      GameAudio.getInstance().stopSound();
      GameAudio.getInstance().playAudio(
        !state.tableSettings.sound,
        BUTTON_SOUND,
        true,
        false
      );
    },

    setAutoBuyInPercentage: (state, action) => {
      const { percentage } = action.payload;
      state.tableSettings.autoBuyIn.percentage = percentage;
    },

    toggleAutoTopup: (state) => {
      state.tableSettings.autoTopupConfig.enabled =
        !state.tableSettings.autoTopupConfig.enabled;

      GameAudio.getInstance().stopSound();
      GameAudio.getInstance().playAudio(
        !state.tableSettings.sound,
        BUTTON_SOUND,
        true,
        false
      );
    },

    handleAutoTopupFallsBelowSliderChange: (state, action) => {
      const { value } = action.payload;
      state.tableSettings.autoTopupConfig.fallsBelowAmount = value;
      state.tableSettings.autoTopupConfig.topUpAmount = Math.max(10, value);
    },

    handleAutoTopupSliderChange: (state, action) => {
      const { value } = action.payload;
      state.tableSettings.autoTopupConfig.topUpAmount = value;
    },

    handleShowEomjiToggle: (state, action) => {
      const { value } = action.payload;
      state.tableSettings.showEmojis = value;
    },
    handleShowThrowableToggle: (state, action) => {
      const { value } = action.payload;
      state.tableSettings.showThrowables = value;
    },

    toggleSound: (state) => {
      const updatedToggleValue = !state.tableSettings.sound;
      GameAudio.getInstance().stopSound();
      if (updatedToggleValue) {
        GameAudio.getInstance().playAudio(false, BUTTON_SOUND, true, false);
      }
      state.tableSettings.sound = updatedToggleValue;
      setToLocalStorage(IS_SOUND_ENABLED, updatedToggleValue);
    },

    toggleHaptics: (state) => {
      const updatedToggleValue = !state.tableSettings.haptics;
      GameAudio.getInstance().stopSound();
      if (updatedToggleValue) {
        GameAudio.getInstance().playVibration(VIBRATE_HEAVY);
      }
      if (state.tableSettings.sound) {
        GameAudio.getInstance().playAudio(
          !state.tableSettings.sound,
          BUTTON_SOUND,
          true,
          false
        );
      }
      state.tableSettings.haptics = updatedToggleValue;
      setToLocalStorage(IS_HAPTICS_EBABLED, updatedToggleValue);
    },

    updateGameTableBoundingRect: (state, action) => {
      const { tempTableId, positions } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        try {
          let dimensions = JSON.parse(positions);
          state.games[tempTableId].gameTableDimensions = dimensions;
        } catch (err) {
          console.log("Error in updating bounding client rect:", err);
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    updatePlayerPositionsOnTable: (state, action) => {
      const { tempTableId, positions } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].playerPositions = positions;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    changeTableOrientation: (state, action) => {
      let orientation = action?.payload?.orientation;
      if (orientation) {
        state.tableOrientation = orientation;
      } else {
        if (state.tableOrientation === PORTRAIT) {
          state.tableOrientation = LANDSCAPE;
        } else {
          state.tableOrientation = PORTRAIT;
        }
      }
    },

    updateActiveGame: (state, action) => {
      state.activeGame = action.payload;
      state.visibleGameTables = [state.activeGame];
    },

    acknowledgePlayerMovedToCenter: (state, action) => {
      let { playerMovedToCenter, tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].playerMovedToCenter = playerMovedToCenter;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    watchAllGameTables: (state, action) => {
      if (!state?.timerObserver) {
        let observer = new TimerObserver(
          action.payload.dispatchFunction,
          state.games
        );
        state.timerObserve = observer;
      }
      state?.timerObserver?.timeoutHandler();
    },

    hideGameTable: (state, action) => {
      try {
        let { tempTableId } = action.payload;
        if (tempTableId) {
          let game = state.games[tempTableId];
          if (
            game.communityCards.length > 0 ||
            game.RITCommunityCards.length > 0
          ) {
            game.showCommunityCardsImmediately = true;
          }
        }
      } catch (err) {
        console.log("TempTableId not passed in hide game table function");
      }
      state.swipeDirection = undefined;
      state.showGameTable = false;
    },

    showGameTable: (state) => {
      state.swipeDirection = undefined;
      state.showGameTable = true;
      state?.timerObserver?.cleanup();
      state.timerObserver = null;
    },

    cleanUpTableObservers: (state) => {
      state?.timerObserver?.cleanup();
      state.timerObserver = null;
    },

    closeGameWindow: (state, action) => {
      let processedState = processCloseGameWindow(current(state), action);
      return processedState;
    },

    processReconnectionAck: (state, action) => {
      const { tempTableId, gameId, playerName, tableId, latestGameId } =
        action.payload;

      let tableData = state.games[tempTableId];

      if (tableData) {
        //let tableData = cloneDeep(tableData);

        if (tableData.gameId !== gameId) {
          console.log(
            "Local table data gameId and received 'gameId' key value is mismatched at reconnection ack"
          );
        }

        if (tableData.gameId !== latestGameId) {
          console.log(
            "Local table data gameId and received 'latestGameId' key value is mismatched at reconnection ack"
          );
          tableData.gameId = latestGameId;
        }
        if (tableId) {
          tableData.tableId = tableId;
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    closeFailedGameTable: (state, action) => {
      let games = state.games;
      let { tempTableId } = action.payload;
      let arrayOfGames = Object.keys(games);
      try {
        TableUtils.getInstance().removeTableObserver(tempTableId);
      } catch (err) {
        console.log(
          "Error in removing table observer. Game connection probably does not exist. ",
          err
        );
      }
      // Checking if more than 1 game is created, if so, navigating to the other active game.
      if (arrayOfGames.length > 1) {
        arrayOfGames = arrayOfGames.filter((game) => game !== tempTableId);
        state.activeGame = arrayOfGames[0];
      } else {
        state.activeGame = null;
      }
      delete games[tempTableId];
      state.games = games;
    },

    closeExistingTourneyGameTable: (state, action) => {
      const { tourneyId } = action.payload;

      let games = state.games;
      if (games && Object.keys(games).length > 0) {
        let arrayOfGames = Object.keys(games);
        arrayOfGames.forEach((eachTempTableId) => {
          let currentGame = games[eachTempTableId];
          if (
            currentGame?.isTourneyGame &&
            currentGame?.gameDefinition.tourneyId === tourneyId
          ) {
            TableUtils.getInstance().removeTableObserver(eachTempTableId);
          }
        });
      }
    },

    deleteGameTable: (state, action) => {
      let games = state.games;
      let { tempTableId } = action.payload;
      // Checking if more than 1 game is created, if so, navigating to the other active game.
      if (games[tempTableId]) {
        let arrayOfGames = Object.keys(games);
        if (arrayOfGames.length > 1) {
          arrayOfGames = arrayOfGames.filter((game) => game !== tempTableId);
          state.activeGame = arrayOfGames[0];
        } else {
          state.activeGame = null;
          state.swipeDirection = undefined;
          state.showGameTable = false;
        }
        sendFaroLog({
          type: "DELETING_GAME_TABLE",
          tempTableId: tempTableId,
          removingGameDetails: games[tempTableId],
        });
        delete games[tempTableId];
        state.games = games;
      } else {
        showNoTableAvailableWarning(action);
      }

      state.autoTableSwitchQueue = state.autoTableSwitchQueue.filter(
        (id) => id !== tempTableId
      );
    },

    exitGameTable: (state, action) => {
      const { tempTableId, playerName } = action.payload;

      let tableData = state.games[tempTableId];

      if (tableData) {
        let gameConnection =
          GameConnectionsN?.getInstance()?.getGameConnection(tempTableId);
        if (gameConnection) {
          const requestPayload = {
            playerName: playerName,
            tableId: tableData.tableId,
            gameDefId: tableData.gameDefinition.gameDefId,
          };
          if (tableData.isTourneyGame) {
            requestPayload["isWatchPlayer"] = tableData.watchPlayer;
          }
          gameConnection.listener.close(requestPayload);
        } else {
          //Note: As game connection is not available we are not restricting user from eixt table, we manually deleting the table and making him exit.
          TableUtils.getInstance()?.removeTableObserver(tempTableId);
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    leaveTableSeat: (state, action) => {
      let { tempTableId, playerName } = action.payload;

      let gameConnections = GameConnections.getInstance();
      let activeGameConnection = gameConnections.getGameConnection(
        state.activeGame
      );

      if (activeGameConnection && activeGameConnection.messageHandler) {
        let activeGameTable = state.games[tempTableId];
        if (activeGameTable) {
          const { tableId } = activeGameTable;
          const { gameDefId } = activeGameTable.gameDefinition;
          activeGameConnection.gameClientListener.leaveSeat({
            playerName: playerName,
            tableId: tableId,
            gameDefId: gameDefId,
          });
        } else {
          showNoTableAvailableWarning(action);
        }
      }
    },

    joinGameTable: (state, action) => {
      state.tableBlur = true;
      let gameDefinition = action.payload;
      let bigBlind = gameDefinition.bigBlind;

      let currentGames = state.games;
      let sameBlindWatchTable = undefined;
      let sameBlindTempTableId;

      for (let game in currentGames) {
        sameBlindTempTableId =
          state.games[game].gameDefinition.bigBlind === bigBlind &&
          !game.watchPlayer;
        if (sameBlindTempTableId) {
          sameBlindWatchTable = game;
        }
      }
      let gameJoinCheckObject = {
        createNewGameTable:
          sameBlindWatchTable === undefined
            ? true
            : sameBlindWatchTable
              ? false
              : true,
        tempTableId: sameBlindWatchTable ? sameBlindWatchTable : null,
      };
      state.gameJoinCheckObject = gameJoinCheckObject;
    },

    handleStartGameTimer: (state, action) => {
      const { tempTableId, startGameTime } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].showStartGameTimer = true;
        state.games[tempTableId].startGameTimerValue = startGameTime;
        state.games[tempTableId].disableOrientationChange = true;
        state.games[tempTableId].shouldPlayCardAnimation = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    disableStartGameTimer: (state, action) => {
      const { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].showStartGameTimer = false;
        state.games[tempTableId].startGameTimerValue = 0;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleStartGame: (state, action) => {
      const {
        tempTableId,
        userCards,
        smallBlindAmount,
        bigBlindAmount,
        playersSeatData,
        gameId,
        tableId,
        anteUserInvestments,
        anteAmount,
        happyHoursEnabled,
        happyHoursRake,
        happyHoursHeadsUpRake,
      } = action.payload;
      let tableData = state.games[tempTableId];

      state.games[tempTableId].happyHoursEnabled = happyHoursEnabled;
      state.games[tempTableId].happyHoursSavingForGame = null;
      state.games[tempTableId].showCommunityCardsImmediately = false;
      state.games[tempTableId].RITRequest = false;
      state.games[tempTableId].gameDefinition.happyHoursRake = happyHoursRake;
      state.games[tempTableId].gameEnded = false;
      state.games[tempTableId].gameDefinition.happyHoursHeadsUpRake =
        happyHoursHeadsUpRake;
      if (happyHoursEnabled && !state.games[tempTableId].showHappyHoursToast) {
        state.games[tempTableId].showHappyHoursToast = true;
        state.games[tempTableId].toastMessages.push({
          type: TOAST_SUCCESS,
          title: "Happy Hours!",
          message: "Happy Hour has started on this table, Enjoy low rake!",
        });

        if (doesExist(state.games[tempTableId].playerSeat)) {
          state.games[tempTableId].showHappyHoursButton = true;
        }
      }

      state.games[tempTableId].happyHourSavings = null;

      if (state.games[tempTableId].showHappyHoursToast && !happyHoursEnabled) {
        state.games[tempTableId].toastMessages.push({
          type: TOAST_INFO,
          title: "Happy Hour Ended",
          message: "Low rakes are no longer applicable on this table.",
        });
        state.games[tempTableId].showHappyHoursToast = false;
      }

      if (tableData) {
        let displayNameMap = tableData.displayNameMap || {};
        let oldPlayerStatsData = {};
        state.games[tempTableId].playerData.map((player, index) => {
          let dataObject = {
            enabledPlayerStats: player?.enabledPlayerStats
              ? player?.enabledPlayerStats
              : false,
            colorCode: player?.colorCode ? player?.colorCode : null,
            playerNotes: player?.playerNotes ? player?.playerNotes : null,
            playerName: player?.userName,
          };
          oldPlayerStatsData[player.userName] = dataObject;
        });
        let activeplayers = 0;
        let sitoutplayers = 0;
        let updatedPlayersData = playersSeatData.map((eachPlayer) => {
          if (eachPlayer.playerName) {
            displayNameMap[eachPlayer.playerName] = eachPlayer.displayName;
          }
          if (eachPlayer?.playerStatus === 303) {
            activeplayers += 1;
          } else {
            sitoutplayers += 1;
          }
          // This is added to make sure playerSeat is never empty. Especially in the edge case of IM-690.
          // Edge case is described in the description of the ticket.
          if (eachPlayer.playerName === state.userDetails.userName) {
            state.games[tempTableId].playerSeat = eachPlayer.position;
            state.games[tempTableId].playerSeatBeforeLeaveSeat =
              eachPlayer.position;

            // This is to mark top up pending as false incase his at table amount is greater than max buy in.
            // Either it has been successfully processed, or he won previous hand.
            if (
              eachPlayer?.atTableAmount >
              state.games[tempTableId]?.gameDefinition?.maxbuyInAmount
            ) {
              state.games[tempTableId].topUpPending = false;
            }
          }

          let playerDetails = {
            position: eachPlayer.position,
            userName: eachPlayer.playerName,
            atTableAmount: eachPlayer.atTableAmount,
            acelevel: eachPlayer.aceLevel,
            avatar: eachPlayer.profilePic,
            isReservedSeat: false,
            isTakenSeat: true,
            isActive: eachPlayer.playerStatus === ACTIVE,
            isFolded: false,
            isWinner: false,
            allIn: eachPlayer.gamePlayerStatus === ALL_IN ? true : false,
            sitOutOption:
              eachPlayer.gamePlayerStatus === SEATED_OUT ? true : false,
            isWaitingForBigBlind:
              eachPlayer.gamePlayerStatus === WAITING_FOR_BB,
            gamePlayerStatus: eachPlayer.gamePlayerStatus,
            playerStatus: eachPlayer.playerStatus,
            totalScore: eachPlayer.totalScore,
            lastAction: "",
            isSmallBlind: eachPlayer.isSmallBlind,
            isBigBlind: eachPlayer.isBigBlind,
            isForcedBlind: eachPlayer.isForcedBlind,
            betAmount: eachPlayer.userInvestment,
            isDealer: eachPlayer.isDealer,
            bountyAmount: eachPlayer?.bountyAmount,
            winningAmount: 0,
            cards:
              state.games[tempTableId].playerSeat === eachPlayer.position
                ? userCards
                : [],
            startTableTimer: false,
            activeTableTimerType: "",
            tableTimer: 0,
            revealCard: false,
            showingCards: false,
            showBlindIcon: true,
            enabledPlayerStats: oldPlayerStatsData[eachPlayer.playerName]
              ?.enabledPlayerStats
              ? oldPlayerStatsData[eachPlayer.playerName].enabledPlayerStats
              : false,
            colorCode: oldPlayerStatsData[eachPlayer.playerName]?.colorCode
              ? oldPlayerStatsData[eachPlayer.playerName]?.colorCode
              : null,
            playerNotes: oldPlayerStatsData[eachPlayer.playerName]?.playerNotes
              ? oldPlayerStatsData[eachPlayer.playerName]?.playerNotes
              : null,
            muckCards: false,
            winningAmount: 0,
            RITRequestAccepted: false,
          };
          return playerDetails;
        });
        tableData.isTableCleaned = false;
        tableData.gameStage = GAME_STAGE_PRE_FLOP;
        tableData.smallBlindAmount = smallBlindAmount; //I see this is not used anywhere @yashwanth
        tableData.gameDefinition.smallBlind = smallBlindAmount; //updating small blind of game definition
        tableData.bigBlindAmount = bigBlindAmount; //I see this is not used anywhere @yashwanth
        tableData.gameDefinition.bigBlind = bigBlindAmount; //updating big blind of game definition
        tableData.playerData = updatedPlayersData;
        tableData.isWinnerDeclared = false;
        tableData.isGameStarted =
          tableData.isTourneyGame && anteUserInvestments ? false : true;
        tableData.showStartGameTimer = false;
        tableData.doCommunityCardsExist = false;
        tableData.restrictUserFromLeavingTable = false;
        tableData.restrictUserFromSitOut = false;
        tableData.startGameTime = -1;
        tableData.communityCards = [];
        tableData.RITCommunityCards = [];
        tableData.shownCards = [];
        tableData.showAllCards = false;
        tableData.isUserWinner = false;
        tableData.isRITEnabled = false;
        tableData.multiPotAmounts = [];
        tableData.gameId = gameId;
        tableData.tableId = tableId;
        tableData.showRankDetails = false;
        tableData.winningPotDisplay = undefined;
        tableData.totalPotAmt = undefined;
        tableData.winningHand = [];
        tableData.disableOrientationChange = true;
        tableData.revealCards = false;
        tableData.startWinnerPotAnimation = false;
        tableData.playerCards = userCards;
        state.games[tempTableId].shouldPlayCardAnimation = true;
        tableData.numberOfSidePots = 0;

        tableData.privateTable.showAutoStartMessage = false;
        tableData.privateTable.showMinPlayersJoinMessage = false;
        //  might have to change the condition
        if (userCards.length > 0) {
          tableData.playerStatus = ACTIVE;
          tableData.playerMovedToCenter = true;
        }
        if (state.tableSettings.haptics && tempTableId === state.activeGame) {
          GameAudio.getInstance().playVibration(VIBRATE_HEAVY);
        }
        if (state.tableSettings.sound && tempTableId === state.activeGame) {
          GameAudio.getInstance().playAudio(
            !state.tableSettings.sound,
            DEAL_SOUND,
            true,
            false
          );
        }

        if (
          !tableData.isTourneyGame &&
          tableData.playerSeat !== null &&
          tableData.playerSeat !== undefined
        ) {
          //Part of fix for IM-2504 issue.  We are requesting for refresh# when player took seat and in exact same time if we get start# , player data is not available in start#
          const isMySeatAvailable = playersSeatData.find(
            (eachSeatedPlayer) =>
              eachSeatedPlayer.position === tableData.playerSeat
          );
          if (!isMySeatAvailable) {
            sendRefreshProtocol({
              tempTableId: tempTableId,
              playerName: state.userDetails.userName,
              tableId: tableData.tableId,
              gameId: tableData.gameId,
              tourneyId: tableData.gameDefinition.tourneyId,
            });
          }
        }

        if (tableData.isTourneyGame && anteUserInvestments) {
          tableData.playerData.map((player) => {
            if (Object.keys(anteUserInvestments).includes(player.userName)) {
              player.betAmount = parseDecimalValuesOfNumber(
                anteUserInvestments[player.userName]
              );
              player.cards = []; // NOTE: we are making empty to avoid card dealing animation while playing ante amounts animation
              return player;
            }
            return player;
          });
        }
        state.games[tempTableId] = tableData;
        if (tableData.isTourneyGame) {
          state.games[tempTableId].restrictUserFromLeavingTable =
            tableData.watchPlayer ? false : true;
          state.games[tempTableId].anteAmount = anteAmount;
        }
        if (
          tableData.isTourneyGame &&
          state.games[tempTableId].activeTourneyBannerType !==
          TOURNEY_BANNER_MERGED_WITH_ANOTHER_TABLE
        ) {
          state.games[tempTableId].activeTourneyBannerType = null;
        }

        let gameConnection =
          GameConnectionsN.getInstance().getGameConnection(tempTableId);
        gameConnection.listener.setGameId(gameId);
        gameConnection.listener.setTableId(tableId);
        state.games[tempTableId].displayNameMap = displayNameMap;
        state.games[tempTableId].activeplayerCount = activeplayers;
        state.games[tempTableId].sitoutplayerCount = sitoutplayers;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    setShownCards: (state, action) => {
      const { tempTableId, card, playerCards } = action.payload;
      const gameTable = state.games[tempTableId];
      let shownCards = gameTable.shownCards;
      //console.log('Spruha log >>> Card Opted By User >>> ", card);
      if (
        shownCards.includes(card) &&
        gameTable.gameStage !== GAME_STAGE_SHOWDOWN &&
        !gameTable.isWinnerDeclared
      ) {
        shownCards = shownCards.filter((item) => item !== card);
      } else {
        shownCards = [...shownCards, card];
      }
      // if (
      //   gameTable.gameStage !== GAME_STAGE_SHOWDOWN &&
      //   !gameTable.isWinnerDeclared
      // ) {
      gameTable.shownCards = shownCards;
      // }
      if (playerCards.length === shownCards.length) {
        gameTable.showAllCards = true;
      } else {
        gameTable.showAllCards = false;
      }
    },

    toggleShowAllCards: (state, action) => {
      const { tempTableId, playerCards } = action.payload;
      const gameTable = state.games[tempTableId];
      if (gameTable.showAllCards) {
        gameTable.shownCards = [];
      } else {
        gameTable.shownCards = playerCards;
      }
      gameTable.showAllCards = !gameTable.showAllCards;
    },

    processPlayerStatsData: (state, action) => {
      let { data, tempTableId } = action.payload;
      let currentPlayerName = state.userDetails.userName;
      let playerStatData = data.filter(
        (item) => item.playerName === currentPlayerName
      )[0];
      let opponentData = null;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (playerStatData) {
          opponentData = state.games[tempTableId].playerData.find(
            (player) => player.userName === playerStatData.opponetName
          );
        }
        if (opponentData) {
          if (playerStatData?.enabledPlayerStats) {
            opponentData.enabledPlayerStats = true;
            opponentData.colorCode = playerStatData?.colorCode ?? null;
          } else {
            opponentData.enabledPlayerStats = false;
            opponentData.colorCode = null;
          }
          opponentData.playerNotes = playerStatData?.playerNotes;
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    processPlayerStatsOnDemand: (state, action) => {
      let { data, tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        let opponentData = state.games[tempTableId].playerData.find(
          (player) => player.userName === data?.opponetName
        );
        if (opponentData) {
          if (data?.enabledPlayerStats) {
            opponentData.enabledPlayerStats = true;
            opponentData.colorCode = data?.colorCode ? data?.colorCode : null;
          } else {
            opponentData.enabledPlayerStats = false;
            opponentData.colorCode = null;
          }
          opponentData.playerNotes = data?.playerNotes;
          window.sessionStorage.setItem(
            "player-profile-data",
            JSON.stringify(opponentData)
          );
          state.games[tempTableId].gameModal.type = PLAYER_STATS;
          state.games[tempTableId].gameModal.visible = true;
        } else {
          console.error("Player data does not exist for player stats.");
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    processPlayerStatsOnDemandFailure: (state, action) => {
      let { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].toastMessages.push({
          type: TOAST_ERROR,
          title: "Player Stats Error",
          message: "We couldn't retrieve the player stats, we're on it.",
        });
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    processSavePlayerStatsResponse: (state, action) => {
      let { tempTableId, data } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (data?.status === 100) {
          let PStatsSuccessData = JSON.parse(
            window.sessionStorage.getItem("PS-Success-Data")
          );
          let playerData = state.games[tempTableId].playerData.find(
            (player) => player.userName === PStatsSuccessData.opponetName
          );
          if (playerData) {
            playerData.enabledPlayerStats =
              PStatsSuccessData.enabledPlayerStats;
            playerData.playerNotes = PStatsSuccessData.playerNotes;
            playerData.colorCode = PStatsSuccessData.colorCode;
            state.games[tempTableId].toastMessages.push({
              type: TOAST_SUCCESS,
              title: "Player Marked",
              message: "Saved player details successfully.",
            });
          } else {
            state.games[tempTableId].toastMessages.push({
              type: TOAST_INFO,
              title: "Player Not Found",
              message:
                "Player has left the seat. Your changes have been saved.",
            });
          }
          if (state.games[tempTableId].gameModal.type === PLAYER_STATS) {
            state.games[tempTableId].gameModal.type = null;
            state.games[tempTableId].gameModal.visible = false;
          }
          window.sessionStorage.removeItem("player-profile-data");
          window.sessionStorage.removeItem("PS-Success-Data");
        } else {
          state.games[tempTableId].toastMessages.push({
            type: TOAST_ERROR,
            title: "Player Stats Error",
            message: "Something wen't wrong. We're on it.",
          });
        }
      } else {
        showNoTableAvailableWarning(action);
      }
      window.sessionStorage.removeItem("PS-Success-Data");
    },

    handleRefreshProtocolData: (state, action) => {
      let loggedInPlayerDetails = state.userDetails;
      const {
        tempTableId,
        stage,
        rankDetails,
        sitOutEndTime,
        waitingForSitOut,
        gameId,
        tableId,
        smallBlindAmount,
        bigBlindAmount,
        userCards,
        clientMultiPotPojoList,
        isWatchPlayer,
        isAutoPlayOn,
        isNGTRunning,
        anteAmount,
        displayName,
        privateTable,
      } = action.payload;

      let tableData = state.games[tempTableId];

      if (tableData) {
        let displayNameMap = tableData.displayNameMap || {};
        if (loggedInPlayerDetails.userName) {
          displayNameMap[loggedInPlayerDetails.userName] = displayName;
        }
        if (isNGTRunning) {
          sendNextGameProtocol({
            tempTableId: tempTableId,
            playerName: loggedInPlayerDetails.userName,
          });
        }

        let updatedPlayerData = state.games[tempTableId].playerData.map(
          (player) => {
            if (
              player !== undefined &&
              player.isActive &&
              player.position === state.games[tempTableId].playerSeat &&
              rankDetails.handType &&
              stage !== GAME_STAGE_PRE_FLOP
            ) {
              player.possibleWinningHandType = getHandType(
                rankDetails.handType
              );
              player.possibleWinningHandCards =
                rankDetails.winningHand.split(",");
            }
            player.showBlindIcon = true;
            return player;
          }
        );
        state.games[tempTableId].displayNameMap = displayNameMap;
        state.games[tempTableId].multiPotAmounts = clientMultiPotPojoList;
        state.games[tempTableId].useProgressOffsetValue = true;
        state.games[tempTableId].showRankDetails = true;
        state.games[tempTableId].playerData = updatedPlayerData;
        state.games[tempTableId].isWinnerDeclared = false;
        state.games[tempTableId].gameEnded = false;
        state.games[tempTableId].sitOutButtonDisabled = false;
        state.games[tempTableId].openBuyInModal = false;
        state.games[tempTableId].setBuyInValueForPlayerPosition = null;
        state.games[tempTableId].processingDReserve = false;
        state.games[tempTableId].gameId = gameId;
        state.games[tempTableId].tableId = tableId;
        state.games[tempTableId].shouldPlayCardAnimation = true;
        state.games[tempTableId].playerCards = userCards;
        state.games[tempTableId].gameDefinition.smallBlind = smallBlindAmount;
        state.games[tempTableId].gameDefinition.bigBlind = bigBlindAmount;
        state.games[tempTableId].tourneyAutoPlay = isAutoPlayOn;
        state.games[tempTableId].showCommunityCardsImmediately = true;
        state.games[tempTableId].privateTable.openHostControlSlider = false;

        state.games[tempTableId].processingReserve = {
          status: false,
          position: undefined,
        };
        state.games[tempTableId].watchPlayer = isWatchPlayer;
        if (sitOutEndTime > 0) {
          state.games[tempTableId].sitOutOption = true;
          state.games[tempTableId].playerSitOutTimer = sitOutEndTime;
          state.games[tempTableId].showDefaultActions = false;
          state.games[tempTableId].showAutoActions = false;
        } else {
          if (waitingForSitOut) {
            state.games[tempTableId].sitOutOption = true;
          }
        }
        state.games[tempTableId].disableOrientationChange = false;
        if (state.games[tempTableId].isTourneyGame) {
          state.games[tempTableId].restrictUserFromLeavingTable = state.games[
            tempTableId
          ].watchPlayer
            ? false
            : true;
          if (
            state.games[tempTableId].activeTourneyBannerType !==
            TOURNEY_BANNER_MERGED_WITH_ANOTHER_TABLE
          ) {
            state.games[tempTableId].activeTourneyBannerType = null;
          }
        }
        state.autoTableSwitchQueue = state.autoTableSwitchQueue.filter(
          (id) => id !== tempTableId
        );

        /* Note:  This check is added explicitly to ensure that playerMovedToCenter flag is true when the player is part of a toruney and the first protocol he receives is refresh instead of start, same check has been added to startGame for tourney */
        if (userCards.length > 0 && state.games[tempTableId].isTourneyGame) {
          state.games[tempTableId].playerMovedToCenter = true;
          state.games[tempTableId].anteAmount = anteAmount;
        }
        if (privateTable) {
          state.games[tempTableId].privateTable.isPrivateTable = true;
        }

        let gameConnection =
          GameConnectionsN.getInstance().getGameConnection(tempTableId);
        gameConnection.listener.setGameId(gameId);
        gameConnection.listener.setTableId(tableId);
        state.removePrivateTableGameDefId = null;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    toggleCallAction: (state, action) => {
      const { tempTableId, betAmount, playerName } = action.payload;
      let gameConnections = GameConnections.getInstance();
      let activeGameConnection = gameConnections.getGameConnection(tempTableId);

      if (activeGameConnection && activeGameConnection.messageHandler) {
        let activeGameTable = state.games[tempTableId];
        if (activeGameTable) {
          const { tableId } = activeGameTable;
          activeGameConnection.gameClientListener.requestCallAction({
            playerName: playerName,
            tableId: tableId,
            gameId: activeGameTable.gameId,
            betAmount: parseDecimalValuesOfNumber(betAmount),
          });
        } else {
          showNoTableAvailableWarning(action);
        }
      }
    },

    toggleCheckAction: (state, action) => {
      const { tempTableId, playerName } = action.payload;
      let gameConnections = GameConnections.getInstance();
      let activeGameConnection = gameConnections.getGameConnection(tempTableId);
      if (activeGameConnection && activeGameConnection.messageHandler) {
        let activeGameTable = state.games[tempTableId];
        if (activeGameTable) {
          const { tableId } = activeGameTable;
          activeGameConnection.gameClientListener.requestCheckAction({
            playerName: playerName,
            tableId: tableId,
            gameId: activeGameTable.gameId,
          });
        } else {
          showNoTableAvailableWarning(action);
        }
      }
    },

    toggleRaiseAction: (state, action) => {
      const { tempTableId, betAmount, playerName } = action.payload;
      let gameConnections = GameConnections.getInstance();
      let activeGameConnection = gameConnections.getGameConnection(tempTableId);

      if (activeGameConnection && activeGameConnection.messageHandler) {
        let activeGameTable = state.games[tempTableId];
        if (activeGameTable) {
          const { tableId } = activeGameTable;
          activeGameConnection.gameClientListener.requestRaiseAction({
            playerName: playerName,
            tableId: tableId,
            gameId: activeGameTable.gameId,
            betAmount: parseDecimalValuesOfNumber(betAmount),
          });
        } else {
          showNoTableAvailableWarning(action);
        }
      }
    },
    toggleFoldAction: (state, action) => {
      const { tempTableId, playerName } = action.payload;
      let gameConnections = GameConnections.getInstance();
      let activeGameConnection = gameConnections.getGameConnection(tempTableId);
      if (activeGameConnection && activeGameConnection.messageHandler) {
        let activeGameTable = state.games[tempTableId];
        if (activeGameTable) {
          const { tableId } = activeGameTable;
          activeGameConnection.gameClientListener.requestFoldAction({
            playerName: playerName,
            tableId: tableId,
            gameId: activeGameTable.gameId,
          });
        } else {
          showNoTableAvailableWarning(action);
        }
      }
    },

    toggleAutoCallAction: (state, action) => {
      const { tempTableId, betAmount, playerName, autoActionEnable } =
        action.payload;
      let gameConnections = GameConnections.getInstance();
      let activeGameConnection = gameConnections.getGameConnection(tempTableId);

      if (activeGameConnection && activeGameConnection.messageHandler) {
        let activeGameTable = state.games[tempTableId];
        if (activeGameTable) {
          const { tableId } = activeGameTable;
          activeGameConnection.gameClientListener.requestAutoCallAction({
            playerName: playerName,
            tableId: tableId,
            gameId: activeGameTable.gameId,
            betAmount: parseDecimalValuesOfNumber(betAmount),
            autoActionEnable: autoActionEnable,
          });
        } else {
          showNoTableAvailableWarning(action);
        }
      }
    },
    toggleAutoCallAnyAction: (state, action) => {
      const { tempTableId, betAmount, playerName, autoActionEnable } =
        action.payload;
      let gameConnections = GameConnections.getInstance();
      let activeGameConnection = gameConnections.getGameConnection(tempTableId);

      if (activeGameConnection && activeGameConnection.messageHandler) {
        let activeGameTable = state.games[tempTableId];
        if (activeGameTable) {
          const { tableId } = activeGameTable;
          activeGameConnection.gameClientListener.requestAutoCallAnyAction({
            playerName: playerName,
            tableId: tableId,
            gameId: activeGameTable.gameId,
            betAmount: parseDecimalValuesOfNumber(betAmount),
            autoActionEnable: autoActionEnable,
          });
        } else {
          showNoTableAvailableWarning(action);
        }
      }
    },
    toggleAutoCheckFoldAction: (state, action) => {
      const { tempTableId, playerName, autoActionEnable } = action.payload;
      let gameConnections = GameConnections.getInstance();
      let activeGameConnection = gameConnections.getGameConnection(tempTableId);

      if (activeGameConnection && activeGameConnection.messageHandler) {
        let activeGameTable = state.games[tempTableId];
        if (activeGameTable) {
          const { tableId } = activeGameTable;
          activeGameConnection.gameClientListener.requestAutoCheckFoldAnyAction(
            {
              playerName: playerName,
              tableId: tableId,
              gameId: activeGameTable.gameId,
              autoActionEnable: autoActionEnable,
            }
          );
        } else {
          showNoTableAvailableWarning(action);
        }
      }
    },
    toggleAutoCheckAction: (state, action) => {
      const { tempTableId, playerName, autoActionEnable } = action.payload;
      let gameConnections = GameConnections.getInstance();
      let activeGameConnection = gameConnections.getGameConnection(tempTableId);

      if (activeGameConnection && activeGameConnection.messageHandler) {
        let activeGameTable = state.games[tempTableId];
        if (activeGameTable) {
          const { tableId } = activeGameTable;
          activeGameConnection.gameClientListener.requestAutoCheckAction({
            playerName: playerName,
            tableId: tableId,
            gameId: activeGameTable.gameId,
            autoActionEnable: autoActionEnable,
          });
        } else {
          showNoTableAvailableWarning(action);
        }
      }
    },

    toggleAutoFoldAction: (state, action) => {
      const { tempTableId, playerName, autoActionEnable } = action.payload;
      let gameConnections = GameConnections.getInstance();
      let activeGameConnection = gameConnections.getGameConnection(tempTableId);

      if (activeGameConnection && activeGameConnection.messageHandler) {
        let activeGameTable = state.games[tempTableId];
        if (activeGameTable) {
          const { tableId } = activeGameTable;
          activeGameConnection.gameClientListener.requestAutoFoldAction({
            playerName: playerName,
            tableId: tableId,
            gameId: activeGameTable.gameId,
            autoActionEnable: autoActionEnable,
          });
        } else {
          showNoTableAvailableWarning(action);
        }
      }
    },

    toggleSitOutAction: (state, action) => {
      let tempTableId = state.activeGame;
      let type = action.payload?.type;
      let activeGameTable = state.games[tempTableId];

      if (activeGameTable) {
        let { tableId, gameId } = activeGameTable;
        let playerName = state.userDetails.userName;
        let sitOutState = activeGameTable.sitOutOption;

        let dataObject = {
          playerName,
          tableId,
          gameId,
        };

        if (activeGameTable) {
          if (type === "sitOutCancel") {
            sendCancelSitOutProtocol(tempTableId, dataObject);
          } else {
            if (sitOutState) {
              sendSitInProtocol(tempTableId, dataObject);
            } else {
              sendSitOutProtocol(tempTableId, dataObject);
            }
          }
        }
        state.games[tempTableId].sitOutButtonDisabled = true;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    updateReleaseToFoldStatus: (state, action) => {
      const { tempTableId, status } = action.payload;
      let game = state.games[tempTableId];
      if (game) {
        game.showReleaseToFoldAlert = status;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    sitInAction: (state, action) => {
      let { tempTableId, data } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (data.success) {
          state.games[tempTableId].sitOutOption = false;
          state.games[tempTableId].playerSitOutTimer = false;
          state.games[tempTableId].isWaitingForBigBlind = false;
          let playerData = state.games[tempTableId].playerData.find(
            (player) => player.userName === data.playerName
          );
          let isGameStarted = state.games[tempTableId].isGameStarted;
          playerData.sitOutOption = false;
          playerData.isActive = isGameStarted ? false : true;
        }

        state.games[tempTableId].sitOutButtonDisabled = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    sitOutAction: (state, action) => {
      let sitOutResult = action.payload.data;
      let tempTableId = action.payload.tempTableId;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (sitOutResult.success) {
          state.games[tempTableId].sitOutOption = true;
        }

        if (sitOutResult.timeout) {
          state.games[tempTableId].playerSitOutTimer = sitOutResult.timeout;
          state.games[tempTableId].showDefaultActions = false;
          state.games[tempTableId].showAutoActions = false;
        } else {
          state.games[tempTableId].toastMessages.push({
            type: TOAST_INFO,
            title: "Sit Out Pending",
            message: "You will sit out next hand.",
          });
        }
        state.games[tempTableId].sitOutButtonDisabled = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    sitOutBroadcastAction: (state, action) => {
      let sitOutResult = action.payload.data;
      let tempTableId = action.payload.tempTableId;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (sitOutResult.success) {
          let playerObject = state.games[tempTableId].playerData.find(
            (player) => player.userName === sitOutResult.playerName
          );
          playerObject.sitOutOption = true;
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    sitInBroadcastAction: (state, action) => {
      let sitOutResult = action.payload.data;
      let tempTableId = action.payload.tempTableId;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (sitOutResult.success) {
          let playerObject = state.games[tempTableId].playerData.find(
            (player) => player.userName === sitOutResult.playerName
          );
          playerObject.sitOutOption = false;
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    sitOutCancelAction: (state, action) => {
      let sitOutCancelResult = action.payload.data;
      let tempTableId = action.payload.tempTableId;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (sitOutCancelResult.success) {
          state.games[tempTableId].sitOutOption = false;
          state.games[tempTableId].playerSitOutTimer = false;
        }
        state.games[tempTableId].sitOutButtonDisabled = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    sitInFailAction: (state, action) => {
      let { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].sitOutButtonDisabled = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    sitOutFailAction: (state, action) => {
      let { tempTableId, statusCode } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].toastMessages.push({
          type: TOAST_ERROR,
          title: "Sit Out Failure",
          message: "Something wen't wrong, we're on it.",
        });
        state.games[tempTableId].sitOutButtonDisabled = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    resizingTable: (state) => {
      state.resizingStatus = false;
    },

    setResizingToComplete: (state) => {
      state.resizingStatus = true;
    },

    updatePositionsArranged: (state, action) => {
      const { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].positionsArranged = true;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    hidePlayerPositions: (state, action) => {
      const { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].positionsArranged = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    processPlayersDataOnTable: (state, action) => {
      const {
        gameId,
        playersData,
        tempTableId,
        happyHoursEnabled,
        happyHoursRake,
        happyHoursHeadsUpRake,
        gameStarted,
      } = action.payload;
      let tableData = state.games[tempTableId];

      // state.games[tempTableId].gameDefinition.happyHoursEnabled =
      //   happyHoursEnabled;
      // state.games[tempTableId].gameDefinition.happyHoursRake = happyHoursRake;
      // state.games[tempTableId].gameDefinition.happyHoursHeadsUpRake =
      //   happyHoursHeadsUpRake;

      if (tableData) {
        let playersOnTable = [];
        let currentPlayerSeat = state.games[tempTableId].playerSeat;
        let loggedInPlayerDetails = state.userDetails;
        let oldPlayerStatsData = {};

        state.games[tempTableId].playerData.map((player, index) => {
          let dataObject = {
            enabledPlayerStats: player?.enabledPlayerStats
              ? player?.enabledPlayerStats
              : false,
            colorCode: player?.colorCode ? player?.colorCode : null,
            playerNotes: player?.playerNotes ? player?.playerNotes : null,
            playerName: player?.userName,
          };
          oldPlayerStatsData[player.userName] = dataObject;
        });

        playersData.forEach((player) => {
          playersOnTable.push({
            position: player.position,
            userName: player.playerName,
            atTableAmount: player.atTableamt,
            acelevel: player.acelevel,
            avatar: player.profilePic,
            isReservedSeat: false,
            isTakenSeat: true,
            isActive: true,
            isFolded: false,
            isWinner: false,
            allIn: false,
            muckCards: false,
            RITRequestAccepted: false,
            sitOutOption: player.gamePlayerStatus === SEATED_OUT ? true : false,
            isWaitingForBigBlind: player.isWaitingForBigBlind,
            enabledPlayerStats: oldPlayerStatsData[player.playerName]
              ?.enabledPlayerStats
              ? oldPlayerStatsData[player.playerName].enabledPlayerStats
              : player?.statsEnabled ?? false,
            colorCode: oldPlayerStatsData[player.playerName]?.colorCode
              ? oldPlayerStatsData[player.playerName]?.colorCode
              : player?.colourCode ?? null,
            playerNotes: oldPlayerStatsData[player.playerName]?.playerNotes
              ? oldPlayerStatsData[player.playerName]?.playerNotes
              : player?.playerNotes ?? "",
          });
          if (player.playerName === loggedInPlayerDetails.userName) {
            currentPlayerSeat = player.position;
            state.games[tempTableId].sitOutButtonDisabled = false;
            state.games[tempTableId].openBuyInModal = false;
            state.games[tempTableId].setBuyInValueForPlayerPosition = null;
            state.games[tempTableId].processingDReserve = false;
            state.games[tempTableId].processingReserve = {
              status: false,
              position: undefined,
            };
          }
        });
        state.games[tempTableId].playerSeat = currentPlayerSeat;
        state.games[tempTableId].playerSeatBeforeLeaveSeat = currentPlayerSeat;
        state.games[tempTableId].playerData = [...playersOnTable];
        state.games[tempTableId].gameId = gameId;
        if (
          !gameStarted &&
          state.games[tempTableId].privateTable.isPrivateTable
        ) {
          state.games[tempTableId].privateTable.hideStartGameButton = false;
          state.games[tempTableId].privateTable.showAutoStartMessage = true;
          state.games[
            tempTableId
          ].privateTable.showMinPlayersJoinMessage = true;
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    processPlayersDataOnTableForAlreadyRunningGame: (state, action) => {
      const {
        playersData,
        tempTableId,
        gameStarted,
        gameStage,
        communityCards,
        ritCommunityCards,
        gameId,
        userCards,
        happyHoursEnabled,
        happyHoursRake,
        happyHoursHeadsUpRake,
      } = action.payload;
      let tableData = state.games[tempTableId];
      state.games[tempTableId].happyHoursEnabled = happyHoursEnabled;
      state.games[tempTableId].gameDefinition.happyHoursRake = happyHoursRake;
      state.games[tempTableId].gameDefinition.happyHoursHeadsUpRake =
        happyHoursHeadsUpRake;

      if (tableData) {
        let currentPlayerSeat = state.games[tempTableId].playerSeat;
        let communityCardPositon =
          state.games[tempTableId].communityCardPositon;
        let loggedInPlayerDetails = state.userDetails;

        let oldPlayerStatsData = {};

        state.games[tempTableId].playerData.map((player, index) => {
          let dataObject = {
            enabledPlayerStats: player?.enabledPlayerStats
              ? player?.enabledPlayerStats
              : false,
            colorCode: player?.colorCode ? player?.colorCode : null,
            playerNotes: player?.playerNotes ? player?.playerNotes : null,
            playerName: player?.userName,
          };
          oldPlayerStatsData[player.userName] = dataObject;
        });

        let playersOnTable = [];
        playersData.forEach((player) => {
          const {
            atTableamt,
            isActivePlayer,
            isAllinPlayer,
            isBigBlind,
            isDealer,
            isFoldPlayer,
            isSitoutPlayer,
            isSmallBlind,
            isForcedBlind,
            playerName,
            userAcelevel,
            userProfilePic,
            isWaitingForBigBlind,
            gamePlayerStatus,
            latestPlayerAction,
            statsEnabled,
            colourCode,
            playerNotes,
          } = player.playerInfo;
          playersOnTable.push({
            position: player.position,
            userName: playerName,
            atTableAmount: atTableamt,
            acelevel: userAcelevel,
            avatar: userProfilePic,
            isReservedSeat: player.isReserved,
            isTakenSeat: true,
            isActive: isActivePlayer,
            isFolded: isFoldPlayer,
            isWinner: false,
            allIn: isAllinPlayer,
            isBigBlind: isBigBlind,
            isSmallBlind: isSmallBlind,
            isForcedBlind: isForcedBlind,
            isDealer: isDealer,
            isSitoutPlayer: isSitoutPlayer,
            showBlindIcon: true,
            sitOutOption: gamePlayerStatus === SEATED_OUT ? true : false,
            isWaitingForBigBlind: isWaitingForBigBlind,
            muckCards: false,
            RITRequestAccepted: false,
            cards:
              playerName === loggedInPlayerDetails.userName ? userCards : [],
            lastAction: isFoldPlayer
              ? FOLD_ACTION
              : latestPlayerAction
                ? latestPlayerAction?.action.toLowerCase() === AUTO_FOLD
                  ? FOLD_ACTION
                  : latestPlayerAction?.action.toLowerCase() === AUTO_CHECK
                    ? CHECK_ACTION
                    : latestPlayerAction.action
                : "",
            allIn: isAllinPlayer ? isAllinPlayer : false,
            winningAmount: 0,
            betAmount: latestPlayerAction
              ? parseDecimalValuesOfNumber(latestPlayerAction.amount)
              : 0,
            enabledPlayerStats: oldPlayerStatsData[player.playerName]
              ?.enabledPlayerStats
              ? oldPlayerStatsData[player.playerName].enabledPlayerStats
              : statsEnabled,
            colorCode: oldPlayerStatsData[player.playerName]?.colorCode
              ? oldPlayerStatsData[player.playerName]?.colorCode
              : colourCode,
            playerNotes: oldPlayerStatsData[player.playerName]?.playerNotes
              ? oldPlayerStatsData[player.playerName]?.playerNotes
              : playerNotes,
          });
          if (playerName === loggedInPlayerDetails.userName) {
            currentPlayerSeat = player.position;
          }
        });
        state.games[tempTableId].playerSeat = currentPlayerSeat;
        state.games[tempTableId].playerSeatBeforeLeaveSeat = currentPlayerSeat;
        state.games[tempTableId].setBuyInValueForPlayerPosition =
          currentPlayerSeat;
        state.games[tempTableId].playerData = [...playersOnTable];
        state.games[tempTableId].isGameStarted = gameStarted;
        state.games[tempTableId].gameStage = gameStage;
        state.games[tempTableId].communityCards = [...communityCards];
        if (ritCommunityCards) {
          state.games[tempTableId].RITCommunityCards = ritCommunityCards;
        }
        // state.games[tempTableId].RITCommunityCards = [...RITCommunityCards];
        if (communityCards.length > 0) {
          state.games[tempTableId].doCommunityCardsExist = true;
        }
        state.games[tempTableId].communityCardPositon = [
          ...communityCardPositon,
        ];
        state.games[tempTableId].gameId = gameId;
        if (gameStarted) {
          state.games[tempTableId].privateTable.showAutoStartMessage = false;
          state.games[
            tempTableId
          ].privateTable.showMinPlayersJoinMessage = false;
          state.games[tempTableId].privateTable.hideStartGameButton = true;
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    processLeaveSeatAck: (state, action) => {
      const { tableId, playerName, tempTableId, ackStatus } = action.payload;

      let tableData = state.games[tempTableId];

      if (tableData) {
        let currentPlayerData = state.games[tempTableId].playerData.find(
          (player) => player.position === state.games[tempTableId].playerSeat
        );
        if (
          state.games[tempTableId].isGameStarted &&
          currentPlayerData.isActive &&
          ackStatus !== LEAVE_SEAT_ACK_SUCCESS
        ) {
          let message = "";
          if (ackStatus === LEAVE_SEAT_ACK_PROCESSING) {
            message = "You will be removed at the end of this hand";
          } else if (ackStatus === LEAVE_SEAT_ACK_REQUEST_ALREADY_SENT) {
            message = "Leave seat request already sent";
          }
          state.games[tempTableId].toastMessages.push({
            type: TOAST_INFO,
            title: "Leave Seat Processing",
            message: message,
          });
        } else if (
          state.games[tempTableId] &&
          ackStatus === LEAVE_SEAT_ACK_SUCCESS
        ) {
          state.games[tempTableId].playerData = state.games[
            tempTableId
          ].playerData.filter((player) => player.userName !== playerName);
          state.games[tempTableId].playerCards = [];
          state.games[tempTableId].playerSeat = undefined;
          state.games[tempTableId].setBuyInValueForPlayerPosition = undefined;
          state.games[tempTableId].playerPosition = [];
          state.games[tempTableId].playerMovedToCenter = false;
          state.games[tempTableId].playerTimer = undefined;
          state.games[tempTableId].playerSitOutTimer = false;
          state.games[tempTableId].sitOutOption = false;
          state.games[tempTableId].playerStatus = IN_ACTIVE;
          state.games[tempTableId].topUpPending = false;
          state.games[tempTableId].watchPlayer = true;
        }

        state.games[tempTableId].isWaitingForBigBlind = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    leaveSeatBroadcastAction: (state, action) => {
      const { playerName, tempTableId } = action.payload;

      let tableData = state.games[tempTableId];

      if (tableData) {
        let playerData = tableData.playerData.filter(
          (player) => player.userName !== playerName
        );
        tableData.playerData = playerData;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    processLeaveSeatAckFromSitOut: (state, action) => {
      const { playerName, tempTableId } = action.payload;

      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].playerSeatBeforeLeaveSeat =
          state.games[tempTableId].playerSeat;

        tableData.playerData = tableData.playerData.filter(
          (player) => player.userName !== playerName
        );
        tableData.playerSeat = undefined;
        tableData.setBuyInValueForPlayerPosition = undefined;
        tableData.playerPosition = [];
        tableData.playerTimer = undefined;
        tableData.playerSitOutTimer = false;
        tableData.sitOutOption = false;
        tableData.playerStatus = IN_ACTIVE;
        tableData.isWaitingForBigBlind = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleJoinFailureAction: (state, action) => {
      let { tempTableId, statusCode, position, lowBalanceData } =
        action.payload;

      let tableData = state.games[tempTableId];

      if (tableData) {
        if (statusCode === 222) {
          state.games[tempTableId].gameModal.type = state.games[tempTableId]
            .isFunGame
            ? INSUFFICIENT_FUN_CHIPS_BALANCE
            : INSUFFICIENT_BALANCE;
          state.games[tempTableId].gameModal.visible = true;

          if (lowBalanceData && Object.keys(lowBalanceData).length > 0) {
            const gameDefinition = state.games[tempTableId].gameDefinition;
            state.games[tempTableId].gameModal.config = {
              amountToAdd: lowBalanceData?.amount_to_add,
              totalBalance: lowBalanceData?.total_balance,
              depositAndWinnings: lowBalanceData?.deposit_and_winning,
              bonus: lowBalanceData?.bonus,
              usableBonus: lowBalanceData?.usable_bonus,
              buyInAmount: lowBalanceData?.buyInAmount,
              isTourneyGame: state.games[tempTableId].isTourneyGame,
              blindsText: gameDefinition
                ? `(${returnGameTypeText(gameDefinition?.gameType)} ${gameDefinition?.smallBlind
                }/${gameDefinition?.bigBlind})`
                : "",
            };
          }

          state.games[tempTableId].toastMessages.push({
            type: TOAST_ERROR,
            title: "Insufficient Funds",
            message: state.games[tempTableId].isFunGame
              ? "Please add chips to start playing."
              : "Please add cash to start playing.",
          });
        } else if (statusCode === 204) {
          //ACCOUNT_ISSUE_GAME_JOIN
          state.games[tempTableId].gameModal.visible = true;
          state.games[tempTableId].gameModal.type = ACCOUNT_ISSUE_GAME_JOIN;
        } else if (statusCode === 205) {
          //WALLET_BALANCE_ISSUE_GAME_JOIN
          state.games[tempTableId].gameModal.visible = true;
          state.games[tempTableId].gameModal.type =
            WALLET_BALANCE_ISSUE_GAME_JOIN;
        } else if (statusCode === 206) {
          //DATA_LOST_ISSUE_GAME_JOIN
          state.games[tempTableId].gameModal.visible = true;
          state.games[tempTableId].gameModal.type = DATA_LOST_ISSUE_GAME_JOIN;
        } else if (statusCode === 207) {
          //JOIN_FAILURE_ACCOUNT_DELETED
          state.games[tempTableId].gameModal.visible = true;
          state.games[tempTableId].gameModal.type =
            JOIN_FAILURE_ACCOUNT_DELETED;
        } else if (statusCode === 111) {
          state.games[tempTableId].toastMessages.push({
            type: TOAST_ERROR,
            title: "Buy In Failure",
            message: "Your seat reservation time has ended.",
          });
        } else if (statusCode === 101) {
          state.games[tempTableId].toastMessages.push({
            type: TOAST_ERROR,
            title: "That didn't work",
            message: "The next game just started, please try again.",
          });
        } else if (statusCode === 112) {
          console.log("Inside the status code 112");
          //User trying to join during restricted hours (tamilnadu state applicable for now)
          state.games[tempTableId].gameModal.visible = true;
          state.games[tempTableId].gameModal.type = RESTRICTED_LOCATION_HOURS;
        } else {
          state.games[tempTableId].toastMessages.push({
            type: TOAST_ERROR,
            title: "Take Seat Failure",
            message: "Failed to take a seat, we're looking into it.",
          });
        }

        state.games[tempTableId].processingReserve = {
          status: false,
          position: position,
        };
        state.games[tempTableId].joinFailureFlag = true;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    processLeaveSeatFailure: (state, action) => {
      let tempTableId = action.payload.tempTableId;
      let tableData = state.games[tempTableId];

      if (tableData) {
        tableData.toastMessages.push({
          type: TOAST_ERROR,
          title: "Leave Seat",
          message: "You cannot leave your seat right now.",
        });
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    createTableData: (state, action) => {
      processCreateTableData(state, action);
    },

    resetTableData: (state, action) => {
      let processedState = processResetTableData(current(state), action);
      return processedState;
    },

    updateGameConnectionStatusN: (state, action) => {
      const { tempTableId, status } = action.payload;

      let tableData = state.games[tempTableId];
      if (tableData) {
        tableData.gameConnectionStatus = status;

        if (status === GAME_CONNECTION_PROTOCOL_SUCCESS) {
          tableData.isConnectionAckReceivedOnce = true;
        }

        tableData.gameAPIState =
          status === CHECK_GAME_API_READY_TO_REQUEST
            ? CHECK_GAME_API
            : status === INITIATE_TOURNEY_GAME_RECONNECTION
              ? TOURNEY_GAME_RECONNECTION_STATE
              : tableData.gameAPIState;

        if (tableData.isTourneyGame) {
          tableData.isTourneyNodeSwitch = false;
          tableData.isReset = false;
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    privateTableHostConnectFailure: (state, action) => {
      const { tempTableId } = action.payload;
      state.games[tempTableId].gameModal.type = PRIVATE_TABLE_HOST_NOT_ALLOWED;
      state.games[tempTableId].gameModal.visible = true;
      state.games[tempTableId].gameModal.config = {
        message: "Previous game is in progress. Please wait and try again",
      };
      state.games[tempTableId].privateTable.openHostControlSlider = false;
    },

    updateGameConnectionFailureProtocolStatus: (state, action) => {
      const { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].gameAPICurrentStatus =
          GAME_JOIN_API_RESPONSE_FAILURE;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    updatePlayerDetails: (state, action) => {
      //assigning lobby player object for reference
      const { lobbyPlayerData } = action.payload;
      state.userDetails = lobbyPlayerData;
    },

    handleReloginFailure: (state, action) => {
      const { tempTableId } = action.payload;

      let tableData = state.games[tempTableId];

      if (tableData) {
        tableData.openInSufficientFundsModal = false;
        tableData.openTopupModal = false;
        tableData.openBuyInModal = false;
        tableData.openRebuyInModal = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    startGameListenerN: (state, action) => {
      const { store, tempTableId, dispatchFunction } = action.payload;

      let tableData = state.games[tempTableId];

      if (tableData) {
        let gameConnections = GameConnectionsN.getInstance();

        let connection = gameConnections.getGameConnection(tempTableId);
        if (!connection) {
          let gameListenerN = new GameListenerN(store, dispatchFunction);
          gameListenerN.setTempTableId(tempTableId);
          gameListenerN.setIsTourneyGame(tableData.isTourneyGame);

          connection = {
            tempTableId: tempTableId,
            listener: gameListenerN,
          };
          gameConnections.addGameConnection(connection);
        } else {
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    processMatchMakingResponse: (state, action) => {
      const {
        tempTableId,
        connectionStatus,
        tableId,
        gameId,
        hostname,
        port,
        connectionType,
        awsalbcookie,
        gameEndpoint,
      } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        tableData.gameConnectionStatus = connectionStatus;
        tableData.tableId = tableId;
        tableData.gameId = gameId;
        tableData.serverAddress = hostname;
        tableData.serverPort = port;
        tableData.connectionType = connectionType;
        tableData.awsalbcookie = awsalbcookie;
        tableData.gameEndpoint = gameEndpoint;
      } else {
        showNoTableAvailableWarning();
      }
    },

    processCheckGameResponse: (state, action) => {
      const {
        tempTableId,
        connectionStatus,
        tableId,
        gameId,
        hostname,
        port,
        connectionType,
        awsalbcookie,
        gameEndpoint,
      } = action.payload;

      let tableData = state.games[tempTableId];

      if (tableData) {
        tableData.gameConnectionStatus = connectionStatus;
        tableData.tableId = tableId;
        tableData.gameId = gameId;
        tableData.serverAddress = hostname;
        tableData.serverPort = port;
        tableData.connectionType = connectionType;
        tableData.awsalbcookie = awsalbcookie;
        tableData.gameEndpoint = gameEndpoint;
      } else {
        showNoTableAvailableWarning();
      }
    },

    setToastMessage: (state, action) => {
      const { tempTableId, type, title, message } = action.payload;
      let tableData = state.games[tempTableId];
      if (tableData) {
        tableData.toastMessages.push({
          type: type,
          title: title,
          message: message,
        });
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    removeToastMessage: (state, action) => {
      const { tempTableId, message } = action.payload;

      let tableData = state.games[tempTableId];

      if (tableData) {
        let index = tableData.toastMessages.indexOf(message);
        tableData.toastMessages.splice(index, 1);
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    setCardDistributionAnimationCompleteFlag: (state, action) => {
      const { tempTableId } = action.payload;

      let tableData = state.games[tempTableId];

      if (tableData) {
        tableData.disableOrientationChange = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handlePrizePotAmount: (state, action) => {
      const { tempTableId, potAmountDetails } = action.payload;
      const {
        atTableAmounts,
        userStageInvestment,
        totalPot,
        gameStage,
        multiPotsPojo,
        betAnimation,
      } = potAmountDetails;

      let playersWhoInvestedInPot = Object.keys(userStageInvestment);

      let tableData = state.games[tempTableId];

      if (tableData) {
        tableData.totalPotAmt = parseDecimalValuesOfNumber(totalPot);
        tableData.gameStage = gameStage;
        tableData.playerData.map((player) => {
          if (playersWhoInvestedInPot.includes(player.userName)) {
            player.betAmount = parseDecimalValuesOfNumber(
              userStageInvestment[player.userName]
            );
          }
        });

        // Using bet animation flag to increase multiPotAmounts array size as it indicates whether betting is over for the round or not
        if (betAnimation) {
          // updating at table amount in case of refund.
          let updatedPlayer = tableData.playerData.map((player) => {
            player.atTableAmount = atTableAmounts[player.userName];
            if (userStageInvestment[player.userName]) {
              player.betAmount = parseDecimalValuesOfNumber(
                userStageInvestment[player.userName]
              );
            }
            return player;
          });

          // Add a default "run" key to each pot in multiPotsPojo
          tableData.multiPotAmounts = multiPotsPojo.map((pot) => ({
            ...pot,
            run: 1, // Add default run key
          }));

          tableData.playerData = updatedPlayer;
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    updateInSufficientFundsModalOpenStatus: (state, action) => {
      const { tempTableId, isOpen } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].openInSufficientFundsModal = isOpen;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    updateWaitingForBB: (state, action) => {
      let { isWaitingForBigBlind, tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].isWaitingForBigBlind = isWaitingForBigBlind;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleRankDetails: (state, action) => {
      const { tempTableId, data } = action.payload;
      const { rankDetails } = data;

      let tableData = state.games[tempTableId];

      if (tableData) {
        if (tableData?.gameStage === GAME_STAGE_SHOWDOWN) {
          return;
        }
        let mySeat = tableData.playerSeat;
        tableData.playerData.map((player) => {
          if (player.position === mySeat) {
            player.possibleWinningHandType = getHandType(rankDetails.handType);
            player.possibleWinningHandCards =
              rankDetails.winningHand.split(",");
            return player;
          }
        });
        tableData.showRankDetails = true;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    updateHandHistory: (state, action) => {
      let { details } = action.payload;

      let currentHandHistory = state.handHistory;
      if (details?.potAmount) {
        details.potAmount = parseDecimalValuesOfNumber(
          details?.potAmount,
          2,
          checkToDisplayValueInK(details?.potAmount),
          checkToDisplayValueInL(details?.potAmount)
        );
      }
      // Saving a different parameter called activeHandIndex to know which hand we are viewing.
      currentHandHistory.activeHandIndex =
        currentHandHistory.activeHandIndex !== undefined &&
          currentHandHistory.activeHandIndex !== null
          ? currentHandHistory.activeHandIndex
          : details.gameIds.length > 1
            ? details.gameIds.length - 1
            : 0;
      // Details contain all hand history data along with different game Ids.
      currentHandHistory.gameIds = details.gameIds;
      currentHandHistory.details = details;
      state.handHistoryLoading = false;
    },

    setHandHistoryLoading: (state) => {
      state.handHistoryLoading = true;
    },

    updateTableStats: (state, action) => {
      let { details, tempTableId } = action.payload;

      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].tableStats = details;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    openHandHistoryRequest: (state) => {
      let dataObject = {
        playerName: state.userDetails.userName,
        tableId: state.games[state.activeGame].tableId,
      };
      let gameConnection = GameConnections.getInstance().getGameConnection(
        state.activeGame
      );
      gameConnection.gameClientListener.processHandHistoryRequest(dataObject);
    },

    clearHandHistoryIndex: (state) => {
      state.handHistory.activeHandIndex = undefined;
      state.handHistoryLoading = true;
    },

    requestHandHistory: (state, action) => {
      let { gameId, index } = action.payload;
      let tableData = state.games[state.activeGame];

      if (tableData) {
        let dataObject = {
          playerName: state.userDetails.userName,
          tableId: state.games[state.activeGame]?.tableId,
          gameId,
        };
        if (state.games[state.activeGame]?.isTourneyGame) {
          dataObject["tourneyId"] =
            state.games[state.activeGame]?.gameDefinition.tourneyId;
        }

        let currentHandHistory = state.handHistory;
        currentHandHistory.activeHandIndex = index;
        currentHandHistory.details = {};

        let gameConnection = GameConnectionsN.getInstance().getGameConnection(
          state.activeGame
        );
        gameConnection.listener.processHandHistoryRequest(dataObject);
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    updateGameApplicationVisibility: (state, action) => {
      let { status } = action.payload;

      state.applicationVisibility = status;
    },

    syncUpTableTimers: (state, action) => {
      // const { playerName, position, time, type } = action.payload.data;
      // const { tempTableId } = action.payload;
      // let gameObject = state.games[tempTableId];
      // if (gameObject) {
      //   let positionOfPlayerTurn = gameObject.playerTurn;
      //   let playerObject = gameObject.playerData.find(
      //     (player) => player.position === position
      //   );
      //   let activePlayerObjectOnClientSide = gameObject.playerData.find(
      //     (player) => player.position === gameObject.playerTurn
      //   );
      //   if (activePlayerObjectOnClientSide && playerName) {
      //     if (playerName !== activePlayerObjectOnClientSide?.userName) {
      //       let message = {
      //         type: "Active player mismatch in heart beat",
      //         data: {
      //           clientActiveUser: activePlayerObjectOnClientSide.userName,
      //           serverActiveUser: playerName,
      //         },
      //       };
      //       let gameConnection =
      //         GameConnectionsN.getInstance().getGameConnection(tempTableId);
      //       gameConnection.listener
      //         .getCommunicationChannel()
      //         .sendMessage(`DB#${JSON.stringify(message)}`);
      //       sendFaroLog(message);
      //     }
      //   }
      //   if (
      //     type === "T#" &&
      //     position === positionOfPlayerTurn &&
      //     Math.abs(playerObject.remainingTime - time) > 2
      //   ) {
      //     playerObject.tableTimer = time - 1;
      //   }
      // } else {
      //   showNoTableAvailableWarning(action);
      // }
    },

    handleCleanTable: (state, action) => {
      const {
        tempTableId,
        cleanGameId,
        status,
        tourneyGameAndCheckExitTable,
        doNotCleanShownCards,
      } = action.payload;
      // Remove the game connection if status is 800. Since game is under maintenance.
      processCleanTable(
        state,
        tempTableId,
        cleanGameId,
        tourneyGameAndCheckExitTable,
        doNotCleanShownCards
      );
      // Need to filter out this game from autoTableSwitching queue.
      state.autoTableSwitchQueue = state.autoTableSwitchQueue.filter(
        (id) => id !== tempTableId
      );
    },

    handleNextGameTimer: (state, action) => {
      const { tempTableId } = action.payload;
      let gameTable = state.games[tempTableId];

      if (gameTable) {
        if (
          gameTable.playerSeat !== undefined &&
          gameTable.playerSeat !== null &&
          !gameTable.isTourneyGame
        ) {
          gameTable.restrictUserFromLeavingTable = true;
        }
        if (gameTable.isTourneyGame) {
          gameTable.restrictUserFromLeavingTable = !gameTable.watchPlayer;
        }
        state.games[tempTableId] = gameTable;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    checkPlayerIsAvailableInSeats: (state, action) => {
      const { tempTableId, playersData } = action.payload;
      let isPlayerPartOfGame = false;
      let loggedInPlayerDetails = state.userDetails;
      let tableData = state.games[tempTableId];

      if (tableData) {
        let displayNameMap = tableData.displayNameMap || {};
        playersData.map((eachPlayer) => {
          if (eachPlayer.playerName) {
            displayNameMap[eachPlayer.playerName] = eachPlayer.displayName;
          } else if (eachPlayer.playerInfo.playerName) {
            displayNameMap[eachPlayer.playerInfo.playerName] =
              eachPlayer.playerInfo.displayName;
          }
          if (eachPlayer.playerName === loggedInPlayerDetails.userName) {
            isPlayerPartOfGame = true;
            // Fix for IM-1195
            state.games[tempTableId].playerMovedToCenter = true;
          }
        });

        if (!isPlayerPartOfGame) {
          state.games[tempTableId].playerCards = [];
          state.games[tempTableId].playerSeat = undefined;
          state.games[tempTableId].setBuyInValueForPlayerPosition = state.games[
            tempTableId
          ].playerWaitingPosition
            ? state.games[tempTableId].setBuyInValueForPlayerPosition
            : undefined;
          state.games[tempTableId].playerPosition = [];
          state.games[tempTableId].playerTimer = undefined;
          state.games[tempTableId].playerSitOutTimer = false;
          state.games[tempTableId].sitOutOption = false;
          state.games[tempTableId].playerStatus = IN_ACTIVE;
          state.games[tempTableId].playerTurn = false;
        }
        state.games[tempTableId].displayNameMap = displayNameMap;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleCloseFailure: (state, action) => {
      const { tempTableId } = action.payload;

      let tableData = state.games[tempTableId];

      if (tableData) {
        tableData.toastMessages.push({
          type: TOAST_ERROR,
          title: "Exit Table Failure",
          message: "Something wen't wrong, we're on it.",
        });
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    updateGameDefinitionId: (state, action) => {
      const { tempTableId, gameDefinition } = action.payload;
      state.games[tempTableId].gameDefinition = gameDefinition;
    },

    showInsufficientBalance: (state, action) => {
      const { tempTableId } = action.payload;
      state.games[tempTableId].showInsufficientBalance = true;
    },

    hideInsufficientBalance: (state, action) => {
      const { tempTableId } = action.payload;
      state.games[tempTableId].showInsufficientBalance = false;
    },

    updateAmountToAdd: (state, action) => {
      let { tempTableId, amountToAdd } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].amountToAdd = amountToAdd;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    disableMultitableSwipe: (state) => {
      state.canUserSwipe = false;
    },

    enableMultitableSwipe: (state) => {
      state.canUserSwipe = true;
    },

    enableRIT: (state, action) => {
      const { tempTableId } = action.payload;

      state.games[tempTableId].isRITEnabled = true;

      const multiPotAmounts = state.games[tempTableId].multiPotAmounts;

      if (Array.isArray(multiPotAmounts) && multiPotAmounts.length > 0) {
        state.games[tempTableId].multiPotAmounts = multiPotAmounts.flatMap(
          (pot) => {
            const halfAmount = pot.potAmount / 2;

            return [
              { ...pot, potAmount: halfAmount, run: 1 }, // First run
              { ...pot, potAmount: halfAmount, run: 2 }, // Second run
            ];
          }
        );
      } else {
        // console.warn(
        //   "Spruha log >>> multiPotAmounts is either empty or invalid"
        // );
      }
    },

    toggleRIT: (state, action) => {
      const { tempTableId } = action.payload;
      state.games[tempTableId].isRITEnabled =
        !state.games[tempTableId].isRITEnabled;
    },

    processRabbitHuntingDetails: (state, action) => {
      const { tempTableId, cards } = action.payload;

      let tableData = state.games[tempTableId];

      if (tableData) {
        let gameStage = tableData.gameStage;
        let rabbitHuntingCardsArray = [];
        for (let card of cards) {
          let item = {
            source: card,
            rabbitHunting: true,
          };
          rabbitHuntingCardsArray.push(item);
        }
        tableData.communityCards = [
          ...tableData.communityCards,
          ...rabbitHuntingCardsArray,
        ];
        tableData.disableOrientationChange = true;
        state.games[tempTableId].doCommunityCardsExist = true;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    openLocalGameModal: (state, action) => {
      const { tempTableId, type, data } = action.payload;
      console.log("STATE_SET_SUCCESS 0");
      //state = cloneDeep(current(state));
      if (
        state.games[tempTableId].gameModal.type === DISCONNECTION &&
        type !== RELOGIN_FAILURE
      ) {
        //return state;
        return;
      } else if (state.games[tempTableId]) {
        state.games[tempTableId].gameModal.visible = true;
        state.games[tempTableId].gameModal.type = type;
        if (action.payload?.data) {
          state.games[tempTableId].gameModal.data = action.payload?.data;
        }
        if (action.payload.config) {
          state.games[tempTableId].gameModal.config = action.payload.config
            ? action.payload.config
            : null;
        }
      } else {
        showNoTableAvailableWarning(action);
      }
      console.log("STATE_SET_SUCCESS 1");
    },

    closeLocalGameModal: (state, action) => {
      const { tempTableId } = action.payload;

      if (state.games[tempTableId]) {
        state.games[tempTableId].gameModal.visible = false;
        state.games[tempTableId].gameModal.type = null;
        state.games[tempTableId].gameModal.data = null;
        state.games[tempTableId].gameModal.config = null;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    closeInternetDisconnectionGameModal: (state, action) => {
      const { tempTableId } = action.payload;

      if (state.games[tempTableId]) {
        if (state.games[tempTableId].gameModal.type === DISCONNECTION) {
          state.games[tempTableId].gameModal.visible = false;
          state.games[tempTableId].gameModal.type = null;
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handlePlayerDisconnectionTime: (state, action) => {
      const { tempTableId, playerName, position, disconnectionTimeBank } =
        action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].playerData.map((player) => {
          if (player.position === position && player.userName === playerName) {
            player.tableTimer = disconnectionTimeBank;
            player.totalTime = disconnectionTimeBank;
            player.startTableTimer = true;
            player.activeTableTimerType = DISCONNECTION_TIMER;
            player.remainingTime = false;
          }
        });
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyPrize: (state, action) => {
      const { tempTableId, tourneyEnded } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].tourneyPrizeDetails = {
          ...action.payload,
        };
        state.games[tempTableId].gameModal.visible = true;
        state.games[tempTableId].gameModal.type = TOURNEY_GAME_WINNER_MODAL;
        state.games[tempTableId].restrictUserFromLeavingTable = true;
        state.games[tempTableId].tourneyGameCompleted = tourneyEnded;

        //NOTE: We are watedly adding watchplayer as true for active player as no channel is there, to avoid re-entry table creation issue at the time of processing lack tourney games.
        state.games[tempTableId].watchPlayer = true;

        //new value
        state.games[tempTableId].openTourneyWinnerModal = true;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyEliminate: (state, action) => {
      const { tempTableId, tourneyEnded, rank } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].gameModal.visible = true;
        state.games[tempTableId].gameModal.type = GAME_LOOSER_MODAL;
        state.games[tempTableId].gameModal.config = { rank: rank };
        state.games[tempTableId].restrictUserFromLeavingTable = true;
        state.games[tempTableId].tourneyGameCompleted = tourneyEnded;
        state.games[tempTableId].openTourneyEliminationModal = true;

        //NOTE: We are watedly adding watchplayer as true for active player as no channel is there, to avoid re-entry table creation issue at the time of processing lack tourney games.
        state.games[tempTableId].watchPlayer = true;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handlersTourneyRebuyIn: (state, action) => {
      const { tempTableId, rebuyInDetails } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].tourneyRebuyInDetails = rebuyInDetails;
        state.games[tempTableId].gameModal.visible = true;
        state.games[tempTableId].gameModal.type =
          TOURNEY_REBUYIN_WITH_DOUBLE_REBUY;
        state.games[tempTableId].isTourneyRebuyRequestLoading = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    submitTourneyRebuyRequest: (state, action) => {
      const { tempTableId, rebuyRequestPayload } = action.payload;

      const tableData = state.games[tempTableId];
      if (tableData) {
        const { tableId, tourneyId } = tableData;
        let gameConnection =
          GameConnectionsN.getInstance().getGameConnection(tempTableId);

        gameConnection.listener.processTourneyRebuyRequest({
          tourneyId: tourneyId,
          tableId: tableId,
          ...rebuyRequestPayload,
        });

        state.games[tempTableId].isTourneyRebuyRequestLoading = true;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    processTourneyRebuyCancle: (state, action) => {
      const { tempTableId, channel, playerName } = action.payload;

      const tableData = state.games[tempTableId];
      if (tableData) {
        const { tableId, tourneyId } = tableData;
        let gameConnection =
          GameConnectionsN.getInstance().getGameConnection(tempTableId);

        gameConnection.listener.processTourneyRebuyCancle({
          tourneyId: tourneyId,
          tableId: tableId,
          channel: channel,
          playerName: playerName,
        });

        state.games[tempTableId].isTourneyRebuyRequestLoading = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyRebuyAck: (state, action) => {
      const { tempTableId, buyInMessage } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].isTourneyRebuyRequestLoading = false;
        state.games[tempTableId].gameModal.visible = false;
        state.games[tempTableId].gameModal.type = null;
        state.games[tempTableId].gameModal.config = null;
        state.games[tempTableId].toastMessages.push({
          type: TOAST_SUCCESS,
          title: "Re-BuyIn Success",
          message: buyInMessage,
        });
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyRebuyCancle: (state, action) => {
      const { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].isTourneyRebuyRequestLoading = false;
        state.games[tempTableId].gameModal.visible = false;
        state.games[tempTableId].gameModal.type = null;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyRebuyFailure: (state, action) => {
      const { tempTableId, buyInMessage } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].isTourneyRebuyRequestLoading = false;
        state.games[tempTableId].gameModal.visible = false;
        state.games[tempTableId].gameModal.type = null;
        state.games[tempTableId].toastMessages.push({
          type: TOAST_ERROR,
          title: "Tourney Re-BuyIn Failure",
          message: buyInMessage,
        });
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyRebuyBroadcast: (state, action) => {
      const { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].activeTourneyBannerType =
          TOURNEY_BANNER_WAITING_FOR_REBUYS;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyBubbleBroadcast: (state, action) => {
      const { tempTableId, isITMBubble, isFinalTableBubble } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].activeTourneyBannerType =
          isITMBubble && isFinalTableBubble
            ? TOURNEY_BANNER_ITM_AND_FINAL_BUBBLE
            : isITMBubble
              ? TOURNEY_BANNER_IN_THE_MONEY_BUBBLE
              : isFinalTableBubble
                ? TOURNEY_BANNER_HAND_TO_HAND_FINAL_TABLE_BUBBLE
                : null;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyRebuyEnded: (state, action) => {
      const { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (
        tableData &&
        tableData?.activeTourneyBannerType === TOURNEY_REBUYIN_WITH_DOUBLE_REBUY
      ) {
        state.games[tempTableId].activeTourneyBannerType = null;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyWaitingForMerging: (state, action) => {
      const { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].activeTourneyBannerType =
          TOURNEY_BANNER_MERGE_WAIT_MESSAGE;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyNodeSwitch: (state, action) => {
      const { tempTableId, nodeIp, gameId, tableId, awsalbcookie } =
        action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].activeTourneyBannerType =
          TOURNEY_BANNER_NODE_SWITCH;

        const { hostname, port, protocol } = new URL(nodeIp);

        state.games[tempTableId].serverAddress = hostname;
        state.games[tempTableId].serverPort = port;
        state.games[tempTableId].connectionType = protocol.replace(":", "");
        state.games[tempTableId].gameId = gameId;
        state.games[tempTableId].tableId = tableId;
        state.games[tempTableId].awsalbcookie = awsalbcookie;
        state.games[tempTableId].isTourneyNodeSwitch = true;

        //added but commented by @yashwanth - need to confirm with @ganesh
        // state.games[tempTableId].gameAPIState = TOURNEY_GAME_CONNECTION_STATEMATCH_MAKING_API;
        // state.games[tempTableId].gameConnectionStatus = INITIATE_TOURNEY_GAME_CONNECTION;

        let gameConnection =
          GameConnectionsN.getInstance().getGameConnection(tempTableId);
        gameConnection.listener.setGameId(gameId);
        gameConnection.listener.setTableId(tableId);
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleRequestTourneyRankingLeaderboardDetails: (state, action) => {
      const { tempTableId, playerName } = action.payload;
      const tableData = state.games[tempTableId];

      if (tableData) {
        const { tableId, gameDefinition } = tableData;
        let gameConnection =
          GameConnectionsN.getInstance().getGameConnection(tempTableId);

        gameConnection.listener.requestTourneyRankingLeaderboard({
          tourneyId: gameDefinition.tourneyId,
          tableId: tableId,
          playerName: playerName,
        });

        state.games[
          tempTableId
        ].isTourneyRankingLeaderboardRequestInProgress = true;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyRankingLeaderBoard: (state, action) => {
      const { tempTableId, rankingLeaderboardData, playerName } =
        action.payload;
      const tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].tourneyRankingLeaderboardDetails = {
          ...rankingLeaderboardData,
        };

        let rankDataList =
          state.games[tempTableId].tourneyRankingLeaderboardDetails
            .rankDataList;
        if (rankDataList && rankDataList?.length > 0) {
          let index = rankDataList.findIndex(
            (item) => item["playerName"] === playerName
          );
          if (index > 0) {
            //to rearrange ranks order only if the player name is greater than index 0
            let currentUserRankDetails = rankDataList[index];
            rankDataList.splice(index, 1);

            let updatedRanksDataList = rankDataList;
            let reorderedRanksData = [
              currentUserRankDetails,
              ...updatedRanksDataList,
            ];
            state.games[
              tempTableId
            ].tourneyRankingLeaderboardDetails.rankDataList =
              reorderedRanksData;
          }
        }

        state.games[
          tempTableId
        ].isTourneyRankingLeaderboardRequestInProgress = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyPlayerRankDetails: (state, action) => {
      const { tempTableId, rankDetails } = action.payload;
      const tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].tourneyPlayerRankDetails = {
          ...rankDetails,
        };
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyBountyCreditDetails: (state, action) => {
      const { tempTableId, bustedOutPlayersMap } = action.payload;

      state.games[tempTableId].playerData.map((eachPlayer) => {
        if (Object.keys(bustedOutPlayersMap).includes(eachPlayer.userName)) {
          eachPlayer.isBustedOut = true;
          eachPlayer.playKOAnimation = true;
          return eachPlayer;
        }
        return eachPlayer;
      });
    },

    handleBlindsUpDetails: (state, action) => {
      const { tempTableId, blindsUpDetails } = action.payload;
      const tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].tourneyBlindsUpDetails = {
          ...blindsUpDetails,
        };
        // Commented below code Temporarily - ante details to be added in refresh protocol too (same like in start protocol)
        // state.games[tempTableId].gameDefinition.smallBlind =
        //   blindsUpDetails.sb;
        // state.games[tempTableId].gameDefinition.bigBlind =
        //   blindsUpDetails.bb;
        // state.games[tempTableId].gameDefinition["level"] =
        //   blindsUpDetails.level;
        // state.games[tempTableId].gameDefinition["ante"] =
        //   blindsUpDetails.ante;

        state.games[tempTableId].activeTourneyBannerType =
          blindsUpDetails?.finalLevel
            ? TOURNEY_BANNER_BLINDS_UP_FINAL_LEVEL
            : TOURNEY_BANNER_BLINDS_UP;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyAutoPlayAcknowledgement: (state, action) => {
      const { autoPlay, playerName, tourneyId, tempTableId } = action.payload;
      state.games[tempTableId].tourneyAutoPlay = autoPlay;
    },

    handleTourneyBreakBroadcast: (state, action) => {
      const { tempTableId, breakDetails } = action.payload;
      const tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].tourneyGameBreakBroadcast = {
          ...breakDetails,
        };

        state.games[tempTableId].activeTourneyBannerType =
          breakDetails.endTime !== 0
            ? TOURNEY_BANNER_BREAK_TIME
            : TOURNEY_BANNER_BREAK_WAITING_FOR_OTHER_TABLES;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyBreakEnd: (state, action) => {
      const { tempTableId } = action.payload;
      const tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].tourneyGameBreakBroadcast = null;
        state.games[tempTableId].activeTourneyBannerType = null;
        state.games[tempTableId].tourneyAddOnDetails = null;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyAddOn: (state, action) => {
      const { tempTableId, addOnDetails } = action.payload;
      const tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].tourneyGameBreakBroadcast = {
          ...addOnDetails,
        };
        state.games[tempTableId].activeTourneyBannerType =
          addOnDetails.endTime !== 0
            ? TOURNEY_BANNER_BREAK_TIME
            : TOURNEY_BANNER_ADDON_BREAK_WAITING_FOR_OTHER_TABLES;

        if (addOnDetails?.addOnDetailsToClient) {
          state.games[tempTableId].tourneyAddOnDetails = {
            ...addOnDetails.addOnDetailsToClient,
          };
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyWatchPlayerAddOn: (state, action) => {
      const { tempTableId, endTime } = action.payload;
      const tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].tourneyGameBreakBroadcast = {
          ...action.payload,
        };
        state.games[tempTableId].activeTourneyBannerType =
          endTime !== 0
            ? TOURNEY_BANNER_BREAK_TIME
            : TOURNEY_BANNER_BREAK_WAITING_FOR_OTHER_TABLES;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyPlayerInTheMoneyDetails: (state, action) => {
      const { tempTableId } = action.payload;
      const tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].activeTourneyBannerType =
          TOURNEY_BANNER_IN_WINNING_POSITIONS;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleOpenTourneyAddOnPopup: (state, action) => {
      const { tempTableId } = action.payload;
      const tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].gameModal.visible = true;
        state.games[tempTableId].gameModal.type = TOURNEY_ADDON;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    closeTourneyAddOnPopup: (state, action) => {
      const { tempTableId } = action.payload;
      const tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].gameModal.visible = false;
        state.games[tempTableId].gameModal.type = null;
        state.games[tempTableId].tourneyAddOnDetails = null;
        state.games[tempTableId].isTourneyAddOnRequestInProgress = false;

        const { tableId, gameDefinition } = tableData;
        let loggedInPlayerDetails = state.userDetails;

        let gameConnection =
          GameConnectionsN.getInstance().getGameConnection(tempTableId);

        gameConnection.listener.requestTourneyAddonCancle({
          tourneyId: gameDefinition.tourneyId,
          tableId: tableId,
          playerName: loggedInPlayerDetails.userName,
        });
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    requestTourneyAddOnTopup: (state, action) => {
      const { playerName, userId, channel } = action.payload;
      const tableData = state.games[state.activeGame];

      if (tableData) {
        const { tourneyId, tableId } = tableData;

        let requestPayload = {
          tourneyId: tourneyId,
          tableId: tableId,
          playerName: playerName,
          userId: userId,
          channel: channel,
        };

        let gameConnection = GameConnectionsN.getInstance().getGameConnection(
          tableData.tempTableId
        );

        gameConnection.listener.processTourneyAddOnRequest({
          ...requestPayload,
        });
        state.games[state.activeGame].isTourneyAddOnRequestInProgress = true;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyAddonAck: (state, action) => {
      const { tempTableId, statusCode, addOnMessage } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (statusCode === 200) {
          state.games[tempTableId].toastMessages.push({
            type: TOAST_SUCCESS,
            title: "Tourney Add-On Success",
            message: addOnMessage,
          });
        } else if (statusCode === 400) {
          state.games[tempTableId].toastMessages.push({
            type: TOAST_ERROR,
            title: "Tourney Add-On Error",
            message: addOnMessage,
          });
        }
        state.games[tempTableId].isTourneyAddOnRequestInProgress = false;
        state.games[tempTableId].tourneyAddOnDetails = null;

        state.games[tempTableId].gameModal.visible = false;
        state.games[tempTableId].gameModal.type = null;
        state.games[tempTableId].gameModal.data = null;
        state.games[tempTableId].gameModal.config = null;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyAddonFailureAck: (state, action) => {
      const { tempTableId, addOnMessage } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].toastMessages.push({
          type: TOAST_ERROR,
          title: "Tourney Add-On Failure",
          message: addOnMessage,
        });
        state.games[tempTableId].isTourneyAddOnRequestInProgress = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyTableSwitching: (state, action) => {
      const { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].activeTourneyBannerType =
          TOURNEY_BANNER_MERGED_WITH_ANOTHER_TABLE;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleTourneyNextLevelUp: (state, action) => {
      const { tempTableId, nextLevelDetails } = action.payload;
      let tableData = state.games[tempTableId];
      let previousDetails;

      if (tableData) {
        if (state.games[tempTableId].tourneyNextLevelUpDetails) {
          previousDetails = state.games[tempTableId].tourneyNextLevelUpDetails;
        }
        state.games[tempTableId].tourneyNextLevelUpDetails = {
          ...nextLevelDetails,
        };
        if (nextLevelDetails.bigBlind !== bigBlind && previousDetails) {
          state.games[tempTableId].toastMessages.push({
            type: TOAST_INFO,
            title: "Tourney Level Up",
            message: `Blinds are now up - ${previousDetails?.smallBlind} / ${previousDetails?.bigBlind}`,
          });
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    closeTourneyBanner: (state, action) => {
      const { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].activeTourneyBannerType = null;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    checkForTableMergeBannerAndClose: (state, action) => {
      const { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (
        tableData &&
        tableData.isTourneyGame &&
        tableData.activeTourneyBannerType ===
        TOURNEY_BANNER_MERGED_WITH_ANOTHER_TABLE
      ) {
        setTimeout(() => {
          state.games[tempTableId].activeTourneyBannerType = null;
        }, TOURNEY_TABLE_MERGE_BANNER_DELAY);
      } else if (!tableData) {
        showNoTableAvailableWarning(action);
      }
    },

    handleSitOutButtonOnDRebuyIn: (state, action) => {
      const { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        // This is to enable the i'm back button on closing rebuy in modal
        state.games[tempTableId].openRebuyInModal = false;
        state.games[tempTableId].sitOutButtonDisabled = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    updateDisableOrientationChange: (state, action) => {
      const { tempTableId, isDisabled } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].disableOrientationChange = isDisabled;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    updateUserRestrictionStatus: (state, action) => {
      const { tempTableId, status } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].restrictUserFromSitOut = status;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    reportHandHistoryIssue: (state, action) => {
      const {
        gameId,
        tempTableId,
        fraudPlayers,
        issueType,
        channel,
        comments,
        accessToken,
        a23Token,
      } = action.payload;
      const { gameDefinition, isTourneyGame } = state.games[tempTableId];

      let temp = new Date();
      let date = new Date(temp.getTime() + 330 * 60 * 1000);
      date = date.toISOString().replace("T", ",");
      date = date.replace("Z", "");
      const requestPayload = {
        reported_fraud_players: fraudPlayers,
        game_name: isTourneyGame
          ? gameDefinition.tourneyName
          : gameDefinition.tableName,
        comments: comments,
        date_posted: date,
        issue_type: issueType,
        channel: channel,
        game_type: isTourneyGame ? "ip-poker-tourney" : "ip-poker-game", //gameDefinition.gameType, NOTE: changed this to poker-game as per live change.
        game_id: isTourneyGame
          ? `${gameId}#${gameDefinition?.tourneyId}`
          : gameId,
      };
      let gameConnection =
        GameConnectionsN.getInstance().getGameConnection(tempTableId);
      gameConnection.listener.submitReportIssueDetails({
        apiURL: import.meta.env.VITE_REACT_APP_REPORT_ISSUE,
        apiPayload: requestPayload,
        accessToken: accessToken,
        a23Token: a23Token,
        tempTableId: tempTableId,
      });
    },

    handleReportIssueSuccess: (state, action) => {
      const { data, tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (data.status) {
          state.games[tempTableId].gameModal.visible = false;
          state.games[tempTableId].gameModal.type = null;
          state.games[tempTableId].toastMessages.push({
            type: TOAST_SUCCESS,
            title: "Issue Reported",
            message: data.message,
          });
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    updatePlayerSettingsConfig: (state, action) => {
      const {
        playerBasicSettings,
        playerAutoRebuyConfig,
        playerHaptics,
        bettingOptions,
        cashLobbyFilterSortConfig,
        emojis,
        throwables,
      } = action.payload;
      const { autoRebuy, playerAutoTopUpConfig } = playerAutoRebuyConfig;

      // Helper function to remap presets back to indexes
      const remapPresetsToIndexes = (presetValues) => {
        return Object.keys(presetValues).reduce((acc, key) => {
          const index = parseInt(key.replace("preset", "")) - 1; // Convert preset1 to 0, preset2 to 1, etc.
          acc[index] = presetValues[key];
          return acc;
        }, {});
      };

      // console.log(
      //   "Spruha log >>> Received Auto Buy In Data is >>> ",
      //   playerAutoRebuyConfig.autoBuyIn,
      //   playerAutoRebuyConfig.autoBuyInAmount
      // );

      state.tableSettings = {
        cashLobbyFilterSortConfig: {
          favorites: cashLobbyFilterSortConfig.favorites,
          sortBy: cashLobbyFilterSortConfig.sortBy, // 'blinds-low-high' | 'blinds-high-low' | 'players-low-high' | 'players-high-low'
          stakes: {
            low: cashLobbyFilterSortConfig.stakes.includes("low"),
            mid: cashLobbyFilterSortConfig.stakes.includes("mid"),
            high: cashLobbyFilterSortConfig.stakes.includes("high"),
          },
          hasActiveFilters: cashLobbyFilterSortConfig.hasActiveFilters,
          appliedStakes: [],
        },
        sortCardsByRank: false,
        showHandStrength: playerBasicSettings.handStrength,
        autoTableSwitch: playerBasicSettings.autoTableSwitching,
        autoMuck: playerBasicSettings.autoMuck,
        showEmojis: playerBasicSettings.emojiEnabled,
        showThrowables: playerBasicSettings.throwableEnabled,
        emojis: emojis,
        throwables: throwables,
        smartGestures: playerHaptics.smartGestures,
        BBDisplay: playerBasicSettings.displayChipsInBB,
        smartGestureOptions: {
          smartFold: playerHaptics.dragToFold,
          smartCheck: playerHaptics.doubleTapOnCheck,
        },
        sound: playerHaptics.sound,
        haptics: playerHaptics.vibrations,
        autoRebuy: autoRebuy,
        autoTopupConfig: {
          enabled: playerAutoTopUpConfig.autoTopUpenabled,
          fallsBelowAmount: playerAutoTopUpConfig.fallsBelowPercentage,
          topUpAmount: playerAutoTopUpConfig.topUpPercentage,
          fallBelowMinAmount: playerAutoTopUpConfig.fallBelowMinAmount,
          fallsBelowMaxAmount: playerAutoTopUpConfig.fallsBelowMaxAmount,
          topUpMinAmount: playerAutoTopUpConfig.topUpMinAmount,
          topUpMaxAmount: playerAutoTopUpConfig.topUpMaxAmount,
        },
        bettingOptions: {
          defaultPreflopPresetValue: bettingOptions.defaultPreflopPresetValue,
          defaultPostflopPresetValue: bettingOptions.defaultPostflopPresetValue,
          preflopPresetValues: remapPresetsToIndexes(
            bettingOptions.preflopPresetValues
          ),
          postflopPresetValues: remapPresetsToIndexes(
            bettingOptions.postflopPresetValues
          ),
        },
        autoBuyIn: {
          enabled: playerAutoRebuyConfig.autoBuyIn,
          percentage: playerAutoRebuyConfig.autoBuyInAmount,
        },
      };
      // console.log(
      //   "SPRUHA LOG >>> TABLE SETTINGS >>> ",
      //   state.tableSettings,
      //   bettingOptions
      // );
      setToLocalStorage(IS_SOUND_ENABLED, playerHaptics.sound);
      setToLocalStorage(IS_HAPTICS_EBABLED, playerHaptics.vibrations);
    },

    submitUpdatedTableSettingsConfig: (state, action) => {
      const { tableSettings } = state;
      const {
        showHandStrength,
        autoTableSwitch,
        autoMuck,
        smartGestures,
        smartGestureOptions,
        BBDisplay,
        sound,
        haptics,
        autoRebuy,
        autoTopupConfig,
        bettingOptions,
      } = tableSettings;
      const {
        enabled,
        fallsBelowAmount,
        topUpAmount,
        fallBelowMinAmount,
        fallsBelowMaxAmount,
        topUpMinAmount,
        topUpMaxAmount,
      } = autoTopupConfig;
      let loggedInPlayerDetails = state.userDetails;

      // Helper function to remap indexes to preset1, preset2, etc.
      const remapPresets = (presetValues) => {
        return Object.keys(presetValues).reduce((acc, key) => {
          acc[`preset${parseInt(key) + 1}`] = presetValues[key];
          return acc;
        }, {});
      };

      // Remap bettingOptions
      const updatedBettingOptions = {
        ...bettingOptions,
        preflopPresetValues: remapPresets(bettingOptions.preflopPresetValues),
        postflopPresetValues: remapPresets(bettingOptions.postflopPresetValues),
      };

      const requestPayload = {
        playerName: loggedInPlayerDetails.userName,
        playerBasicSettings: {
          handStrength: showHandStrength,
          autoTableSwitching: autoTableSwitch,
          displayChipsInBB: BBDisplay,
          autoMuck: autoMuck,
          emojiEnabled: true, //TODO: need to change
          throwableEnabled: true, //TODO: need to change
        },
        playerHaptics: {
          vibrations: haptics,
          sound: sound,
          smartGestures: smartGestures,
          doubleTapOnCheck: smartGestureOptions.smartCheck,
          dragToFold: smartGestureOptions.smartFold,
        },
        playerAutoRebuyConfig: {
          autoRebuy: autoRebuy,
          playerAutoTopUpConfig: {
            autoTopUpenabled: enabled,
            fallsBelowPercentage: fallsBelowAmount,
            topUpPercentage: topUpAmount,
            fallBelowMinAmount: fallBelowMinAmount,
            fallsBelowMaxAmount: fallsBelowMaxAmount,
            topUpMinAmount: topUpMinAmount,
            topUpMaxAmount: topUpMaxAmount,
          },
        },
        bettingOptions: updatedBettingOptions,
      };

      let gameConnections = GameConnectionsN.getInstance();
      let activeGameConnection = gameConnections.getGameConnection(
        state.activeGame
      );
      if (activeGameConnection && activeGameConnection.listener) {
        activeGameConnection.listener.processTableSettingsSaveRequest(
          requestPayload
        );
      }
    },

    handleTourneyStartTableCreationBasedOnActiveGames: (state, action) => {
      let tableData = state.games[state.activeGame];

      if (tableData) {
        state.games[state.activeGame].toastMessages.push({
          type: TOAST_INFO,
          title: "Tourney",
          message: action.payload.message,
        });
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleJoinWaitListAck: (state, action) => {
      const {
        tempTableId,
        playerName,
        status,
        totWaitListCount,
        playerWaitingPosition,
      } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (state.userDetails.userName === playerName) {
          if (status === 100) {
            // if the player is successfully added to waitlist using its waitist position for further flow
            state.games[tempTableId].playerWaitingPosition =
              playerWaitingPosition;
            state.games[tempTableId].totalWaitListPlayerCount =
              totWaitListCount;

            state.games[tempTableId].toastMessages.push({
              type: TOAST_SUCCESS,
              title: "Waitlisted",
              message: `You have been added to the wait list.`,
            });
          } else if (status === 111) {
            // show insufficient funds modal
            state.games[tempTableId].openInSufficientFundsModal = true;
            state.games[tempTableId].autoAction = "";
            state.games[tempTableId].playerWaitingPosition = undefined;
          }
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleWaitListFailure: (state, action) => {
      const { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].playerWaitingPosition = undefined;
        state.games[tempTableId].totalWaitListPlayerCount = undefined;

        state.games[tempTableId].autoAction = "";

        state.games[tempTableId].toastMessages.push({
          type: TOAST_ERROR,
          title: "Waitlist Failure",
          message: `Failed to join waitlist. Please try again later.`,
        });
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleRemoveFromWaitList: (state, action) => {
      const { tempTableId, playerName, status, totWaitListCount } =
        action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (state.userDetails.userName === playerName && status === 100) {
          state.games[tempTableId].totalWaitListPlayerCount = totWaitListCount;

          state.games[tempTableId].playerWaitingPosition = undefined;

          state.games[tempTableId].autoAction = "";

          state.games[tempTableId].toastMessages.push({
            type: TOAST_INFO,
            title: "Waitlist",
            message: `You have been removed from the wait list.`,
          });
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleJoinOrRemoveFromWaitListBroadcast: (state, action) => {
      const { tempTableId, playerName, status, totWaitListCount } =
        action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        if (status === 100 && state.userDetails.userName === playerName) {
          state.games[tempTableId].totalWaitListPlayerCount = totWaitListCount;
          if (totWaitListCount === 1) {
            state.games[tempTableId].playerWaitingPosition = totWaitListCount;
          }
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    updateComplianceBlocked: (state, action) => {
      const { tempTableId, isComplainceBlocked } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].isComplainceBlocked = isComplainceBlocked;
      } else {
        showNoTableAvailableWarning(action);
      }
    },
    handleStartPrivateTableAck: (state, action) => {
      const { tempTableId } = action.payload;
      state.games[tempTableId].privateTable.hideStartGameButton = true;
    },

    handleConcludePrivateTable: (state, action) => {
      let {
        tempTableId,
        isPrivateTable,
        status,
        isPrivateTableHostTerminated,
      } = action.payload;
      let tableData = state.games[tempTableId];
      if (tableData) {
        processCleanTable(state, tempTableId);
        state.games[tempTableId].gameModal.type = END_PRIVATE_TABLE;
        state.games[tempTableId].gameModal.visible = true;
        state.games[tempTableId].gameModal.config = {
          message: isPrivateTableHostTerminated
            ? "Host terminated this table"
            : "This table has been concluded",
          title: isPrivateTableHostTerminated
            ? "Table Terminated"
            : "Table Concluded",
        };
        state.games[tempTableId].gameConnectionStatus = null;
        state.games[tempTableId].showMaintenancePopup = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleAnnouncementPrivateTableAck: (state, action) => {
      const { tempTableId } = action.payload;
      if (
        state.games[tempTableId].gameModal.type ===
        PRIVATE_TABLE_ADD_ANNOUNCEMENT
      ) {
        state.games[tempTableId].gameModal.type = null;
        state.games[tempTableId].gameModal.visible = false;
        state.games[tempTableId].gameModal.config = {};
      }
    },

    updateCardSortingByRank: (state, action) => {
      state.tableSettings.sortCardsByRank = !state.tableSettings.sortCardsByRank;
    },

    handleAnnouncementBroadcastPrivateTable: (state, action) => {
      const { tempTableId, hostName, message } = action.payload;
      if (hostName !== state.userDetails.userName) {
        state.games[tempTableId].gameModal.type =
          PRIVATE_TABLE_ADD_ANNOUNCEMENT;
        state.games[tempTableId].gameModal.visible = true;
        state.games[tempTableId].gameModal.config = {
          announcementMessage: message,
          autoCloseDuration:
            PRIVATE_TABLE_ANNOUNCEMENT_BROADCAST_CLOSE_DURATION,
        };
      }
    },

    handleTerminatePrivateTableAck: (state, action) => {
      const { tempTableId, status } = action.payload;
      if (status === TERMINATE_PRIVATE_TABLE_REQUEST_PROCESSED) {
        state.games[tempTableId].toastMessages.push({
          type: TOAST_INFO,
          title: "Private Table - Game Over",
          message: "Game will be terminated at the end of this hand!",
        });
      } else if (status === TERMINATE_PRIVATE_TABLE_REQUEST_ALREADY_SENT) {
        state.games[tempTableId].toastMessages.push({
          type: TOAST_INFO,
          title: "Private Table",
          message: "Terminate table request already sent.",
        });
      }
    },

    handleTerminatePrivateTableFailure: (state, action) => {
      const { tempTableId } = action.payload;
      state.games[tempTableId].privateTable.toastMessages.push({
        type: TOAST_ERROR,
        title: "Private Table - Error",
        message: "Failed to terminate table.",
      });
    },

    removePrivateTableRunningGameDef: (state, action) => {
      const { tempTableId } = action.payload;
      if (state.games[tempTableId].privateTable.isPrivateTable) {
        state.removePrivateTableGameDefId =
          state.games[tempTableId].gameDefinition.gameDefId;
      }
    },
    closeHostControlSlider: (state, action) => {
      const { tempTableId } = action.payload;
      state.games[tempTableId].privateTable.openHostControlSlider = false;
    },
    handleFavToggleClick: (state, action) => {
      const { status, tempTableId } = action.payload;
      state.games[tempTableId].clickedFavToggle = status;
    },
    handleWatchTimerData: (state, action) => {
      const {
        tempTableId,
        playerName,
        tableId,
        statusCode,
        timeLeft,
        endTime,
        socketClosed,
      } = action.payload;
      state.games[tempTableId].watchTable.timer = timeLeft;
      state.games[tempTableId].watchTable.status = statusCode;
      if (
        statusCode === WAITLIST_ACCEPTED ||
        statusCode === TIMER_REMOVED ||
        timeLeft < 0
      ) {
        state.games[tempTableId].watchTable.hideTimer = true;
      }
      if (
        statusCode === WAITLIST_REJECTED ||
        (statusCode === TIME_RUNNING && timeLeft > 0)
      ) {
        state.games[tempTableId].watchTable.hideTimer = false;
      }
      if (socketClosed) {
        state.games[tempTableId].watchTable.closeSocket = true;
      }
      const timerWorker = getTimerWorkerInstance();

      console.log("YASHWANTH timeLeft:", timeLeft);
      if (timeLeft > 0) {
        console.log(
          "YASHWANTH Setting watch timer for table: ",
          tempTableId,
          " with time left: ",
          timeLeft
        );
        timerWorker.postMessage({
          type: "subscribe",
          timerId: "watch-timer-" + tempTableId,
          timerType: "countdown",
          total: timeLeft,
          callbackInterval: 1000,
        });
      } else {
        timerWorker.postMessage({
          type: "unsubscribe",
          timerId: "watch-timer-" + tempTableId,
        });
      }
    },
    handleThrowablesOnTable: (state, action) => {
      const {
        tempTableId,
        fromPlayerName,
        toPlayerName,
        throwableId,
        statusCode,
      } = action.payload;
      const tableData = state.games[tempTableId];
      if (!tableData) return;

      let sourceUserPosition = null;
      let targetUserPosition = null;

      if (statusCode === 200) {
        for (const player of tableData.playerData) {
          if (player.userName === fromPlayerName) {
            sourceUserPosition = player.position;
          } else if (player.userName === toPlayerName) {
            targetUserPosition = player.position;
          }
          if (sourceUserPosition && targetUserPosition) break;
        }

        if (!sourceUserPosition || !targetUserPosition) return;

        const sourcePlayerPosition = tableData.playerPositions.find(
          (p) => p.position === sourceUserPosition
        );

        const targetPlayerPosition = tableData.playerPositions.find(
          (p) => p.position === targetUserPosition
        );

        if (!sourcePlayerPosition || !targetPlayerPosition) return;

        tableData.throwables.push({
          uid: generateUniqueId(),
          throwableId,
          sourceCoordinates: {
            x: sourcePlayerPosition.left,
            y: sourcePlayerPosition.top,
          },
          targetCoordinates: {
            x: targetPlayerPosition.left,
            y: targetPlayerPosition.top,
          },
          duration: 1,
          loop: false,
        });
      }
    },
    handlePlayerEmojiOnTable: (state, action) => {
      const { tempTableId, playerName, emojiId, statusCode } = action.payload;
      const tableData = state.games[tempTableId];
      if (
        !tableData ||
        statusCode !== 200 ||
        !state.tableSettings?.showEmojis
      ) {
        console.log("NOT EXECUTING EMOJIS");
        return;
      }
      tableData.gameModal.visible = false;
      tableData.gameModal.type = null;
      tableData.gameModal.data = null;
      tableData.gameModal.config = null;
      const userPosition = tableData.playerData.find(
        (player) => player.userName === playerName
      )?.position;

      if (
        userPosition === undefined ||
        userPosition === null ||
        userPosition < 0
      ) {
        return;
      }

      const playerCoordinates = tableData.playerPositions.find(
        (pos) => pos.position === userPosition
      );

      if (!playerCoordinates) return;
      //NOTE: Here we are reusing common logic of throwables even for self expression so here source and target coords will be same.
      tableData.throwables.push({
        uid: generateUniqueId(),
        throwableId: emojiId,
        sourceCoordinates: {
          x: playerCoordinates.left,
          y: playerCoordinates.top + EMOJI_SIZE / 3,
        },
        targetCoordinates: {
          x: playerCoordinates.left,
          y: playerCoordinates.top + EMOJI_SIZE / 3,
        },
        duration: 0,
        loop: false,
      });
    },
    remvoeThrowableOntable: (state, action) => {
      const { tempTableId, uid } = action.payload;
      const tableData = state.games[tempTableId];
      if (!tableData) return;
      tableData.throwables = tableData.throwables.filter(
        (throwable) => throwable.uid !== uid
      );
    },
    handleSendEmojiToServer: (state, action) => {
      const { tempTableId } = action.payload;
      const tableData = state.games[tempTableId];

      if (tableData) {
        let gameConnection =
          GameConnectionsN.getInstance().getGameConnection(tempTableId);
        gameConnection.listener.sendEmojiRequest({
          ...action.payload,
          tableId: tableData.tableId,
        });
        tableData.gameModal.visible = false;
        tableData.gameModal.type = null;
        tableData.gameModal.data = null;
        tableData.gameModal.config = null;
      } else {
        showNoTableAvailableWarning(action);
      }
    },
    handleEmojiFailure: (state, action) => {
      const { tempTableId, statusCode } = action.payload;
      let tableData = state.games[tempTableId];

      if (tableData) {
        state.games[tempTableId].toastMessages.push({
          type: TOAST_ERROR,
          message:
            statusCode === 104
              ? `Oops! Your emoji-meter hit zero. Try again after sometime`
              : `Failed to send emoji, Try after sometime`,
          title: "Emoji Failed",
        });
        tableData.gameModal.visible = false;
        tableData.gameModal.type = null;
        tableData.gameModal.data = null;
        tableData.gameModal.config = null;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleDealStartedData: (state, action) => {
      const { tempTableId, tourneyId } = action.payload;
      let tableData = state.games[tempTableId];
      if (tableData) {
        state.games[tempTableId].dealObject.dealStarted = true;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handlePlayerDealVoteRequest: (state, action) => {
      const { tempTableId } = action.payload;
      state.games[tempTableId].dealObject.pendingAck = true;
    },

    handleDealVoteAck: (state, action) => {
      const { tempTableId, status, playerName, tourneyId } = action.payload;
      let tableData = state.games[tempTableId];
      tableData.dealObject.pendingAck = false;

      if (tableData) {
        if (status === DEAL_OPTED_IN) {
          tableData.dealObject.dealOpted = true;
          tableData.toastMessages.push({
            type: TOAST_SUCCESS,
            message: `You have accepted the deal`,
          });
        } else if (status === DEAL_OPTED_OUT) {
          tableData.dealObject.dealOpted = false;
          tableData.toastMessages.push({
            type: TOAST_INFO,
            message: `You have rejected the deal`,
          });
        } else if (status === DEAL_PLAYER_NOT_SEATED) {
          tableData.dealObject.dealOpted = false;
          tableData.toastMessages.push({
            type: TOAST_ERROR,
            message: `You are not seated on the table`,
          });
        } else if (status === DEAL_INVALID_REQUEST_DATA) {
          tableData.dealObject.dealOpted = false;
          tableData.toastMessages.push({
            type: TOAST_ERROR,
            message: `Failed to process your request.Try Again.`,
          });
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleDealStatusData: (state, action) => {
      const {
        tempTableId,
        tourneyId,
        optedCount,
        currentPlayerCount,
        playersList,
      } = action.payload;
      let tableData = state.games[tempTableId];
      if (tableData) {
        tableData.dealObject.currentPlayerCount = currentPlayerCount;
        tableData.dealObject.optedCount = optedCount;
        tableData.dealObject.dealOptedPlayers = playersList;
        tableData.dealObject.dealOpted = playersList.includes(
          state.userDetails.userName
        );
        if (tableData.showDealICMPayoutDistribution) {
          // If deal ICM payout distribution is already shown, and player is in disconnection, when connected again if the old deal is ended, then we need to reset the deal object
          tableData.showDealICMPayoutDistribution = false;
          tableData.dealICMObject = {
            dealICMData: {},
            dealICMRunTime: 0,
            pendingAck: false,
            winnersDetails: {},
          };
        }
        tableData.dealObject.dealStarted = true;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleDealICMData: (state, action) => {
      const { tempTableId, ICM, runTime } = action.payload;
      let tableData = state.games[tempTableId];
      if (tableData) {
        // Sorting ICM Data based on chipStack(descending order)
        // Step 1: Convert to entries
        const sortedEntries = Object.entries(ICM).sort(
          ([, a], [, b]) => b.chipStack - a.chipStack
        );
        // Step 2 (optional): Convert back to object
        const ICMData = Object.fromEntries(sortedEntries);

        tableData.dealICMObject.dealICMRunTime = runTime;
        tableData.dealICMObject.dealICMData = ICMData;
        tableData.showDealICMPayoutDistribution = true;
        processCleanTable(state, tempTableId); // cleaning table as actions and cards are visible on the gametable during deal
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleDealICMStatusData: (state, action) => {
      const { tempTableId, timeLeft, votes } = action.payload;
      let tableData = state.games[tempTableId];
      let isWatchPlayer = state.games[tempTableId].watchPlayer;
      if (tableData) {
        tableData.dealICMObject.dealICMRunTime = timeLeft;
        if (isWatchPlayer) {
          // tableData.activeTourneyBannerType = TOURNEY_IN_DEAL;
          processCreateTourneyBanner(state, {
            tempTableId: tempTableId,
            type: TOURNEY_IN_DEAL,
            tourneyBannerData: {
              endTime: timeLeft,
            },
            autoClose: false,
          });
        } else {
          for (const [playerName, status] of Object.entries(votes)) {
            if (tableData.dealICMObject.dealICMData[playerName]) {
              tableData.dealICMObject.dealICMData[playerName] = {
                ...tableData.dealICMObject.dealICMData[playerName],
                playerICMStatus: status,
              };
            } else {
              tableData.dealICMObject.dealICMData[playerName] = {
                ...tableData.dealICMObject.dealICMData[playerName],
                playerICMStatus: status,
              };
            }
          }
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handlePlayerICMDealVoteRequest: (state, action) => {
      const { tempTableId, status } = action.payload;
      state.games[tempTableId].dealICMObject.pendingAck = true;
      let dataObject = {
        playerName: state.userDetails.userName,
        tableId: state.games[tempTableId].tableId,
        tourneyId: state.games[tempTableId].gameDefinition.tourneyId,
        vote: status,
      };
      const gameConnection =
        GameConnectionsN.getInstance().getGameConnection(tempTableId);
      gameConnection.listener.processPlayerDealICMVoteRequest(dataObject);
    },

    handleICMVoteAckData: (state, action) => {
      const { tempTableId, status, playerName, tourneyId } = action.payload;
      state.games[tempTableId].dealICMObject.pendingAck = false;
      let tableData = state.games[tempTableId];
      if (tableData) {
        switch (status) {
          case DEAL_OPTED_IN:
            tableData.dealICMObject.dealICMVoted = true;
            tableData.toastMessages.push({
              type: TOAST_SUCCESS,
              message: `You have accepted the deal`,
            });
            break;
          case DEAL_OPTED_OUT:
            tableData.dealICMObject.dealICMVoted = true;
            tableData.toastMessages.push({
              type: TOAST_INFO,
              message: `You have rejected the deal`,
            });
            break;
          case DEAL_PLAYER_NOT_SEATED:
            tableData.dealICMObject.dealICMVoted = false;
            tableData.toastMessages.push({
              type: TOAST_ERROR,
              message: `You are not seated on the table`,
            });
            break;
          case DEAL_INVALID_REQUEST_DATA:
            tableData.dealICMObject.dealICMVoted = false;
            tableData.toastMessages.push({
              type: TOAST_ERROR,
              message: `Invalid ICM deal request data`,
            });
            return;
          case DEAL_MAKING_TIMER_NOT_FOUND:
            tableData.dealICMObject.dealICMVoted = false;
            tableData.toastMessages.push({
              type: TOAST_ERROR,
              message: `No active deal making at the moment`,
            });
            return;
          case DEAL_ALREADY_OPTED_IN:
            tableData.dealICMObject.dealICMVoted = true;
            tableData.toastMessages.push({
              type: TOAST_ERROR,
              message: `You have already opted in for the deal`,
            });
            return;
          case DEAL_ALREADY_OPTED_OUT:
            tableData.dealICMObject.dealICMVoted = false;
            tableData.toastMessages.push({
              type: TOAST_ERROR,
              message: `You have already opted out for the deal`,
            });
            return;
          case NOT_DEAL_PARTICIPANT:
            tableData.toastMessages.push({
              type: TOAST_ERROR,
              message: `You are not a participant of the deal`,
            });
            return;
          default:
            tableData.dealICMObject.dealICMVoted = false;
            tableData.toastMessages.push({
              type: TOAST_ERROR,
              message: `Invalid deal vote request`,
            });
            return;
        }
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleDealICMFailData: (state, action) => {
      const { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];
      if (tableData) {
        tableData.showDealICMPayoutDistribution = false;
        // tableData.activeTourneyBannerType = TOURNEY_DEAL_UNSUCCESSFUL;

        processCreateTourneyBanner(state, {
          tempTableId: tempTableId,
          type: TOURNEY_DEAL_UNSUCCESSFUL,
          tourneyBannerData: {},
          autoClose: true,
        });

        tableData.dealObject = {
          dealStarted: false,
          dealOpted: false,
          pendingAck: false,
          optedCount: 0,
          currentPlayerCount: 0,
          dealOptedPlayers: [],
        };
        tableData.dealICMObject = {
          dealICMData: {},
          dealICMRunTime: 0,
          pendingAck: false,
          winnersDetails: {},
        };
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    handleDealICMSuccessData: (state, action) => {
      const { tempTableId, winnersDetails } = action.payload;
      let tableData = state.games[tempTableId];
      if (tableData) {
        // sorting winner details Obj based on winning amount
        const sortobj = Object.entries(winnersDetails).sort(
          ([, a], [, b]) => b.win - a.win
        );
        const sortedWinnerDetails = Object.fromEntries(sortobj);
        tableData.showDealICMPayoutDistribution = false;
        state.games[tempTableId].gameModal.type = DEAL_MAKING_DONE;
        state.games[tempTableId].gameModal.visible = true;
        state.games[tempTableId].tourneyBanners = [];
        state.games[tempTableId].tourneyGameCompleted = true;
        state.games[tempTableId].showDealConclusionPopup = true;
        // tableData.activeTourneyBannerType = TOURNEY_DEAL_SUCCESSFUL;
        tableData.dealICMObject.winnersDetails = sortedWinnerDetails;
      } else {
        showNoTableAvailableWarning(action);
      }
    },

    closeDealMakingICMPayoutPopup: (state, action) => {
      const { tempTableId } = action.payload;
      let tableData = state.games[tempTableId];
      if (tableData) {
        tableData.showDealICMPayoutDistribution = false;
      } else {
        showNoTableAvailableWarning(action);
      }
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchMatchMakingDetails.fulfilled, (state, action) => {
        const { tempTableId, data, status } = action.payload;
        sendFaroLog({
          requestType: "MATCH_MAKING_FULFILLED",
          responseData: data,
          status: status,
        });
        let tableData = state.games[tempTableId];
        if (tableData) {
          const {
            gameEndpoint,
            tableIdGameIdEntity,
            status,
            amountToAdd,
            awsAlbCookie,
          } = data;
          const { tableId, gameId } = tableIdGameIdEntity;
          //fulfilled response time logging - match making
          let date = new Date();
          let logsArray = tableData.apiMatchMakingTimeLogsArray;
          let logObject = logsArray[logsArray.length - 1]; //length zero is not considered as ideally it should be atleast one

          //no balance -- show add cash alert
          //200 -- success, received all values required to establish game socket connection
          //201 -- low balance
          //202 -- account error (like blocked or contact A23 support)
          //203 -- match making server error (check to confirm retry)

          if (status === 200) {
            tableData.gameConnectionStatus = MATCH_MAKING_API_RESPONSE_SUCCESS;

            const { hostname, port, protocol } = new URL(gameEndpoint);

            tableData.tableId = tableId;
            tableData.gameId = gameId;
            tableData.serverAddress = hostname;
            tableData.serverPort = port;
            tableData.connectionType = protocol.replace(":", ""); //ws or wss
            tableData.awsalbcookie = awsAlbCookie;
            window.document.cookie = `AWSALB=${awsAlbCookie};domain=${hostname};path=/`;
          } else {
            tableData.gameConnectionStatus = MATCH_MAKING_API_REQUEST_REJECTED;
            tableData.startConnectionTimeout = true;
          }

          logObject[
            tableData.gameConnectionStatus === MATCH_MAKING_API_RESPONSE_SUCCESS
              ? RESPONSE_KEY_NAME
              : REJECTED_KEY_NAME
          ] = `Date: ${date.getDate()}:${date.getMonth()}:${date.getFullYear()}, Time: ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()}`;
          logObject[RESPONSE_CODE_KEY_NAME] = status;
        } else {
          showNoTableAvailableWarning();
        }
      })
      .addCase(fetchMatchMakingDetails.rejected, (state, action) => {
        const { tempTableId } = action.payload;
        sendFaroLog({
          requestType: "MATCH_MAKING_REJECTED",
        });
        //state = current(state);
        let tableData = state.games[tempTableId];

        if (tableData) {
          tableData.gameConnectionStatus = MATCH_MAKING_API_REQUEST_REJECTED;
          tableData.startConnectionTimeout = true;

          //rejected response time logging - match making
          let date = new Date();
          let logsArray = tableData.apiMatchMakingTimeLogsArray;
          let logObject = logsArray[logsArray.length - 1]; //length zero is not considered as ideally it should be atleast one

          logObject[
            REJECTED_KEY_NAME
          ] = `Date: ${date.getDate()}:${date.getMonth()}:${date.getFullYear()}, Time: ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()}`;
        } else {
          showNoTableAvailableWarning();
        }
      })
      .addCase(fetchCheckGameDetails.fulfilled, (state, action) => {
        const { tempTableId, data } = action.payload;
        sendFaroLog({
          requestType: "CHECK_GAME_FULFILLED",
          responseData: data,
        });
        const { nodeIP, gameId, status, tableID, awsalbcookie } = data;

        let tableData = state.games[tempTableId];
        if (tableData) {
          let date = new Date();
          let logsArray = tableData.apiCheckGameTimeLogsArray;
          let logObject = logsArray[logsArray.length - 1]; //length zero is not considered as ideally it should be atleast one

          //200 -- success, received all values required to establish game socket connection

          if (status === 200) {
            tableData.gameConnectionStatus = CHECK_GAME_API_RESPONSE_SUCCESS;

            const { hostname, port, protocol } = new URL(nodeIP);
            tableData.serverAddress = hostname;
            tableData.serverPort = port;
            tableData.connectionType = protocol.replace(":", ""); //ws or wss
            tableData.gameId = gameId;
            tableData.tableId = tableID;
            tableData.awsalbcookie = awsalbcookie;

            window.document.cookie = `AWSALB=${awsalbcookie};domain=${hostname};path=/`;
          } else {
            tableData.gameConnectionStatus = CHECK_GAME_API_REQUEST_REJECTED;
            tableData.startConnectionTimeout = true;
          }

          logObject[
            tableData.gameConnectionStatus === CHECK_GAME_API_RESPONSE_SUCCESS
              ? RESPONSE_KEY_NAME
              : REJECTED_KEY_NAME
          ] = `Date: ${date.getDate()}:${date.getMonth()}:${date.getFullYear()}, Time: ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()}`;
          logObject[RESPONSE_CODE_KEY_NAME] = status;
        } else {
          showNoTableAvailableWarning(action);
        }
      })
      .addCase(fetchCheckGameDetails.rejected, (state, action) => {
        let tempTableId = action.payload;
        sendFaroLog({
          requestType: "CHECK_GAME_REJECTED",
        });
        let tableData = state.games[tempTableId];

        if (tableData) {
          tableData.gameConnectionStatus = CHECK_GAME_API_REQUEST_REJECTED;
          tableData.startConnectionTimeout = true;

          //rejected response time logging - check game
          let date = new Date();
          let logsArray = tableData.apiCheckGameTimeLogsArray;
          let logObject = logsArray[logsArray.length - 1]; //length zero is not considered as ideally it should be atleast one

          logObject = logsArray[logsArray.length - 1]; //length zero is not considered as ideally it should be atleast one
          logObject[
            REJECTED_KEY_NAME
          ] = `Date: ${date.getDate()}:${date.getMonth()}:${date.getFullYear()}, Time: ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()}`;
        } else {
          showNoTableAvailableWarning(action);
        }
      });
  },
});

export const {
  setPlayerRemainingTime,
  setTableTheme,
  setTableBackground,
  setCardBack,
  setCardDeck,
  setCardSize,
  setBuyInValueForPlayerPosition,
  toggleHandStrength,
  toggleAutoTableSwitch,
  toggleDisplayInBB,
  toggleSmartGestures,
  toggleSmartFold,
  toggleSmartCheck,
  toggleAutoMuck,
  toggleSound,
  toggleHaptics,
  updateGameTableBoundingRect,
  updatePlayerPositionsOnTable,
  changeTableOrientation,
  updateActiveGame,
  acknowledgePlayerMovedToCenter,
  watchAllGameTables,
  hideGameTable,
  showGameTable,
  exitGameTable,
  joinGameTable,
  leaveTableSeat,
  toggleSitOutAction,
  sitInAction,
  sitOutAction,
  resizingTable,
  setResizingToComplete,
  updatePositionsArranged,
  hidePlayerPositions,
  processPlayersDataOnTable,
  processLeaveSeatAck,
  createTableData,
  resetTableData,
  updateGameConnectionStatusN,
  closeGameWindow,
  startGameListenerN,
  processMatchMakingResponse,
  processCheckGameResponse,
  updateGameConnectionFailureProtocolStatus,
  requestReserveSeat,
  requestRemoveReserveSeat,
  setRemoveReserveSeatForPlayer,
  handleGameJoinRequest,
  handlePlayerJoinBroadcast,
  handleReserveSeatBroadcast,
  handleRemoveReserveSeatBroadcast,
  handleStartGame,
  handlePlayerAutoActions,
  handleTableTimerChangeRequest,
  handleStartGameTimer,
  disableStartGameTimer,
  setToastMessage,
  removeToastMessage,
  handleTurnChange,
  handleRevealCards,
  handleRITRevealCards,
  handleRITRequest,
  handleRITReject,
  handleRITAccept,
  setRITRequest,
  processLeaveSeatFailure,
  toggleCallAction,
  toggleCheckAction,
  toggleRaiseAction,
  toggleFoldAction,
  toggleAutoCallAction,
  toggleAutoCheckAction,
  toggleAutoFoldAction,
  handleCallActionAck,
  handleCheckActionAck,
  handleFoldActionAck,
  handleRaiseActionAck,
  handleAutoCallActionAck,
  handleAutoCheckActionAck,
  handleAutoFoldActionAck,
  toggleAutoCallAnyAction,
  toggleAutoCheckFoldAction,
  handleAutoCallAnyActionAck,
  handleAutoCheckFoldActionAck,
  updateDisableGameActions,
  removePlayerFromTable,
  closeFailedGameTable,
  deleteGameTable,
  handleJoinFailureAction,
  handleCallActionBroadcast,
  handleCheckActionBroadcast,
  handleFoldActionBroadcast,
  handleRaiseActionBroadcast,
  handleRepaintPotAmounts,
  handlePotWinner,
  handlePrizePotAmount,
  processReconnectionAck,
  updateWaitingForBB,
  handleRankDetails,
  updateHandHistory,
  updateTableStats,
  setHandHistoryLoading,
  openHandHistoryRequest,
  requestHandHistory,
  syncUpTableTimers,
  handleRevealOtherPlayerCards,
  handleShowOtherPlayerCards,
  handleResult,
  sitOutBroadcastAction,
  sitInBroadcastAction,
  handleCleanTable,
  processPlayersDataOnTableForAlreadyRunningGame,
  sitOutFailAction,
  sitInFailAction,
  sitOutCancelAction,
  processLeaveSeatAckFromSitOut,
  leaveSeatBroadcastAction,
  handleRSeatBroadcast,
  handlePlayerExtraTime,
  handlePlayerExtraTimeLeft,
  initiateNextGameStartRequest,
  handleCloseFailure,
  handleAutoRebuySuccess,
  handleAutoRebuyBroadcast,
  handleAutoRebuyFailure,
  handleRebuyIn,
  handleDRebuyIn,
  handleRebuyFailure,
  handleRebuySuccessAck,
  handleRebuySuccessBroadcast,
  updateReleaseToFoldStatus,
  updateInSufficientFundsModalOpenStatus,
  initiateTopupRequest,
  handleTopupSuccessAck,
  handleTopupBroadcast,
  handleTopupFailure,
  handleTopupCancel,
  updateTopupModalOpenStatus,
  disableMultitableSwipe,
  enableMultitableSwipe,
  checkPlayerIsAvailableInSeats,
  handleRefreshProtocolData,
  updatePlayerDetails,
  handleReloginFailure,
  handleNextGameTimer,
  handlePreSelectedAutoAction,
  updateAllInAnimationFlag,
  processRabbitHuntingDetails,
  toggleAutoRebuy,
  toggleAutoBuyIn,
  setAutoBuyInPercentage,
  openLocalGameModal,
  closeLocalGameModal,
  closeInternetDisconnectionGameModal,
  handleTourneyPrize,
  handleSitOutButtonOnDRebuyIn,
  handleBlindsUpDetails,
  handleTourneyBreakBroadcast,
  handleTourneyAutoPlayAcknowledgement,
  handleTourneyNextLevelUp,
  updateUserAutoActionPreference,
  closeTourneyBanner,
  updateAutoTableSwitchQueue,
  handlePlayerDisconnectionTime,
  updateDisableOrientationChange,
  handleTourneyEliminate,
  updateUserRestrictionStatus,
  clearHandHistoryIndex,
  reportHandHistoryIssue,
  handleReportIssueSuccess,
  updatePlayerSettingsConfig,
  submitUpdatedTableSettingsConfig,
  toggleAutoTopup,
  handleAutoTopupFallsBelowSliderChange,
  handleAutoTopupSliderChange,
  processPlayerStatsOnDemand,
  processPlayerStatsData,
  setShownCards,
  toggleShowAllCards,
  processPlayerStatsOnDemandFailure,
  processSavePlayerStatsResponse,
  updateAmountToAdd,
  showInsufficientBalance,
  hideInsufficientBalance,
  updateGameDefinitionId,
  updateGameApplicationVisibility,
  handlersTourneyRebuyIn,
  submitTourneyRebuyRequest,
  handleTourneyRebuyAck,
  processTourneyRebuyCancle,
  handleTourneyRebuyCancle,
  handleTourneyRebuyBroadcast,
  handleTourneyRebuyFailure,
  handleTourneyStartTableCreationBasedOnActiveGames,
  processAutoTableSwitch,
  processReserveFailure,
  requestTourneyAddOnTopup,
  handleTourneyAddonAck,
  handleMaintenancePopup,
  closeRebuyIn,
  handleTourneyAddonFailureAck,
  handleRequestTourneyRankingLeaderboardDetails,
  handleTourneyRankingLeaderBoard,
  cleanUpTableObservers,
  handleTourneyPlayerRankDetails,
  handleTourneyAddOn,
  handleOpenTourneyAddOnPopup,
  closeTourneyAddOnPopup,
  handleTourneyTableSwitching,
  handleTourneyNodeSwitch,
  handleTourneyBreakEnd,
  handleTourneyRebuyEnded,
  handleJoinWaitListAck,
  handleRemoveFromWaitList,
  handleJoinOrRemoveFromWaitListBroadcast,
  handleWaitListFailure,
  processPlayerConfigAck,
  clearToastMessages,
  handleTourneyWatchPlayerAddOn,
  handleTourneyPlayerInTheMoneyDetails,
  closeExistingTourneyGameTable,
  handleTourneyWaitingForMerging,
  checkForTableMergeBannerAndClose,
  updateWinningPotDisplay,
  setPreflopPresetValues,
  setPostflopPresetValues,
  setDefaultPreflopPresetValue,
  setDefaultPostflopPresetValue,
  setHappyHoursInfoLoading,
  processHappyHoursInfo,
  processHappyHoursInfoFailure,
  updateGameDefinition,
  setPlayerAvatar,
  handleStartPrivateTableAck,
  handleConcludePrivateTable,
  handleAnnouncementPrivateTableAck,
  handleAnnouncementBroadcastPrivateTable,
  updateCardSortingByRank,
  handleTerminatePrivateTableAck,
  handleTerminatePrivateTableFailure,
  removePrivateTableRunningGameDef,
  privateTableHostConnectFailure,
  enableRIT,
  toggleRIT,
  updateComplianceBlocked,
  closeHostControlSlider,
  handleTourneyBountyCreditDetails,
  handleFavToggleClick,
  handleTourneyBubbleBroadcast,
  handleWatchTimerData,
  handleThrowablesOnTable,
  handlePlayerEmojiOnTable,
  remvoeThrowableOntable,
  handleSendEmojiToServer,
  handleEmojiFailure,
  handleShowEomjiToggle,
  handleShowThrowableToggle,
  handleDealStartedData,
  handlePlayerDealVoteRequest,
  handleDealVoteAck,
  handleDealStatusData,
  handleDealICMData,
  handleDealICMStatusData,
  handlePlayerICMDealVoteRequest,
  handleICMVoteAckData,
  handleDealICMFailData,
  handleDealICMSuccessData,
  closeDealMakingICMPayoutPopup,
} = gameTableSlice.actions;

export default gameTableSlice.reducer;
